import moment from "moment";
import React, { Suspense, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Link } from "react-router-dom";
import { getAccount, getUnlockLORAConsumer, getAllMapDataInGSM, getAllMeterTotalGSM, getAllModemTotalGSM, getAreaById, getCircleById, getCountStatusByGa, getDivisionById, getGaById, getGSMRSSIInDeshboardAllCountByStatus, getGSMTotalCountByTS, getmodemFirmwarTotalGSM, getmodemServiceProviderTotalGSM, getRolesById, getSubdevisionById, getTagsWiseConsumerData, gsm_instantaneous_day_wise_graph_details, onGetConsumerDetailsByColumn, onGetConsumerDetailsByColumnBetween, onGetConsumerIncolumeName, getmodemMeterConnectivityTotalGSM, getmodemConnectivityTotalGSM, getGSM_BANDTotalGSM, getAllGSMEventChartByDate, getAllGSMMonthlyChartByDate, GetInstallationDateWiseGraphData, getAllGSMChartByDateSlection, getStartAndEndDateByTable, getIPVTotalINGSM, GetInstallationDateWiseGraphDataBySelectedDate, getAllGSMMonthlyChartBySelectedDate, getAllGSMEventChartBySelectedDate, getProfilNameByAccountId, getHeatbeatStatusWiseCountInGroupDashboard, getAPMTotalGSM, getBateeryPercentageAllCountByStatus, getLoraTotalCountByTS, getLoraCountStatusByGa, getHeatbeatStatusWiseCountInLoraGroupDashboard, getLoraAllMeterTotalGSM, getLoraAllModemTotalGSM, getmodemFirmwarTotalLORA, getLoraBateeryPercentageAllCountByStatus, getLoraRSSIInDeshboardAllCountByStatus, getLoraLDR, getLoraTagsWiseConsumerData, GetLoraInstallationDateWiseGraphData, GetLoraInstallationDateWiseGraphDataBySelectedDate, getLorawanSF, getAllLorawanChartByDate, onGetLoraConsumerDetailsByColumn, onGetLoraConsumerDetailsByColumnBetween, lora_instantaneous_day_wise_graph_details, onGetLoraConsumerIncolumeName, getAllLoraChartByDateSlection, getLoraSNRAllCountByStatus, getAllMapDataInLorawan, getAllCategoryTableData, getAllMechanicalMeterTotalLora, getLoraCustomDashboadList, UpdateLoraDashboardAddCustomCard, UserDashboardCardFilterStore, getLoraGeneretDiagnosticReport, GetLoraStatusUndermaintainaceGraphData } from "../../../Commoncomponet/Utils";
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker,
	InfoWindow
} from "react-google-maps"
import mapicon from '../../../assets/img/triangle-green.svg'
import mapRedicon from '../../../assets/img/triangle-red.svg'
import { red } from "@mui/material/colors";
import { padding } from "@mui/system";
import { DatePicker, Modal, Popover, Space, Spin, TreeSelect } from "antd";
import { Modal as BootstrapModal } from 'react-bootstrap';
import '../Dashboard.css'
import Select from 'react-select';
import { BootstrapTooltip, exportCSVFile, exportExcelDownload } from "../../../Commoncomponet/common";
import loaderGif from '../../../assets/img/loading_chart.gif'
import jQuery from 'jquery'
import { useRef } from 'react';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Filler,
	Legend,
	Decimation, TimeScale
} from 'chart.js';
import $ from 'jquery'
import { Bar, getElementsAtEvent, getElementAtEvent, getDatasetAtEvent, Line } from 'react-chartjs-2';
import zoomPlugin from 'chartjs-plugin-zoom';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useMemo } from "react";
import html2canvas from "html2canvas";
import makeAnimated from 'react-select/animated';
import { Info } from "react-feather";
import Lora_meter_dashboard from "./Lora_meter_dashboard";
import signal1 from '../../../assets/img/onesignal.png'
import signal2 from '../../../assets/img/secondsignal.png'
import signal3 from '../../../assets/img/signal3.png'
import signal4 from '../../../assets/img/signal4.png'
import signal5 from '../../../assets/img/signal5.png'
import { toast } from "react-toastify";
import chroma from "chroma-js";
import exports from '../../../assets/img/export.png'
import card_json from './Lora_Card.json'
import swal from 'sweetalert2';
import MultiInput from "../../../Commoncomponet/MultiInput/MultiInput";
import DownloadGraphImageComponet from "../DownloadGraphImageComponet";
import { jsPDF } from "jspdf";
import ChartClone from "../ChartClone";
window.Swal = swal;

const sum = (arr) => {
	const result = arr.reduce((total, currentValue) => total = total + currentValue, 0);
	return result
}
ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Filler,
	Legend,
	zoomPlugin, ChartDataLabels,
	Decimation, TimeScale
);

export default function Lora_dashboard(props) {
	const { activeTab, setProfile, Profile, DashTabDetailById ,AccounData,GaData,CircleData,DivisionData,SubdevisionData,AreaData,AllCategoryJson,FilterDay,onGetFilterDaywise,setFilterDay,isRefDownload,setisRefDownload,isDownloadBtnShow} = props
	const chartRef = useRef();
	const eventChartRef = useRef();
	const InstallChartRef = useRef();
	const UndermainRef=useRef();
	const IMGCARD0 = useRef();
	const IMGCARD1 = useRef();
	const IMGCARD2 = useRef();
	const IMGCARD3 = useRef();
	const IMGCARD4 = useRef();
	const IMGCARD5 = useRef();
	const IMGCARD6 = useRef();
	const IMGCARD7 = useRef();
	const IMGCARD8 = useRef();
	const IMGCARD9 = useRef();
	const IMGCARD10 = useRef();
	const IMGCARD11= useRef();
	const IMGCARD12= useRef();
	const IMGCARD13= useRef();
	const IMGCARD14= useRef();
	const IMGCARD15= useRef();
	const IMGCARD28=useRef()

	var [GSMDATList, setGSMDATList] = useState(['HEARTBEAT_SUCCESS_LIST', 'HEARTBEAT_FAIL_LIST', 'DAILY_SUCCESS_LIST', 'DAILY_FAIL_LIST', 'HOURLY_SUCCESS_LIST', 'HOURLY_FAIL_LIST', 'ALERT_LIST', 'TIMESYNC_LIST', 'REBOOT_LIST', 'STATUS_ERR_LIST', 'DAILY_FAIL_LIST', 'OTHER_EVENT_LIST', 'TRANSECTION_EVENT_LIST', 'NONROLLOVER_EVENT_LIST', 'CONTROL_EVENT_LIST', 'COUNT_LIST'])
	var [lora24List, setlora24List] = useState(['HEARTBEAT_SUCCESS_LIST', 'HEARTBEAT_FAIL_LIST', 'DAILY_SUCCESS_LIST', 'DAILY_FAIL_LIST', 'HOURLY_SUCCESS_LIST', 'HOURLY_FAIL_LIST', 'ALERT_LIST', 'TIMESYNC_LIST', 'REBOOT_LIST', 'STATUS_ERR_LIST', 'DAILY_FAIL_LIST', 'OTHER_EVENT_LIST', 'TRANSECTION_EVENT_LIST', 'NONROLLOVER_EVENT_LIST', 'CONTROL_EVENT_LIST', 'COUNT_LIST'])

	const GSMEventList = ['VOLT_EVENT_LIST', 'CURRENT_EVENT_LIST', 'POWER_EVENT_LIST', 'OTHER_EVENT_LIST', 'TRANSECTION_EVENT_LIST', 'NONROLLOVER_EVENT_LIST', 'CONTROL_EVENT_LIST', 'COUNT_LIST']
	var [GSMDATAConsumerCheckList, setGSMDATAConsumerCheckList] = useState(['HEARTBEAT_TS', 'HEARTBEAT_TS', 'DAILY_TS', 'DAILY_TS', 'HOURLY_TS', 'HOURLY_TS', 'ALERT_TS', 'TIMESYNC_TS', 'REBOOT_TS', 'STATUS_ERR_TS', 'EMT_TS_PE', 'EMT_TS_OTHE', 'EMT_TS_TE', 'EMT_TS_NRE', 'EMT_TS_CTRLE'])
	const GSMEventConsumerCheckList = ['EMT_TS_VE', 'EMT_TS_CE', 'EMT_TS_PE', 'EMT_TS_OTHE', 'EMT_TS_TE', 'EMT_TS_NRE', 'EMT_TS_CTRLE']
	const MonthList = ['MONTH_BILL_SUCCESS_LIST', 'MONTH_BILL_FAIL_LIST']
	var [lora24CheckList, setlora24CheckList] = useState(['HEARTBEAT_TS', 'HEARTBEAT_TS', 'DAILY_TS', 'DAILY_TS', 'HOURLY_TS', 'HOURLY_TS', 'ALERT_TS', 'TIMESYNC_TS', 'REBOOT_TS', 'STATUS_ERR_TS', 'EMT_TS_PE', 'EMT_TS_OTHE', 'EMT_TS_TE', 'EMT_TS_NRE', 'EMT_TS_CTRLE'])

	const codeAndStatus = [{ code: 0, name: 'DLMS_ERROR_CODE_OK' }, { code: 1, name: 'DLMS_ERROR_CODE_HARDWARE_FAULT' }, { code: 2, name: 'DLMS_ERROR_CODE_TEMPORARY_FAILURE' }, { code: 3, name: 'DLMS_ERROR_CODE_READ_WRITE_DENIED ' }, { code: 4, name: 'DLMS_ERROR_CODE_UNDEFINED_OBJECT ' }, { code: 9, name: 'DLMS_ERROR_CODE_INCONSISTENT_CLASS_OR_OBJECT ' }, { code: 11, name: 'DLMS_ERROR_CODE_UNAVAILABLE_OBJECT' }, { code: 12, name: 'DLMS_ERROR_CODE_UNMATCH_TYPE' }, { code: 13, name: 'DLMS_ERROR_CODE_ACCESS_VIOLATED' }, { code: 14, name: 'DLMS_ERROR_CODE_DATA_BLOCK_UNAVAILABLE' }, { code: 15, name: 'DLMS_ERROR_CODE_LONG_GET_OR_READ_ABORTED' }, { code: 16, name: 'DLMS_ERROR_CODE_NO_LONG_GET_OR_READ_IN_PROGRESS' }, { code: 17, name: 'DLMS_ERROR_CODE_LONG_SET_OR_WRITE_ABORTED' }, { code: 18, name: 'DLMS_ERROR_CODE_NO_LONG_SET_OR_WRITE_IN_PROGRESS' }, { code: 19, name: 'DLMS_ERROR_CODE_DATA_BLOCK_NUMBER_INVALID' }, { code: 250, name: 'DLMS_ERROR_CODE_OTHER_REASON' }, { code: 251, name: 'DLMS_ERROR_CODE_UNKNOWN' }, { code: 252, name: 'DLMS_ERROR_CODE_SEND_FAILED' }, { code: 253, name: 'DLMS_ERROR_CODE_RECEIVE_FAILED' }, { code: 254, name: 'DLMS_ERROR_CODE_NOT_IMPLEMENTED' }, { code: 255, name: 'DLMS_ERROR_CODE_DLMS_SECURITY_NOT_IMPLEMENTED' }, { code: 256, name: 'DLMS_ERROR_CODE_INVALID_COMMAND' }, { code: 257, name: 'DLMS_ERROR_CODE_INVALID_BLOCK_NUMBER' }, { code: 258, name: 'DLMS_ERROR_CODE_INVALID_PARAMETER' }, { code: 259, name: 'DLMS_ERROR_CODE_NOT_INITIALIZED' }, { code: 260, name: 'DLMS_ERROR_CODE_OUTOFMEMORY' }, { code: 261, name: 'DLMS_ERROR_CODE_NOT_REPLY' }, { code: 262, name: 'DLMS_ERROR_CODE_INVALID_LOGICAL_NAME' }, { code: 263, name: 'DLMS_ERROR_CODE_INVALID_CLIENT_ADDRESS' }, { code: 264, name: 'DLMS_ERROR_CODE_INVALID_SERVER_ADDRESS' }, { code: 265, name: 'DLMS_ERROR_CODE_INVALID_DATA_FORMAT' }, { code: 267, name: 'DLMS_ERROR_CODE_INVALID_VERSION_NUMBER' }, { code: 268, name: 'DLMS_ERROR_CODE_CLIENT_ADDRESS_NO_NOT_MATCH' }, { code: 269, name: 'DLMS_ERROR_CODE_SERVER_ADDRESS_NO_NOT_MATCH' }, { code: 270, name: 'DLMS_ERROR_CODE_WRONG_CRC' }, { code: 281, name: 'DLMS_ERROR_CODE_INVALID_RESPONSE' }, { code: 278, name: 'DLMS_ERROR_CODE_INVALID_TAG' }, { code: 279, name: 'DLMS_ERROR_CODE_ENCODING_FAILED' }, { code: 280, name: 'DLMS_ERROR_CODE_REJECTED_PERMAMENT' }, { code: 281, name: 'DLMS_ERROR_CODE_REJECTED_TRANSIENT' }, { code: 282, name: 'DLMS_ERROR_CODE_NO_REASON_GIVEN' }, { code: 283, name: 'DLMS_ERROR_CODE_APPLICATION_CONTEXT_NAME_NOT_SUPPORTED' }, { code: 284, name: 'DLMS_ERROR_CODE_AUTHENTICATION_MECHANISM_NAME_NOT_RECOGNISED' }, { code: 285, name: 'DLMS_ERROR_CODE_AUTHENTICATION_MECHANISM_NAME_REQUIRED' }, { code: 286, name: 'DLMS_ERROR_CODE_AUTHENTICATION_FAILURE' }, { code: 287, name: 'DLMS_ERROR_CODE_AUTHENTICATION_REQUIRED' }, { code: 288, name: 'DLMS_ERROR_CODE_INVALID_FRAME_NUMBER' }, { code: 289, name: 'DLMS_ERROR_CODE_INVALID_DATE_TIME' }, { code: 289, name: 'DLMS_ERROR_CODE_INVALID_DATE_TIME' }, { code: 290, name: 'DLMS_ERROR_CODE_INVOCATION_COUNTER_TOO_SMALL' }, { code: 291, name: 'DLMS_ERROR_CODE_INVALID_DATE_TIME' }, { code: 292, name: 'DLMS_ERROR_CODE_INVALID_DECIPHERING_ERROR' }, { code: 293, name: 'DLMS_ERROR_CODE_INVALID_SECURITY_SUITE' }]
	const [dateInLong, setDateInLong] = useState([]);
	const [DateEventInLong, setDateEventInLong] = useState([])
	const [AllGSMMonthChartData, setAllGSMMonthChartData] = useState({ month_success: [], month_fail: [], SRNO: [] })
	const [DateMonthInLong, setDateMonthInLong] = useState([]);
	const [AllGSMEventChartData, setAllGSMEventChartData] = useState({ volt: [], current: [], power: [], other: [], transection: [], nonrollover: [], control: [], count: [], SRNO: [] })
	const [AllGSMChartData, setAllGSMChartData] = useState({ heartbeat_success: [], heartbeat_fail: [], daily_success: [], daily_fail: [], alert_total: [], timesync_total: [], REBOOT_LIST_total: [], STATUS_ERR_total: [], SRNO: [] });
	const [tableData, setTableData] = useState([]);
	const [seriesModem, setseriesModem] = useState([])
	const [serviceProvid, setserviceProvid] = useState({ series: [], category: [] })
	const [MCOMST, setMCOMST] = useState({ series: [], category: [], code: [] })
	const [tagsCount, settagsCount] = useState({ series: [], category: [], id: [] })
	const [installData, setInstallData] = useState([])
	const [DEVICE_STATUS, setDEVICE_STATUS] = useState({ series: [], categories: [] })
	const [GSM_BAND, setGSM_BAND] = useState({ series: [], categories: [] })
	const [categoryModem, setcategoryModem] = useState([])
	const [seriesMeter, setseriesMeter] = useState([])
	const [categoryMeter, setcategoryMeter] = useState([])
	const [AllData, setAllData] = useState({});
	const [BlankData, setBlankData] = useState(['Active(Live)','Active(Temporary Disconnection)','Inactive(Permanent Disconnection)','Inactive(Inactive Cancelled Consumer)','Pending Configuration','Under Maintanance']);
	const [loader, setLoader] = useState(false);
	const [mapInfo, setMapInfo] = useState([])
	const [categoryFirmwar, setcategoryFirmwar] = useState([])
	const [UplinkFirm, setUplinkFirm] = useState([])
	const [seriesFirmwar, setseriesFirmwar] = useState([])
	const [testing, setTesting] = useState([])
	const [chartClickData, setchartClickData] = useState([])
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [tabShow, settabShow] = useState(false)
	const [isLastModalVisible, setIsLastModalVisible] = useState(false);
	const [ModelId, setModelId] = useState('')
	const [ColorText, setColorText] = useState('')
	const [ModemId, setModemId] = useState([])
	const [TableData, setTableDataInApi] = useState([])
	const [MeterId, setMeterId] = useState([])
	
	const [permision, setpermision] = useState({});
	const [letest24, setletest24] = useState({});
	const [categoryRSSI, setcategoryRSSI] = useState([])
	const [categoryBAT, setcategoryBAT] = useState([])
	const [categorySNR, setcategorySNR] = useState([])
	const serisBAT = ['0 - 20', '21 - 40', '41 - 60', '61 - 80', '81 - 100', "null"]
	const [inputSeen, setinputSeen] = useState('24')
	const [seriesSNR, setseriesSNR] = useState(['Very Poor (Less Then 12)', 'Poor (-7 to -12)', 'Medium (2 to -6)', 'Good (7 to 1)', 'Excellent (More Then 7)'])
	const [seriesRSSI, setseriesRSSI] = useState(['Very Poor(-150 - -111)', 'Poor (-110 - -96)', 'Medium (-95 - -81)', 'Good (-80 - -52)', 'Excellent (-51 - 0)', 'null'])
	// const [Profile, setProfile] = useState({ account: "", ga: "", circle: "", division: "", subdivision: "", area: "" });
	const [expandedModelHeader, setExpandedModelHeader] = useState('')
	const [expireDate, setExpireDate] = useState({})
	const [isExpandedModalOpen, setisExpandedModalOpen] = useState(false)
	const [expandedChartData, setexpandedChartData] = useState({ total: { heartbeat_success: [], heartbeat_fail: [], daily_success: [], daily_fail: [], alert_total: [], timesync_total: [], REBOOT_LIST_total: [], STATUS_ERR_total: [], SRNO: [] }, date: [] })
	const [IPV, setIPV] = useState({ IPV: [], categories: ['IPV4', 'IPV6', 'IPV4V6(auto)'] })
	const [exInstallationChartData, setExInstallationChartData] = useState({ barData: [], date: [] })
	const [exEventChartData, setExEventChartData] = useState({ total: { volt: [], current: [], power: [], other: [], transection: [], nonrollover: [], control: [], count: [], SRNO: [] }, date: [] })
	const [exMonthBillChartData, setExMonthBillChartData] = useState({ total: { month_success: [], month_fail: [], SRNO: [] }, date: [] })
	const [datesInmap, setdatesInmap] = useState({ start: '', end: '' })
	const [HeatbeatStatus, setHeatbeatStatus] = useState({})
	const [APM, setAPM] = useState({ series: [], category: [] })
	const [ChartLoader, setChartLoader] = useState(false)
	const [dates, setDates] = useState({ start: '', end: '' })
	const [ModalLoad, setModalLoad] = useState(false)
	const [installLoad, setinstallLoad] = useState(false)
	const [MeterDetails, setMeterDetails] = useState([])
	const btnColor = ['#4f5ece', '#f59e0b', '#fc544b', '#3abaf4', '#54ca68', '#191d21', '#7c5295', '#4f5ece']
	const [UnlockBrand, setUnlockBrand] = useState({ series: [], categories: [] })
	const [AllCategory, setAllCategory] = useState({})
	const [seriesMechanicalMeter, setseriesMechanicalMeter] = useState([])
	const [categoryMechanicalMeter, setcategoryMechanicalMeter] = useState([])
	const userInfo = JSON.parse(window.localStorage.getItem("user_info"));
	const [MechancalMeterId, setMechancalMeterId] = useState([])
	const [InstallType, setInstallType] = useState('Days')
	const [tringerMeter, settringerMeter] = useState(false)
	const [DashTabs, setDashTabs] = useState([])
	const [DashLoader, setDashLoader] = useState(false)
	const [Modal_card_name, setModal_card_name] = useState('')
	const [card_id, setcard_id] = useState('')
	const [CardBar,setCardBar]=useState([])
	const [isDashModal, setisDashModal] = useState(false);
	const [chartType,setchartType]=useState({})
	const [DefaultShowBar,setDefaultShowBar]=useState({})
	const [Model,setModel]=useState(false)
	const [isUndermaintanceLoader,setIsUndermaintanceLoader]=useState(false)
	const [UnderMaintanceData,setUnderMaintanceData]=useState([])
	const lableUndermaintance=['1-15 Days','16-30 Days','31-45 Days','Above 45 days']
	const [report, setReport] = useState({ value: '', name: '', start_date: '', end_date: '' })
	const [dataForChartJs, setdataForChartJs] = useState({
		labels: [],
		datasets: [
			{
				label: "Heartbeat Success",
				data: [],
				barPercentage: 1.0,
				backgroundColor: 'rgb(0, 126, 51)',
				borderRadius: 5,
				borderColor:'rgb(0, 126, 51)',
				pointRadius: 5,
				pointHoverRadius: 7
			},
			{
				label: "Heartbeat fail",
				data: [],
				barPercentage: 1.0,
				backgroundColor: 'rgb(50,225,79)',
				borderRadius: 5,
				borderColor:'rgb(50,225,79)',
				pointRadius: 5,
				pointHoverRadius: 7
			},
			{
				label: "DailyData Success",
				data: [],
				barPercentage: 1.0,
				backgroundColor: 'rgb(51,33,113)',
				borderRadius: 5,
				borderColor:'rgb(51,33,113)',
				pointRadius: 5,
				pointHoverRadius: 7
			},
			{
				label: "DailyData Fail",
				data: [],
				barPercentage: 1.0,
				backgroundColor: 'rgb(120,111,206)',
				borderRadius: 5,
				borderColor:'rgb(120,111,206)',
				pointRadius: 5,
				pointHoverRadius: 7
			},
			{
				label: "Hourly Success",
				data: [],
				barPercentage: 1.0,
				backgroundColor: 'rgb(0, 104, 138)',
				borderRadius: 5,
				borderColor:'rgb(0, 104, 138)',
				pointRadius: 5,
				pointHoverRadius: 7
			},
			{
				label: "Hourly fail",
				data: [],
				barPercentage: 1.0,
				backgroundColor: 'rgb(51, 181, 229)',
				borderRadius: 5,
				borderColor:'rgb(51, 181, 229)',
				pointRadius: 5,
				pointHoverRadius: 7
			},
			{
				label: "Alert",
				data: [],
				barPercentage: 1.0,
				backgroundColor: 'rgb(255, 119, 0)',
				borderRadius: 5,
				borderColor:'rgb(255, 119, 0)',
				pointRadius: 5,
				pointHoverRadius: 7
			},
			{
				label: "Timesync",
				data: [],
				barPercentage: 1.0,
				backgroundColor: 'rgb(257, 120, 10)',
				borderRadius: 5,
				borderColor:'rgb(257, 120, 10)',
				pointRadius: 5,
				pointHoverRadius: 7
			},
			{
				label: "Reboot",
				data: [],
				barPercentage: 1.0,
				backgroundColor: 'rgb(120,111,206)',
				borderRadius: 5,
				borderColor:'rgb(120,111,206)',
				pointRadius: 5,
				pointHoverRadius: 7
			},
			{
				label: "Status Error",
				data: [],
				barPercentage: 1.0,
				backgroundColor: 'rgb(51,33,113)',
				borderRadius: 5,
				borderColor:'rgb(51,33,113)',
				pointRadius: 5,
				pointHoverRadius: 7
			}
		],
	});
	
	const [CardFilter,setCardFilter]=useState({})

	const [TreeSelection,setTreeSelection]=useState([])


	const [series1, setseries1] = useState([
		{
			name: "Heartbeat Success",
			data: [],
		},
		{
			name: "Heartbeat fail",
			data: [],
		},

		{
			name: "DailyData Success",
			data: [],
		},
		{
			name: "DailyData Fail",
			data: [],
		}, {
			name: "Hourly Success",
			data: [],
		},
		{
			name: "Hourly Fail",
			data: [],
		},
		{
			name: "Alert",
			data: [],
		},
		{
			name: "Timesync",
			data: [],
		},
		{
			name: "Reboot",
			data: [],
		},
		{
			name: "Status Error",
			data: [],
		}
	]);
	const [options1, setoptions1] = useState({})
	const onChange = (date, dateString) => {
		setDates({ ...dates, start: dateString })
	};
	const onChanges = (date, dateString) => {
		setDates({ ...dates, end: dateString })
	};
	const onChangeMap = (date, dateString) => {
		setdatesInmap({ ...datesInmap, start: dateString })
	};
	const onChangesMap = (date, dateString) => {
		setdatesInmap({ ...datesInmap, end: dateString })
	};
	const onExpandButton = (tableName, col, header) => {
		if (header == 'Installation Date Wise Chart') {
			setExpireDate({ start_date: '', endDate: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000) })
			setisExpandedModalOpen(true)
		}
		else {
			ongetStartAndEndDateByTable(tableName, col)
		}
		// onGetTableNameWiseChartDataBy15Date()
		setExpandedModelHeader(header)
	}
	const handleExpandedModal = () => {
		setisExpandedModalOpen(false);
		setexpandedChartData({ total: {}, date: [] })
		setExInstallationChartData({ barData: [], date: [] })
		setExEventChartData({ total: {}, date: [] })
		setExMonthBillChartData({ total: {}, date: [] })
		if (myChart != undefined) {
			myChart.destroy()
		}
		setChartLoader(false)
		setDates({ start: '', end: '' })
	}

	const ongetStartAndEndDateByTable = async (tableName, col) => {
		console.log("Wanted to check if this is calling or not")
		document.body.style.cursor = 'want'
		const data = await getStartAndEndDateByTable({ tableName: tableName, col: col })
		if (data.success === true) {

			console.log("Expiry Dates == ", data.data)
			setExpireDate(data.data)
			setisExpandedModalOpen(true)
			document.body.style.cursor = 'default'
		} else {
			console.log("something want wrong")
			document.body.style.cursor = 'default'
		}
	}

	const onExpandSubmitClick = async () => {
		const x = new Date(moment(dates.start, 'DD-MM-YYYY').format('YYYY-MM-DD'));
		const y = new Date(moment(dates.end, 'DD-MM-YYYY').format('YYYY-MM-DD'));
		if (x > y) {
			return toast.warn('"Start Date" Must be Less than or Equal to "End Date"')
		}
		console.log(x > y, x, y,expandedModelHeader);
		if (expandedModelHeader == 'Installation Date Wise Chart') {
			onGetexInstallationChartData()

		} else if (expandedModelHeader == 'lorawan Instantaneous Count') {
			onGetexInstantData()
		}
		else if (expandedModelHeader == 'GSM Event Count') {
			onGetexEventData()
		}
		else if (expandedModelHeader == 'GSM Month Bill Count') {
			onGetexMonthBillData()
		}
		else if (expandedModelHeader == 'Lorawan Consumer Status') {
			onGetLoraStatusWiseCount()
		}
	}

	const onGetLoraStatusWiseCount = async () => {
		// const data=await getGroupWiseConsumerStatusCount({ start: moment(dates.start, "DD-MM-YYYY").format("YYYY-MM-DD"), end: moment(dates.end, "DD-MM-YYYY").format("YYYY-MM-DD"), CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === '' ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })

		// if(data.success==true){
		// 	const ChartArray = data.data.data;
		// 	const obj = { active_Live_count: ChartArray.map((item) => (item?.active_Live_count)),active_TD_count: ChartArray.map((item) => (item?.active_TD_count)), inactive_count: ChartArray.map((item) => (item?.inactive_count)), undermaintanace_count: ChartArray.map((item) => (item?.undermaintanace_count)), pending_count: ChartArray.map((item) => (item?.pending_count)), SRNO: ChartArray.map((item) => (item?.SRNO))}
		// 	setexGSMCountGroup({ total: obj, date: data.data.data.map((item) => (item.CREATED_AT.split('T')[1]?moment.utc(item.CREATED_AT).format('DD-MM-YYYY'):item.CREATED_AT))})
		// 	console.log(data.data)
		// }else{
		// 	console.log("something want wrong");
		// }
	}

	const onGetexInstallationChartData = async () => {
		setChartLoader(true)
		const data = await GetLoraInstallationDateWiseGraphDataBySelectedDate({ start: moment(dates.start, "DD-MM-YYYY").format("YYYY-MM-DD"), end: moment(dates.end, "DD-MM-YYYY").format("YYYY-MM-DD"), CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE,ins_no:Profile.ins_no, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === ''&& Profile?.ins_no?.length==0 ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })

		if (data.success === true) {
			setExInstallationChartData({ barData: data.data.data.map((item => item?.total)), date: data.data.data.map((item) => (moment(item.dates).format("DD-MM-YYYY"))) })
			setChartLoader(false)
		}
		else {
			console.log('something want wrong')
			setChartLoader(false)
		}
	}

	const onGetexInstantData = async () => {
		setChartLoader(true)
		const data = await getAllLoraChartByDateSlection({ start: moment(dates.start, "DD-MM-YYYY").format("YYYY-MM-DD"), end: moment(dates.end, "DD-MM-YYYY").format("YYYY-MM-DD"), CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE,ins_no:Profile.ins_no, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === ''&& Profile?.ins_no?.length==0 ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
		if (data.success === true) {
			const ChartArray = data.data.data;
			const obj = { heartbeat_success: ChartArray.map((item) => (item?.heartbeat_success)), heartbeat_fail: ChartArray.map((item) => (item?.heartbeat_fail)), daily_success: ChartArray.map((item) => (item?.daily_success)), daily_fail: ChartArray.map((item) => (item?.daily_fail)), alert_total: ChartArray.map((item) => (item?.alert_total)), timesync_total: ChartArray.map((item) => (item?.timesync_total)), REBOOT_LIST_total: ChartArray.map((item) => (item?.REBOOT_LIST_total)), STATUS_ERR_total: ChartArray.map((item) => (item?.STATUS_ERR_total)), SRNO: ChartArray.map((item) => (item?.SRNO)) }
			console.log(obj);
			setexpandedChartData({ total: obj, date: data.data.data.map((item) => (item.CREATED_AT.split('T')[1] ? moment.utc(item.CREATED_AT).format('DD-MM-YYYY') : item.CREATED_AT)) })
			setChartLoader(false)
		} else {
			console.log('something want wrong')
			setChartLoader(false)
		}
	}
	const onGetexEventData = async () => {
		setChartLoader(true)
		const data = await getAllGSMEventChartBySelectedDate({ start: moment(dates.start, "DD-MM-YYYY").format("YYYY-MM-DD"), end: moment(dates.end, "DD-MM-YYYY").format("YYYY-MM-DD"), CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE,ins_no:Profile.ins_no, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === ''&& Profile?.ins_no?.length==0 ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
		if (data.success === true) {
			console.log("Event Data ===", data.data.data)
			const ChartArray = data.data.data;
			const obj = { volt: ChartArray.map((item) => (item?.volt)), current: ChartArray.map((item) => (item?.current)), power: ChartArray.map((item) => (item?.power)), other: ChartArray.map((item) => (item?.other)), transection: ChartArray.map((item) => (item?.transection)), nonrollover: ChartArray.map((item) => (item?.nonrollover)), control: ChartArray.map((item) => (item?.control)), count: ChartArray.map((item) => (item?.count || 0)), SRNO: ChartArray.map((item) => (item?.SRNO)) }
			setExEventChartData({ total: obj, date: data.data.data.map((item) => (moment.utc(item.CREATED_AT).add(-moment().utcOffset(), "m").format("DD-MM-YYYY"))) })
			setChartLoader(false)
		} else {
			console.log('something want wrong')
			setChartLoader(false)
		}
	}
	const onGetexMonthBillData = async () => {
		setChartLoader(true)
		const data = await getAllGSMMonthlyChartBySelectedDate({ start: dates.start, end: dates.end, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE,ins_no:Profile.ins_no, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === ''&& Profile?.ins_no?.length==0 ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } })
		if (data.success === true) {
			console.log("Month Bill Data == ", data.data.data)
			const ChartArray = data.data.data;
			const obj = { month_success: ChartArray.map((item) => (item?.month_success)), month_fail: ChartArray.map((item) => (item?.month_fail)), SRNO: ChartArray.map((item) => (item?.SRNO)) }
			setExMonthBillChartData({ total: obj, date: data.data.data.map((item) => ([item.CREATED_AT])) })
			setChartLoader(false)
		} else {
			console.log('something want wrong')
			setChartLoader(false)
		}
	}



	const ongetAllGSMChartByDate = async (info,isUpdate) => {
		setAllGSMChartData({ heartbeat_success: [], heartbeat_fail: [], daily_success: [], daily_fail: [], alert_total: [], timesync_total: [], REBOOT_LIST_total: [], STATUS_ERR_total: [], SRNO: [] })

		setLoader(true);
		setLoader(false);
		const data = await getAllLorawanChartByDate(info || {});
		if (data.success === true) {
			const ChartArray = data.data.data;
			const obj = { heartbeat_success: ChartArray.map((item) => (item?.heartbeat_success)), heartbeat_fail: ChartArray.map((item) => (item?.heartbeat_fail)), daily_success: ChartArray.map((item) => (item?.daily_success)), daily_fail: ChartArray.map((item) => (item?.daily_fail)), alert_total: ChartArray.map((item) => (item?.alert_total)), timesync_total: ChartArray.map((item) => (item?.timesync_total)), REBOOT_LIST_total: ChartArray.map((item) => (item?.REBOOT_LIST_total)), STATUS_ERR_total: ChartArray.map((item) => (item?.STATUS_ERR_total)), hourly_success: ChartArray.map((item) => (item?.hourly_success || 0)), hourly_fail: ChartArray.map((item) => (item?.hourly_fail || 0)), SRNO: ChartArray.map((item) => (item?.SRNO)), ENTRYTS: ChartArray[5]?.ENTRYTS }
			setAllGSMChartData(obj)
			const DateArray = ChartArray.map((item) => ([item?.CREATED_AT?.split('T')[1] ? moment.utc(item?.CREATED_AT).format('DD-MM-YYYY') : item?.CREATED_AT]))

			setDateInLong(DateArray);
			var remove_index = []
			const view_json=JSON.parse(DashTabDetailById?.view_json||'{}')
			setdataForChartJs({
				labels: DateArray.map((item) => ([item + ` (${moment(item, 'DD-MM-YYYY').format('ddd')})`])),
				datasets: JSON.parse(JSON.stringify([
					(view_json[card_json[0]?.U_ID]?.bar_pemission?.includes("Heartbeat Success") || activeTab!='Custom Dashboard') && {
						label: "Heartbeat Success",
						data: obj?.heartbeat_success,
						barPercentage: 1.0,
						backgroundColor: 'rgb(0, 126, 51)',
						borderRadius: 5,
					} || undefined,
					(view_json[card_json[0]?.U_ID]?.bar_pemission?.includes("Heartbeat Fail") || activeTab!='Custom Dashboard') && {
						label: "Heartbeat Fail",
						data: obj?.heartbeat_fail,
						barPercentage: 1.0,
						backgroundColor: 'rgb(50,225,79)',
						borderRadius: 5,
					} || undefined,
					(view_json[card_json[0]?.U_ID]?.bar_pemission?.includes("DailyData Success") || activeTab!='Custom Dashboard') && {
						label: "DailyData Success",
						data: obj?.daily_success,
						barPercentage: 1.0,
						backgroundColor: 'rgb(51,33,113)',
						borderRadius: 5,
					} || undefined,
					(view_json[card_json[0]?.U_ID]?.bar_pemission?.includes("DailyData Fail") || activeTab!='Custom Dashboard') && {
						label: "DailyData Fail",
						data: obj?.daily_fail,
						barPercentage: 1.0,
						backgroundColor: 'rgb(120,111,206)',
						borderRadius: 5,
					} || undefined,
					(view_json[card_json[0]?.U_ID]?.bar_pemission?.includes("Hourly Success") || activeTab!='Custom Dashboard') && {
						label: "Hourly Success",
						data: obj?.hourly_success,
						barPercentage: 1.0,
						backgroundColor: 'rgb(0, 104, 138)',
						borderRadius: 5,
					} || undefined,
					(view_json[card_json[0]?.U_ID]?.bar_pemission?.includes("Hourly Fail") || activeTab!='Custom Dashboard') && {
						label: "Hourly Fail",
						data: obj?.hourly_fail,
						barPercentage: 1.0,
						backgroundColor: 'rgb(51, 181, 229)',
						borderRadius: 5,
					} || undefined,
					(view_json[card_json[0]?.U_ID]?.bar_pemission?.includes("Alert") || activeTab!='Custom Dashboard') && {
						label: "Alert",
						data: obj?.alert_total,
						barPercentage: 1.0,
						backgroundColor: 'rgb(255, 119, 0)',
						borderRadius: 5,
					} || undefined,
					(view_json[card_json[0]?.U_ID]?.bar_pemission?.includes("Timesync") || activeTab!='Custom Dashboard') && {
						label: "Timesync",
						data: obj?.timesync_total,
						barPercentage: 1.0,
						backgroundColor: 'rgb(257, 120, 10)',
						borderRadius: 5,
					} || undefined,
					(view_json[card_json[0]?.U_ID]?.bar_pemission?.includes("Reboot") || activeTab!='Custom Dashboard') && {
						label: "Reboot",
						data: obj?.REBOOT_LIST_total,
						barPercentage: 1.0,
						backgroundColor: 'rgb(120,111,206)',
						borderRadius: 5,
					} || undefined,
					(activeTab!='Custom Dashboard' || view_json[card_json[0]?.U_ID]?.bar_pemission?.includes("Status Error")) && {
						label: "Status Error",
						data: obj?.STATUS_ERR_total,
						barPercentage: 1.0,
						backgroundColor: 'rgb(51,33,113)',
						borderRadius: 5,
					} || undefined
				])).filter((item, id) => {
					if (item == undefined) {
						remove_index.push(id)
					}
					return item != undefined
				}),
				
			})
			if (activeTab=='Custom Dashboard'&&isUpdate) {
				setGSMDATAConsumerCheckList([...GSMDATAConsumerCheckList.filter((item, id) => !remove_index.includes(id))])
				setGSMDATList([...GSMDATList.filter((item, id) => !remove_index.includes(id))])
			}
			

		} else {
			console.log("something want wrong");
			setLoader(false);
		}
	};

	// const ongetAllGSMEventChartByDate = async (info) => {
	// 	setAllGSMEventChartData({ volt: [], current: [], power: [], other: [], transection: [], nonrollover: [], count: [], SRNO: [] })

	// 	const data = await getAllGSMEventChartByDate(info);
	// 	if (data.success === true) {
	// 		const ChartArray = data.data.data;
	// 		const obj = { volt: ChartArray.map((item) => (item?.volt)), current: ChartArray.map((item) => (item?.current)), power: ChartArray.map((item) => (item?.power)), other: ChartArray.map((item) => (item?.other)), transection: ChartArray.map((item) => (item?.transection)), nonrollover: ChartArray.map((item) => (item?.nonrollover)), control: ChartArray.map((item) => (item?.control)), count: ChartArray.map((item) => (item?.count || 0)), SRNO: ChartArray.map((item) => (item?.SRNO)) }
	// 		// setAllGSMChartData(obj)}
	// 		// ,volt:ChartArray.map((item) =>(item?.volt)),current:ChartArray.map((item) =>(item?.current)),power:ChartArray.map((item) =>(item?.power)),other:ChartArray.map((item) =>(item?.other)),transection:ChartArray.map((item) =>(item?.transection)),nonrollover:ChartArray.map((item) =>(item?.nonrollover)),control:ChartArray.map((item) =>(item?.control)),count:ChartArray.map((item) =>(item?.count)),SRNO:ChartArray.map((item) =>(item?.SRNO))
	// 		setAllGSMEventChartData(obj)
	// 		const DateArray = ChartArray.map((item) => ([moment.utc(item.CREATED_AT).format("DD-MM-YYYY"), item?.volt + item?.other + item?.power + item?.current + item?.transection + item?.nonrollover + item?.control]))
	// 		setDateEventInLong(DateArray);
	// 	} else {
	// 		console.log("something want wrong");
	// 		setLoader(false);
	// 	}
	// };

	// const ongetAllGSMMonthlyChartByDate = async (info) => {
	// 	setAllGSMMonthChartData({ month_success: [], month_fail: [], SRNO: [] })

	// 	const data = await getAllGSMMonthlyChartByDate(info);
	// 	if (data.success === true) {
	// 		const ChartArray = data.data.data;
	// 		const obj = { month_success: ChartArray.map((item) => (item?.month_success)), month_fail: ChartArray.map((item) => (item?.month_fail)), SRNO: ChartArray.map((item) => (item?.SRNO)) }
	// 		setAllGSMMonthChartData(obj)
	// 		const DateArray = ChartArray.map((item) => ([item.CREATED_AT, item?.month_success + item?.month_fail]))
	// 		setDateMonthInLong(DateArray);
	// 	} else {
	// 		console.log("something want wrong");
	// 		setLoader(false);
	// 	}
	// };

	const ongetCountStatusByGa = async (info) => {
		setTableData([])
		const data = await getLoraCountStatusByGa(info);
		if (data.success === true) {
			const StatusArray = data.data.data
			setTableData([StatusArray?.active_Live_length || 0, StatusArray?.active_TD_length || 0, StatusArray?.InActive_length || 0, StatusArray?.InActive_Cancel_length || 0, StatusArray?.Pandding_length || 0, StatusArray?.Maintenance || 0]);
			// setBlankData(data.data.Blank);
			// setAllData(data.data.ALl);
		} else {
			console.log("something want warong");
		}
	};
	const ongetAllModemTotalGSM = async (info) => {
		setseriesModem([]);

		const data = await getLoraAllModemTotalGSM(info);
		if (data.success === true) {
			const MID = data.data.data.map((item) => (item?.MODEM_TYPE))
			const MSID = data.data.data.map((item) => (item?.Modem_length))
			const MCID = data.data.data.map((item) => (item?.MODEM_PROFILE_NAME + '(' + item?.Modem_length + ')'))
			setModemId(MID)
			setseriesModem(MSID);
			setcategoryModem(MCID);
		} else {
			console.log("something want warong");
		}
	};

	const ongetServiceProviderTotalGSM = async (info) => {
		setserviceProvid({ series: [], category: [] });

		const data = await getLoraLDR(info);
		if (data.success === true) {
			const obj = { series: data.data.data.map((item) => (item?.total)), category: data.data.data.map((item) => (item?.SIM_NWKP + '(' + item?.total + ')' || '')) }
			setserviceProvid(obj);
		} else {
			console.log("something want warong");
		}
	}

	const ongetmodemMeterConnectivityTotalGSM = async (info) => {
		setMCOMST({ series: [], category: [], code: [] })
		const data = await getmodemMeterConnectivityTotalGSM(info);
		if (data.success === true) {
			const obj = { series: data.data.data.map((item) => (item?.total)), category: data.data.data.length > 0 && data.data.data.map((item) => (codeAndStatus.filter((items) => (items?.code == item?.MCOMST))[0]?.name + '(' + item?.total + ')')), code: data.data.data.map((item) => (item?.MCOMST)) }
			setMCOMST(obj);
		} else {
			console.log("something want warong");
		}
	};
	// const ongetmodemConnectivityTotalGSM = async (info) => {
	// 	setDEVICE_STATUS({ series: [], categories: [] })
	// 	const data = await getmodemConnectivityTotalGSM(info);
	// 	if (data.success === true) {
	// 		const obj = { series: data.data.data.map((item) => (item?.total)), categories: data.data.data.map((item) => (item?.DEVICE_STATUS+'('+item?.total+')')) }
	// 		setDEVICE_STATUS(obj);
	// 	} else {
	// 		console.log("something want warong");
	// 	}
	// }
	const ongetGSM_BANDTotalGSM = async (info) => {
		setGSM_BAND({ series: [], categories: [] })
		const data = await getLorawanSF(info);
		if (data.success === true) {
			const obj = { series: data.data.data.map((item) => (item?.total)), categories: data.data.data.map((item) => (item?.LSF + '(' + item?.total + ')')) }
			setGSM_BAND(obj);
		} else {
			console.log("something want warong");
		}
	}
	// const ongetAPMTotalGSM = async (info) => {
	// 	setAPM({ series: [], category: [] })
	// 	const data = await getAPMTotalGSM(info);
	// 	if (data.success === true) {
	// 		const obj = { series: data.data.data.map((item) => (item?.total)), category: data.data.data.map((item) => (item?.APN==''?'Not Available'+'('+item?.total+')':item?.APN+'('+item?.total+')')) }
	// 		setAPM(obj);
	// 	} else {
	// 		console.log("something want warong");
	// 	}
	// }
	const ongetAllMeterTotalGSM = async (info) => {
		setseriesMeter([])
		setcategoryMeter([])
		const data = await getLoraAllMeterTotalGSM(info);

		if (data.success === true) {
			setMeterId(data.data.data.map((item) => (item?.METER_TYPE)))
			setseriesMeter(data.data.data.map((item) => (item?.Meter_length)));
			setcategoryMeter(data.data.data.map((item) => (item?.METER_PROFILE_NAME + ' - ' + item?.Meter_length)));
			setMeterDetails(data?.data?.data)
		} else {
			console.log("something want warong");
		}
	};
	const ongetAllMapDataInLora = async (info) => {
		setMapInfo([])
		const data = await getAllMapDataInLorawan(info)
		if (data.success == true) {
			setMapInfo(data.data.data)
		} else {
			console.log('something want wrong')
		}
	}

	const ongetmodemFirmwarTotalGSM = async (info) => {
		setseriesFirmwar([])
		setcategoryFirmwar([])
		setUplinkFirm([])
		const data = await getmodemFirmwarTotalLORA(info);
		if (data.success === true) {
			setUplinkFirm(data.data.data.map((item) => (item?.modem_firm_uplink)))
			setseriesFirmwar(data.data.data.map((item) => (item?.total)));
			setcategoryFirmwar(data.data.data.map((item) => (item?.modem_firmware + '(' + item?.total + ')' || '')));

		} else {
			console.log("something want warong");
		}
	}
	const ongetTagsWiseConsumerData = async (info) => {
		settagsCount({ ...tagsCount, series: [], category: [], id: [] })
		const data = await getLoraTagsWiseConsumerData(info);
		if (data.success === true) {
			var seri = []
			var category = []
			var id = []
			data.data.data.map((item) => {
				if (item?.total != 0) {
					seri.push(item?.total)
					category.push(item?.TAG_NAME + '(' + item?.total + ')')
					id.push(item?.UNIQUE_ID)
				}
			})
			const obj = { series: seri, category: category, id: id }
			settagsCount(obj)
		} else {
			console.log("something want warong");
		}
	}

	const onGetInstallationDateWiseGraphData = async (info, type) => {
		setinstallLoad(true)
		setInstallData([])
		const data = await GetLoraInstallationDateWiseGraphData({ ...info, type: type || 'Days' });
		if (data.success === true) {
			setInstallData(data.data.data)
			setinstallLoad(false)

		} else {
			console.log("something want warong");
			setinstallLoad(false)

		}
	}

	// const ongetIPVTotalINGSM = async (info) => {
	// 	setIPV({ ...IPV, IPV: [] })
	// 	const data = await getIPVTotalINGSM(info);
	// 	if (data.success === true) {
	// 		setIPV({ ...IPV, IPV: [data?.data?.data?.IPV4, data?.data?.data?.IPV6, data?.data?.data?.IPV4V6],categories:['IPV4'+'('+data?.data?.data?.IPV4+')', 'IPV6'+'('+data?.data?.data?.IPV6+')', 'IPV4V6(auto)'+'('+data?.data?.data?.IPV4V6+')'] })
	// 	} else {
	// 		console.log("something want warong");
	// 	}
	// }
	const ongetAllRSSITotalGSM = async (info) => {
		setcategoryRSSI([])
		const data = await getLoraRSSIInDeshboardAllCountByStatus(info);
		if (data.success === true) {
			setcategoryRSSI(data.data.data);
		} else {
			console.log("something want warong");
		}
	};
	const ongetAllBatteryTotalGSM = async (info) => {
		setcategoryBAT([])
		const data = await getLoraBateeryPercentageAllCountByStatus(info);
		if (data.success === true) {
			setcategoryBAT(data.data.data);
		} else {
			console.log("something want warong");
		}
	};
	const ongetAllSNRyTotalGSM = async (info) => {
		setcategorySNR([])
		const data = await getLoraSNRAllCountByStatus(info);
		if (data.success === true) {
			setcategorySNR(data.data.data);
		} else {
			console.log("something want warong");
		}
	};

	const onGetLoraStatusUndermaintainaceGraphData = async (info, type) => {
		setUnderMaintanceData([])
		if(UnderMaintanceData==false){
			setIsUndermaintanceLoader(true)
		}
		const data = await GetLoraStatusUndermaintainaceGraphData({...info,type:type||'Days'});
		if (data.success === true) {
			setUnderMaintanceData(data.data.data)
			setIsUndermaintanceLoader(false)

		} else {
			console.log("something want warong");
			setIsUndermaintanceLoader(false)

		}
	}
	useEffect(()=>{
		console.log(permision)
		if(Object.keys(permision).length&&Object.keys(AllCategoryJson).length){
		const tree_obj=AllCategoryJson
		var obj_array=[]
	tree_obj?.category0?.map((cat0,id0)=>{
		var obj0={value: cat0.UNIQUE_ID,
		title:<b>{cat0?.CATEGORY0}</b>,
		children:[]}
		if(permision?.ROLES_PERMISSIONS_CATEGORY0?.CATEGORY0_view?.filter((items) => items === cat0.UNIQUE_ID).length > 0 || userInfo?.ROLE === 'ROLE1650614500708'){
		tree_obj?.category1?.map((cat1,id1)=>{
			if(permision?.ROLES_PERMISSIONS_CATEGORY1?.CATEGORY1_view?.filter((items) => items === cat1.CATEGORY1_UNIQUE_ID).length > 0 || userInfo?.ROLE === 'ROLE1650614500708'){
			var obj1={value: cat1.CATEGORY1_UNIQUE_ID,
				title:cat1?.CATEGORY1_NAME,
				children:[]}
			if(cat1.CATEGORY0==cat0?.UNIQUE_ID){
				tree_obj?.category2?.map((cat2,id2)=>{
					if(permision?.ROLES_PERMISSIONS_CATEGORY2?.CATEGORY2_view?.filter((items) => items === cat2.CATEGORY2_UNIQUE_ID).length > 0 || userInfo?.ROLE === 'ROLE1650614500708'){
					var obj2={value: cat2.CATEGORY2_UNIQUE_ID,
						title:cat2?.CATEGORY2_NAME,
						children:[]}
					if(cat2.CATEGORY1==cat1?.CATEGORY1_UNIQUE_ID){
						tree_obj?.category3?.map((cat3,id3)=>{
							if(permision?.ROLES_PERMISSIONS_CATEGORY3?.CATEGORY3_view?.filter((items) => items === cat3.CATEGORY3_UNIQUE_ID).length > 0 || userInfo?.ROLE === 'ROLE1650614500708'){
							var obj3={value: cat3.CATEGORY3_UNIQUE_ID,
								title:cat3?.CATEGORY3_NAME,
								children:[]}
							if(cat3.CATEGORY2==cat2?.CATEGORY2_UNIQUE_ID){
								tree_obj?.category4?.map((cat4,id4)=>{
									if(permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY4_view?.filter((items) => items === cat4.CATEGORY4_UNIQUE_ID).length > 0 || userInfo?.ROLE === 'ROLE1650614500708'){
									var obj4={value: cat4.CATEGORY4_UNIQUE_ID,
										title:cat4?.CATEGORY4_NAME,
										children:[]}
									if(cat4.CATEGORY3==cat3?.CATEGORY3_UNIQUE_ID){
										tree_obj?.category5?.map((cat5,id5)=>{
											if(permision?.ROLES_PERMISSIONS_CATEGORY5?.CATEGORY5_view?.filter((items) => items === cat5.UNIQUE_ID).length > 0 || userInfo?.ROLE === 'ROLE1650614500708'){
											var obj5={value: cat5.UNIQUE_ID,
												title:cat5?.NAME,
												children:[]}
											if(cat5.CATEGORY4==cat4?.CATEGORY4_UNIQUE_ID){

												obj4.children.push(obj5)
											}
										}
										})
										obj3.children.push(obj4)
									}
								}
								})
								obj2.children.push(obj3)
							}
						}
						})
						
						obj1.children.push(obj2)
					}
				}
				})
				obj0.children.push(obj1)
			}
		}
		})
			obj_array.push(obj0)
			}
			
	})
	setTreeSelection(obj_array)
}
	},[AllCategoryJson,permision])
	const onHandaleRoles = async () => {
		const data = await getRolesById(userInfo?.ROLE);
		if (data.success === true) {
			const obj = data.data.data[0];
			setpermision({
				...obj,
				ROLES_PERMISSIONS_CATEGORY0: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY0),
				ROLES_PERMISSIONS_CATEGORY5: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY5),
				ROLES_PERMISSIONS_CATEGORY2: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY2),
				ROLES_PERMISSIONS_CATEGORY3: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY3),
				ROLES_PERMISSIONS_CATEGORY1: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY1),
				ROLES_PERMISSIONS_CATEGORY4: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY4),
				ROLES_OTHER_PERMISSIONS: JSON.parse(obj.ROLES_OTHER_PERMISSIONS)
			});
			const permissionViewCard = JSON.parse(obj?.ROLES_OTHER_PERMISSIONS)
			const infoRolesObj = { ROLES: userInfo?.ROLE, Profile: { CATEGORY0: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY0).CATEGORY0_view, CATEGORY1: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY1).CATEGORY1_view, CATEGORY2: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY2).CATEGORY2_view, CATEGORY3: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY3).CATEGORY3_view, CATEGORY4: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY4).CATEGORY4_view, CATEGORY5: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY5).CATEGORY5_view }, permissionViewCard }
            const view_json=JSON.parse(DashTabDetailById?.view_json||'{}')
			onLoadCosutomDashboardList(permissionViewCard)
			setIsUndermaintanceLoader(true)
			if(activeTab!='Custom Dashboard'||view_json[card_json[3]?.U_ID]?.display==true){
				await ongetCountStatusByGa(infoRolesObj);
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[0]?.U_ID]?.display==true){
				const day_number=(FilterDay?.filter(item=>item?.card_id==card_json[0]?.U_ID)[0]?.day_preference||7)-1
				await ongetAllGSMChartByDate({...infoRolesObj,day_number:activeTab=='Custom Dashboard'?day_number:6},true);
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[1]?.U_ID]?.display==true){
				await ongetHeatbeatStatusWiseCountInGroupDashboard(infoRolesObj)
			}
			
			if(activeTab!='Custom Dashboard'||view_json[card_json[2]?.U_ID]?.display==true){
				await	ongetGSMTotalCountByTS(infoRolesObj)
			}
			
			if(activeTab!='Custom Dashboard'||view_json[card_json[5]?.U_ID]?.display==true){
				await ongetAllMechanicalMeterTotalLora(infoRolesObj)
			}
			// if(permissionViewCard?.GSM_GROUP_DASH?.MODEM?.view?.filter((item)=>(item=='GSM_Event_Count')).length>0||userInfo?.ROLE=='ROLE1650614500708'){
			// 	ongetAllGSMEventChartByDate(infoRolesObj)
			// }
			// if(permissionViewCard?.GSM_GROUP_DASH?.MODEM?.view?.filter((item)=>(item=='GSM_Month_Bill_Count')).length>0||userInfo?.ROLE=='ROLE1650614500708'){

			// 	ongetAllGSMMonthlyChartByDate(infoRolesObj)
			// }
			if(activeTab!='Custom Dashboard'||view_json[card_json[6]?.U_ID]?.display==true){
				await ongetAllModemTotalGSM(infoRolesObj)

			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[4]?.U_ID]?.display==true){
				await ongetAllMeterTotalGSM(infoRolesObj)
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[7]?.U_ID]?.display==true){
				await ongetmodemFirmwarTotalGSM(infoRolesObj)
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[9]?.U_ID]?.display==true){
				await ongetAllRSSITotalGSM(infoRolesObj)
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[8]?.U_ID]?.display==true){
				await ongetAllBatteryTotalGSM(infoRolesObj)
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[12]?.U_ID]?.display==true){
				await ongetAllSNRyTotalGSM(infoRolesObj)
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[10]?.U_ID]?.display==true){
				await	ongetServiceProviderTotalGSM(infoRolesObj)

			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[11]?.U_ID]?.display==true){
				await ongetTagsWiseConsumerData(infoRolesObj)

			}
			// if(permissionViewCard?.GSM_GROUP_DASH?.MODEM?.view?.filter((item)=>(item=='Meter_Connectivity_Status')).length>0||userInfo?.ROLE=='ROLE1650614500708'){
			// 	ongetmodemMeterConnectivityTotalGSM(infoRolesObj)

			// }
			// if(permissionViewCard?.GSM_GROUP_DASH?.MODEM?.view?.filter((item)=>(item=='Modem_Connectivity_Status')).length>0||userInfo?.ROLE=='ROLE1650614500708'){
			// 	ongetmodemConnectivityTotalGSM(infoRolesObj)

			// }
			if(activeTab!='Custom Dashboard'||view_json[card_json[13]?.U_ID]?.display==true){
				await ongetGSM_BANDTotalGSM(infoRolesObj)

			}
			// ongetAPMTotalGSM(infoRolesObj)
			if (permissionViewCard?.GSM_GROUP_DASH?.MODEM?.view?.filter((item) => (item == 'GSM_IPV')).length > 0 || userInfo?.ROLE == 'ROLE1650614500708') {
				// ongetIPVTotalINGSM(infoRolesObj)

			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[15]?.U_ID]?.display==true){
				await	onGetInstallationDateWiseGraphData(infoRolesObj, InstallType)

			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[14]?.U_ID]?.display==true){
				await ongetUnlockLoraConsumer(infoRolesObj)
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[28]?.U_ID]?.display==true){
				await onGetLoraStatusUndermaintainaceGraphData(infoRolesObj)
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[16]?.U_ID]?.display==true){
				await ongetAllMapDataInLora(infoRolesObj)
			}
			props.setisDownloadBtnShow(true)
		} else {
			console.log("something want wrong");
		}
	};

	const ongetHeatbeatStatusWiseCountInGroupDashboard = async (info) => {
		setHeatbeatStatus({})
		const data = await getHeatbeatStatusWiseCountInLoraGroupDashboard(info)
		if (data.success === true) {
			setHeatbeatStatus(data.data.data)
		} else {
			console.log('something wait wrong')
		}
	}

	const onChangesCardWiseFilter = (value,UID,isfilter,day_no) => {
		console.log(value,UID)
		let info={}
			if(isfilter===false){
				info={ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: true,ins_no:Profile.ins_no, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }
			}else{
				const array_parent= findParent(TreeSelection,value)||[]
				setCardFilter({...CardFilter,[UID]:{ account: array_parent[0]||'', ga: array_parent[1]||'', circle: array_parent[2]||'', division:array_parent[3]||'', subdivision: array_parent[4]||'', area: array_parent[5]||'' }})
				info={ CATEGORY0: array_parent[0]||'', CATEGORY1: array_parent[1]||'', CATEGORY2: array_parent[2]||'', CATEGORY3: array_parent[3]||'', CATEGORY4: array_parent[4]||'', CATEGORY5: array_parent[5]||'', ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }
			}
			if(card_json[16]?.U_ID==UID){
		ongetAllMapDataInLora(info)
			}
			if(card_json[5]?.U_ID==UID){
		ongetAllMechanicalMeterTotalLora(info)
			}
			if(card_json[0]?.U_ID==UID){
				let day_number=6
			if(isfilter){
				day_number=(FilterDay?.filter(item=>item?.card_id==card_json[0]?.U_ID)[0]?.day_preference||7)-1
			}else{
				day_number=day_no-1
			}
			ongetAllGSMChartByDate({...info,day_number:activeTab=='Custom Dashboard'?day_number:7})
			}
		if(card_json[3]?.U_ID==UID){
		ongetCountStatusByGa(info)
		}
		if(card_json[2]?.U_ID==UID){
			ongetGSMTotalCountByTS(info)
		}
		if(card_json[4]?.U_ID==UID){
			ongetAllMeterTotalGSM(info)
		}
		if(card_json[6]?.U_ID==UID){
			ongetAllModemTotalGSM(info)
		}
		if(card_json[7]?.U_ID==UID){
			ongetmodemFirmwarTotalGSM(info)
		}
		
		if(card_json[9]?.U_ID==UID){
			ongetAllRSSITotalGSM(info)
		}
		if(card_json[8]?.U_ID==UID){
		ongetAllBatteryTotalGSM(info)
		}
		if(card_json[12]?.U_ID==UID){
		ongetAllSNRyTotalGSM(info)
		}
		if(card_json[10]?.U_ID==UID){
			ongetServiceProviderTotalGSM(info)
		}
		if(card_json[11]?.U_ID==UID){
			ongetTagsWiseConsumerData(info)
		}
		
		if(card_json[13]?.U_ID==UID){
			ongetGSM_BANDTotalGSM(info)
		}
		
		
		if(card_json[15]?.U_ID==UID){
			onGetInstallationDateWiseGraphData(info, InstallType)
		}
		if(card_json[14]?.U_ID==UID){
		ongetUnlockLoraConsumer(info)
		}
		if(card_json[1]?.U_ID==UID){
		ongetHeatbeatStatusWiseCountInGroupDashboard(info)
		}
		if(card_json[28]?.U_ID==UID){
			onGetLoraStatusUndermaintainaceGraphData(info)
		}
	}

	const onChangesProfileWiseSerch = (info) => {
		settringerMeter(true)
			const view_json=JSON.parse(DashTabDetailById?.view_json||'{}')
			if(activeTab!='Custom Dashboard'||view_json[card_json[16]?.U_ID]?.display==true){
		ongetAllMapDataInLora(info)
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[5]?.U_ID]?.display==true){
		ongetAllMechanicalMeterTotalLora(info)
			}
			if(activeTab!='Custom Dashboard'||view_json[card_json[0]?.U_ID]?.display==true){
			const day_number=(FilterDay?.filter(item=>item?.card_id==card_json[0]?.U_ID)[0]?.day_preference||7)-1
			ongetAllGSMChartByDate({...info,day_number:activeTab=='Custom Dashboard'?day_number:6})
			}
		if(activeTab!='Custom Dashboard'||view_json[card_json[3]?.U_ID]?.display==true){
		ongetCountStatusByGa(info)
		}
		if(activeTab!='Custom Dashboard'||view_json[card_json[2]?.U_ID]?.display==true){
			ongetGSMTotalCountByTS(info)
		}
		if(activeTab!='Custom Dashboard'||view_json[card_json[4]?.U_ID]?.display==true){
			ongetAllMeterTotalGSM(info)
		}
		if(activeTab!='Custom Dashboard'||view_json[card_json[6]?.U_ID]?.display==true){
			ongetAllModemTotalGSM(info)
		}
		if(activeTab!='Custom Dashboard'||view_json[card_json[7]?.U_ID]?.display==true){
			ongetmodemFirmwarTotalGSM(info)
		}
		
		if(activeTab!='Custom Dashboard'||view_json[card_json[9]?.U_ID]?.display==true){
			ongetAllRSSITotalGSM(info)
		}
		if(activeTab!='Custom Dashboard'||view_json[card_json[8]?.U_ID]?.display==true){
		ongetAllBatteryTotalGSM(info)
		}
		if(activeTab!='Custom Dashboard'||view_json[card_json[12]?.U_ID]?.display==true){
		ongetAllSNRyTotalGSM(info)
		}
		if(activeTab!='Custom Dashboard'||view_json[card_json[10]?.U_ID]?.display==true){
			ongetServiceProviderTotalGSM(info)
		}
		if(activeTab!='Custom Dashboard'||view_json[card_json[11]?.U_ID]?.display==true){
			ongetTagsWiseConsumerData(info)
		}
		// if(permision?.ROLES_OTHER_PERMISSIONS?.GSM_GROUP_DASH?.MODEM?.view?.filter((item)=>(item=='Modem_Connectivity_Status')).length>0||userInfo?.ROLE=='ROLE1650614500708'){
		// ongetmodemConnectivityTotalGSM(info)
		// }
		// if(permision?.ROLES_OTHER_PERMISSIONS?.GSM_GROUP_DASH?.MODEM?.view?.filter((item)=>(item=='Meter_Connectivity_Status')).length>0||userInfo?.ROLE=='ROLE1650614500708'){
		// ongetmodemMeterConnectivityTotalGSM(info)
		// }
		if(activeTab!='Custom Dashboard'||view_json[card_json[13]?.U_ID]?.display==true){
			ongetGSM_BANDTotalGSM(info)
		}
		// ongetAPMTotalGSM(info)
		if (permision?.ROLES_OTHER_PERMISSIONS?.GSM_GROUP_DASH?.MODEM?.view?.filter((item) => (item == 'GSM_IPV')).length > 0 || userInfo?.ROLE == 'ROLE1650614500708') {
			// ongetIPVTotalINGSM(info)
		}
		// if(permision?.ROLES_OTHER_PERMISSIONS?.GSM_GROUP_DASH?.MODEM?.view?.filter((item)=>(item=='GSM_Event_Count')).length>0||userInfo?.ROLE=='ROLE1650614500708'){
		// ongetAllGSMEventChartByDate(info)
		// }
		// if(permision?.ROLES_OTHER_PERMISSIONS?.GSM_GROUP_DASH?.MODEM?.view?.filter((item)=>(item=='GSM_Month_Bill_Count')).length>0||userInfo?.ROLE=='ROLE1650614500708'){
		// ongetAllGSMMonthlyChartByDate(info)
		// }
		if(activeTab!='Custom Dashboard'||view_json[card_json[15]?.U_ID]?.display==true){
			onGetInstallationDateWiseGraphData(info, InstallType)
		}
		if(activeTab!='Custom Dashboard'||view_json[card_json[14]?.U_ID]?.display==true){
		ongetUnlockLoraConsumer(info)
		}
		if(activeTab!='Custom Dashboard'||view_json[card_json[28]?.U_ID]?.display==true){
			onGetLoraStatusUndermaintainaceGraphData(info)
			}
		if(activeTab!='Custom Dashboard'||view_json[card_json[1]?.U_ID]?.display==true){
		ongetHeatbeatStatusWiseCountInGroupDashboard(info)
		}
	}
	const ongetAllMechanicalMeterTotalLora = async (info) => {
		setseriesMechanicalMeter([])
		setcategoryMechanicalMeter([])
		const data = await getAllMechanicalMeterTotalLora(info);

		if (data.success === true) {
			console.log(data)
			setMechancalMeterId(data?.data?.data?.map((item) => (item?.MC_TYPE||'')))
			setseriesMechanicalMeter(data?.data?.data?.map((item) => (item?.MC_length||'')));
			setcategoryMechanicalMeter(data?.data?.data?.map((item) => (item?.MC_PROFILE_NAME + ' - ' + item?.MC_length)));
		} else {
			console.log("something want warong");
		}
	};
	const ongetGSMTotalCountByTS = async (info) => {
		setletest24({})
		var remove_index = []
		const data = await getLoraTotalCountByTS(info)
		if (data.success === true) {
			setletest24(data.data.data)
			const view_json=JSON.parse(DashTabDetailById?.view_json||'{}')
			setseries1([
				(view_json[card_json[2]?.U_ID]?.bar_pemission?.includes("Heartbeat Success") || activeTab!='Custom Dashboard') && {
					name: "Heartbeat Success",
					data: [data?.data?.data?.heart_success],
				} || undefined,
				(view_json[card_json[2]?.U_ID]?.bar_pemission?.includes("Heartbeat Fail") || activeTab!='Custom Dashboard') && {
					name: "Heartbeat Fail",
					data: [data?.data?.data?.heart_fail],
				} || undefined,

				(view_json[card_json[2]?.U_ID]?.bar_pemission?.includes("DailyData Success") || activeTab!='Custom Dashboard') && {
					name: "DailyData Success",
					data: [data?.data?.data?.daily_success],
				} || undefined,
				(view_json[card_json[2]?.U_ID]?.bar_pemission?.includes("DailyData Fail") || activeTab!='Custom Dashboard') && {
					name: "DailyData Fail",
					data: [data?.data?.data?.daily_fail],
				} || undefined,
				(view_json[card_json[2]?.U_ID]?.bar_pemission?.includes("Hourly Success") || activeTab!='Custom Dashboard') && {
					name: "Hourly Success",
					data: [data?.data?.data?.hourly_success],
				} || undefined,
				(view_json[card_json[2]?.U_ID]?.bar_pemission?.includes("Hourly Fail") || activeTab!='Custom Dashboard') && {
					name: "Hourly Fail",
					data: [data?.data?.data?.hourly_fail],
				} || undefined,
				(view_json[card_json[2]?.U_ID]?.bar_pemission?.includes("Alert") || activeTab!='Custom Dashboard') && {
					name: "Alert",
					data: [data?.data?.data?.alert_count],
				} || undefined,
				(view_json[card_json[2]?.U_ID]?.bar_pemission?.includes("Timesync") || activeTab!='Custom Dashboard') && {
					name: "Timesync",
					data: [data?.data?.data?.timesync_count],
				} || undefined,
				(view_json[card_json[2]?.U_ID]?.bar_pemission?.includes("Reboot") || activeTab!='Custom Dashboard') && {
					name: "Reboot",
					data: [data?.data?.data?.reboot_count],
				} || undefined,
				(view_json[card_json[2]?.U_ID]?.bar_pemission?.includes("Status Error") || activeTab!='Custom Dashboard') && {
					name: "Status Error",
					data: [data?.data?.data?.status_err_count],
				} || undefined
			].filter((item, id) => {
				if (item == undefined) {
					remove_index.push(id)
				}
				return item != undefined
			}))
			if (activeTab=='Custom Dashboard') {

				setlora24CheckList([...lora24CheckList.filter((item, id) => !remove_index.includes(id))])
				setlora24List([...lora24List.filter((item, id) => !remove_index.includes(id))])

			}


			console.log(GSMDATAConsumerCheckList, GSMDATList)
		} else {
			console.log('something want wrong')
		}
	}
	useEffect(() => {
		setoptions1({
			chart: {
				id: "simple-bar",
				type: "bar",
				toolbar: {
					show: false,
				},
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const DATA_point = lora24List[config.seriesIndex]
						console.log(Profile,DATA_point, config.seriesIndex);
						if (lora24List[config.seriesIndex] === 'HEARTBEAT_FAIL_LIST' || lora24List[config.seriesIndex] === 'INSTANTANEOUS_FAIL_LIST' || lora24List[config.seriesIndex] === 'DAILY_FAIL_LIST' || lora24List[config.seriesIndex] === 'HOURLY_FAIL_LIST' || lora24List[config.seriesIndex] === 'MONTH_BILL_FAIL_LIST') {
							GetConsumerIncolumeName(-1, lora24CheckList[config.seriesIndex], DATA_point)
						} else {
							GetConsumerIncolumeName(true, lora24CheckList[config.seriesIndex], DATA_point)
						}
					}
				}
			},

			dataLabels: {
				enabled: true,
				// formatter: function (val) {
				//     return val + "%";
				// },
				offsetY: -20,
				style: {
					fontSize: "10px",
					fontWeight: 100,
					colors: ['rgb(154, 160, 172)'],
				},
			},
			grid: {
				padding: {
					top: 10,
					right: 20,
					bottom: 5,
					left: 40,
				},
			},

			plotOptions: {
				bar: {
					distributed: false,
					borderRadius: 3,
					columnWidth: '35%',
					dataLabels: {
						offsetY: -20,
						offsetX: 0,
						horizontal: true,
						style: {
							fontSize: "11px",
						},
						position: "top",
					},
				},
			},
			colors: ["rgb(0, 126, 51)", "rgb(50,225,79)", "rgb(51,33,113)", "rgb(120,111,206)", "rgb(0,104,138)", "rgb(85, 200, 245)", "rgb(255, 119, 0)", "rgb(240, 193, 91)", "rgb(51, 33, 113)", 'rgb(120,111,206)'],
			legend: {
				show: true,

				fontSize: "12px",
				fontWeight: 100,
				offsetY: 0,
				labels: {
					colors: 'rgb(154, 160, 172)',

				},
				itemMargin: {
					horizontal: 10,
					vertical: 3
				},
			},
			xaxis: {
				categories: [[moment().format('DD-MM-YYYY'), moment().format('ddd'), '(Live)']],
				labels: {
					show: true,

					style: {
						colors: 'rgb(154, 160, 172)',
						fontSize: "12px",
						fontWeight: 200,
					},
				},
				title: {
					text: "Date",
					rotate: 0,
					offsetX: 0,
					offsetY: 100,
					style: {
						color: 'rgb(154, 160, 172)',
						fontSize: "12px",
						fontWeight: 200,
					},
				},
			},
			yaxis: {
				tickAmount: 7,
				labels: {
					show: true,

					style: {
						colors: 'rgb(154, 160, 172)',
						fontSize: "12px",
						fontWeight: 200,
					},
					offsetX: 20,
				},
				// title: {
				//     text: "Count",
				//     rotate: -90,
				//     offsetX: 0,
				//     offsetY: 0,
				//     style: {
				//         fontSize: '11px',
				//         fontWeight: 200,
				//     },
				// },
			},
		})
	}, [GSMDATList, permision,series1])
	const ongetAllCategoryTableData = async (info) => {
		const data = await getAllCategoryTableData({})
		if (data.success === true) {
			setAllCategory(data.data.data)
		} else {
			console.log('something want wrong')
		}
	}
	useEffect(() => {
		jQuery.event.special.touchstart = {
			setup: function (_, ns, handle) {
				if (ns.includes("noPreventDefault")) {
					this.addEventListener("touchstart", handle, { passive: false });
				} else {
					this.addEventListener("touchstart", handle, { passive: true });
				}
			}
		};
		ongetAllCategoryTableData()
		if(activeTab=='Device Dashboard'||activeTab == 'Custom Dashboard'){
		onHandaleRoles()
		}
		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		})
		
	}, [activeTab]);

	const UnderMaintanceChartJs = {
		labels:lableUndermaintance,
		datasets: [
			{
				label: "Under Maintance Consumer",
				data: [UnderMaintanceData[0]&&UnderMaintanceData[0]["1_15_days"]||0,UnderMaintanceData[0]&&UnderMaintanceData[0]["16_30_day"]||0,UnderMaintanceData[0]&&UnderMaintanceData[0]["31_45_days"]||0,UnderMaintanceData[0]&&UnderMaintanceData[0]?.above_45_day||0],
				backgroundColor: 'rgb(0, 143, 251)',
				maxBarThickness: 30,
				borderColor:'rgb(0, 143, 251)',
				pointRadius: 5,
				pointHoverRadius: 7
			}
		]
	}
	const UndermainOptionChartJS = {
		responsive: true,
		maintainAspectRatio: false,
		interaction: {
			mode: chartType[card_json[28].U_ID]=='line'?'index':'nearest',
			intersect: false,
		  },
		scales: {
			x: {
				ticks: {
					font: function (context) {
						var w = context.chart.width;
						return {
							size: w < 512 ? 8 : 10,
						};
					},
				}
			}
		},
		animation: {
			duration: 0
		},

		plugins: {
			legend: {
				position: 'bottom',
				labels: {
					pointStyleWidth: 10,
					usePointStyle: true,
					pointStyle: 'rectRounded'
				}
			},
			zoom: {
				zoom: {
					wheel: {
						enabled: true // SET SCROOL ZOOM TO TRUE
					},
					mode: "x",
				},
				pan: {
					enabled: true,
					mode: "x",
				}
			},
			datalabels: {
				align: 'end',
				anchor: 'end',
				clamp: true,
				color: "black",
				padding: {
					top: 0,
					bottom: 0
				},
				font: function (context) {
					var w = context.chart.width;
					return {
						size: w < 512 ? 10 : 12,

					};
				},
			}
		},
		layout: {
			padding: {
				left: 50,
				right: 50,
				top: 20
			}
		},
	};


	const onHandalGsmChart = async (col, srno, changeTable,CARD_ID) => {
		settabShow(true)
		setModalLoad(true)
		setIsModalVisible(true)
		setModelId(`${col}`)
		let obj={}
			if(Object.keys(CardFilter[CARD_ID]||{}).length){
				obj={ colName: col, SRNO: srno, changeTable: changeTable, CATEGORY0: CardFilter[CARD_ID].account, CATEGORY1: CardFilter[CARD_ID].ga, CATEGORY2: CardFilter[CARD_ID].circle, CATEGORY3: CardFilter[CARD_ID].division, CATEGORY4: CardFilter[CARD_ID].subdivision, CATEGORY5: CardFilter[CARD_ID].area, ROLES: userInfo?.ROLE, serach: true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }
			}else{
				obj={ colName: col, SRNO: srno, changeTable: changeTable, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE,ins_no:Profile.ins_no, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === ''&& Profile?.ins_no?.length==0 ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }
			}
		const data = await lora_instantaneous_day_wise_graph_details(obj)
		if (data.success === true) {
			setTableDataInApi(JSON.parse(data.data.data[0][col] || '[]').map((item) => ({ UNIQUE_ID: item?.UNIQUE_ID, DEVICE_SERIAL_NO: item?.DEVICE_SERIAL_NO, address_compony_name: item?.address_compony_name, RSSI: item?.HEARTBEAT_LAST_DATA?.LRSSI, SNR: item?.HEARTBEAT_LAST_DATA?.LSNR, CAT0_ID: item?.Profile?.CATEGORY0, CAT1_ID: item?.Profile?.CATEGORY1, CAT2_ID: item?.Profile?.CATEGORY2, CAT3_ID: item?.Profile?.CATEGORY3, CAT4_ID: item?.Profile?.CATEGORY4, CAT5_ID: item?.Profile?.CATEGORY5 })))
			setModalLoad(false)

		} else {
			console.log('something want wrong')
			setModalLoad(false)

		}
	}

	const GetConsumerIncolumeName = async (isbetween, col, colname, value,CARD_ID) => {
		setModelId(`${colname}`)
		setIsModalVisible(true)
		setModalLoad(true)
		console.log(permision)
		let obj={}
			if(Object.keys(CardFilter[CARD_ID]||{}).length){
				obj={ isbetween: isbetween, colName: col, value: value, CATEGORY0: CardFilter[CARD_ID]?.account, CATEGORY1: CardFilter[CARD_ID]?.ga, CATEGORY2: CardFilter[CARD_ID]?.circle, CATEGORY3: CardFilter[CARD_ID]?.division, CATEGORY4: CardFilter[CARD_ID]?.subdivision, CATEGORY5: CardFilter[CARD_ID]?.area, ROLES: userInfo?.ROLE, serach:true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }
			}else{
				obj={ isbetween: isbetween, colName: col, value: value, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE,ins_no:Profile.ins_no, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === ''&& Profile?.ins_no?.length==0 ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }
			}
		const data = await onGetLoraConsumerIncolumeName(obj)
		if (data.success === true) {
			setTableDataInApi(data.data.data)
			setModalLoad(false)

		} else {
			console.log('somthing want wrong')
			setModalLoad(false)

		}
	}

	const ongetUnlockLoraConsumer = async (info) => {
		setUnlockBrand({ series: [], categories: [] })
		const data = await getUnlockLORAConsumer(info);
		if (data.success === true) {
			const obj = { series: [data?.data?.data?.locked || 0, data?.data?.data?.unlocked || 0], categories: ["Locked" + '(' + (data?.data?.data?.locked || 0) + ')', "Unlocked" + '(' + (data?.data?.data?.unlocked || 0) + ')'] }
			setUnlockBrand(obj);
		} else {
			setUnlockBrand({ series: [0, 0], categories: ["Locked", "Unlocked"] });
			console.log("something want warong");
		}
	}

	let colors = ['#008ffb', '#00e396', '#feb019', '#ff4560', '#775dcf', '#FF7700', '#554994', "#D36B00", "#0096FF"];




	var option16 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					if(date_index==0){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=1 AND CONSUMER_SUB_STATUS=1`,card_json[3]?.U_ID)
					}else if(date_index==1){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=1 AND CONSUMER_SUB_STATUS=2`,card_json[3]?.U_ID)
					}else if(date_index==2){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=0 AND CONSUMER_SUB_STATUS=3`,card_json[3]?.U_ID)
					}else if(date_index==3){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=0 AND CONSUMER_SUB_STATUS=4`,card_json[3]?.U_ID)
					}else if(date_index==4){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=-1`,card_json[3]?.U_ID)
					}else if(date_index==5){
						GetConsumerIncolumeName('NO', '', BlankData[date_index], `CUSTOMER_STATUS=2`,card_json[3]?.U_ID)
					}
				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: BlankData && BlankData.map((item, id) => (item + `(${tableData[id]})`)),
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return tableData[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: ['#00e396','#00e396','#ff4560','#ff4560','#feb019','#008ffb']

	};

	const seriesMonth = [
		{
			name: "Monthly Success",
			data: AllGSMMonthChartData?.month_success,
		},
		{
			name: "Monthly Fail",
			data: AllGSMMonthChartData?.month_fail,
		}
	];
	const optionsMonth = {
		chart: {
			id: "simple-bar",
			type: "bar",
			toolbar: {
				show: false,
			},
			events: {
				dataPointSelection: function (event, chartContext, config) {
					const DATA_point = MonthList[config.seriesIndex]
					console.log(MonthList[config.seriesIndex], config.dataPointIndex, config.seriesIndex);
					if (config.dataPointIndex === 6) {
						if (DATA_point === 'MONTH_BILL_FAIL_LIST') {
							GetConsumerIncolumeName(false, 'EMT_TS_BILL', DATA_point, `MONTH(EMT_TS_BILL)!='${moment(DateMonthInLong[config.dataPointIndex], 'MMMM-YYYY').format('MM')}' AND YEAR(EMT_TS_BILL)='${moment(DateMonthInLong[config.dataPointIndex], 'MMMM-YYYY').format('YYYY')}' or EMT_TS_BILL is null`)
						} else {
							GetConsumerIncolumeName(false, 'EMT_TS_BILL', DATA_point, `MONTH(EMT_TS_BILL)='${moment(DateMonthInLong[config.dataPointIndex], 'MMMM-YYYY').format('MM')}' AND YEAR(EMT_TS_BILL)='${moment(DateMonthInLong[config.dataPointIndex], 'MMMM-YYYY').format('YYYY')}'`)
						}
					} else {
						onHandalGsmChart(MonthList[config.seriesIndex], AllGSMMonthChartData.SRNO[config.dataPointIndex], true)
					}
				}
			}
		},
		dataLabels: {
			enabled: true,
			// formatter: function (val) {
			//     return val + "%";
			// },
			offsetY: -20,
			style: {
				fontSize: "10px",
				fontWeight: 100,
				colors: ["#304758"],
			},
		},
		grid: {
			padding: {
				top: 10,
				right: 20,
				bottom: 5,
				left: 40,
			},
		},

		plotOptions: {
			bar: {
				distributed: false,
				borderRadius: 3,
				borderRadiusApplication: 'end',
				columnWidth: '35%',
				dataLabels: {
					offsetY: -20,
					offsetX: 0,
					horizontal: true,
					style: {
						fontSize: "11px",
					},
					position: "top",
				},
			},
		},
		colors: ["rgb(0, 126, 51)", "rgb(50,225,79)", "rgb(51, 181, 229)", "rgb(0, 153, 204)", "rgb(255, 187, 51)", "rgb(255, 119, 0)"],

		legend: {
			show: true,
			fontFamily: 'Helvetica, Arial',
			fontSize: "12px",
			labels: {
				colors: 'rgb(154, 160, 172)',

			},
			itemMargin: {
				horizontal: 10,
				vertical: 3
			},
			fontWeight: 100,
			offsetY: 0,
		},
		xaxis: {
			categories: DateMonthInLong,
			labels: {
				show: true,
				style: {
					colors: 'rgb(154, 160, 172)',
					fontSize: "12px",
					fontWeight: 200,
				},
			},
			title: {
				text: "Date",
				rotate: 0,
				offsetX: 0,
				offsetY: 100,
				style: {
					fontSize: "12px",
					fontWeight: 200,
					color: 'rgb(154, 160, 172)',
				},
			},
		},
		yaxis: {
			tickAmount: 7,
			labels: {
				show: true,
				style: {
					colors: 'rgb(154, 160, 172)',
					fontSize: "12px",
					fontWeight: 200,
				},
				offsetX: 20,
			},
			title: {
				text: "Count",
				rotate: -90,
				offsetX: 0,
				offsetY: 0,
				style: {
					color: 'rgb(154, 160, 172)',
					fontSize: "12px",
					fontWeight: 200,
				},
			},
		},
	};

	var options16 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					if (date_index == 0) {
						GetConsumerIncolumeName(false, '', UnlockBrand.categories[date_index], `UNLOCK_STATUS=0 OR UNLOCK_STATUS IS NULL`,card_json[14]?.U_ID)
					} else {
						GetConsumerIncolumeName(false, '', UnlockBrand.categories[date_index], `UNLOCK_STATUS=1`,card_json[14]?.U_ID)
					}
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: UnlockBrand.categories,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return UnlockBrand.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: ['rgb(0, 227, 150)', 'rgb(255, 69, 96)']
	};
	// const seriesEvent = [
	// 	{
	// 		name: "Volt Event",
	// 		data: AllGSMEventChartData?.volt,
	// 	},
	// 	{
	// 		name: "Current Event",
	// 		data: AllGSMEventChartData?.current,
	// 	},
	// 	{
	// 		name: "Power Event",
	// 		data: AllGSMEventChartData?.power,
	// 	},
	// 	{
	// 		name: "Other Event",
	// 		data: AllGSMEventChartData?.other,
	// 	},
	// 	{
	// 		name: "Transaction Event",
	// 		data: AllGSMEventChartData?.transection,
	// 	}, {
	// 		name: "Nonrollover Event",
	// 		data: AllGSMEventChartData?.nonrollover,
	// 	}, {
	// 		name: "Control Event",
	// 		data: AllGSMEventChartData?.control,
	// 	}
	// ];
	// const optionsEvent = {
	// 	chart: {
	// 		id: "simple-bar",
	// 		type: "bar",
	// 		toolbar: {
	// 			show: false,
	// 		},
	// 		events: {
	// 			dataPointSelection: function (event, chartContext, config) {
	// 				const DATA_point = GSMEventList[config.seriesIndex]
	// 				console.log(config.dataPointIndex);
	// 				if (config.dataPointIndex === 6) {
	// 					if (DATA_point === 'HEARTBEAT_FAIL_LIST' || DATA_point === 'INSTANTANEOUS_FAIL_LIST' || DATA_point === 'DAILY_LOAD_FAIL_LIST' || DATA_point === 'LOAD_SURVEY_FAIL_LIST' || DATA_point === 'MONTH_BILL_FAIL_LIST') {
	// 						GetConsumerIncolumeName(false, GSMEventConsumerCheckList[config.seriesIndex], DATA_point, `DATE(${GSMEventConsumerCheckList[config.seriesIndex]})!='${moment(DateEventInLong[config.dataPointIndex], 'DD-MM-YYYY').format('YYYY-MM-DD')}'`)
	// 					} else {
	// 						GetConsumerIncolumeName(false, GSMEventConsumerCheckList[config.seriesIndex], DATA_point, `DATE(${GSMEventConsumerCheckList[config.seriesIndex]})='${moment(DateEventInLong[config.dataPointIndex], 'DD-MM-YYYY').format('YYYY-MM-DD')}'`)
	// 					}
	// 				} else {
	// 					onHandalGsmChart(DATA_point, AllGSMEventChartData.SRNO[config.dataPointIndex], false)
	// 				}
	// 			}
	// 		}
	// 	},

	// 	dataLabels: {
	// 		enabled: true,
	// 		// formatter: function (val) {
	// 		//     return val + "%";
	// 		// },
	// 		offsetY: -20,
	// 		style: {
	// 			fontSize: "10px",
	// 			fontWeight: 100,
	// 			colors: ["#304758"],
	// 		},
	// 	},
	// 	grid: {
	// 		padding: {
	// 			top: 10,
	// 			right: 20,
	// 			bottom: 5,
	// 			left: 40,
	// 		},
	// 	},

	// 	plotOptions: {
	// 		bar: {
	// 			columnWidth: '50%',
	// 			distributed: false,
	// 			borderRadius: 3,
	// 			dataLabels: {
	// 				offsetY: -20,
	// 				offsetX: 0,
	// 				horizontal: true,
	// 				style: {
	// 					fontSize: "11px",
	// 				},
	// 				position: "top",
	// 			},
	// 		},
	// 	},
	// 	colors: ["rgb(0, 200, 81)", "rgb(0, 126, 51)", "rgb(51, 181, 229)", "rgb(0, 153, 204)", "rgb(255, 187, 51)", "rgb(255, 119, 0)"],

	// 	legend: {
	// 		show: true,
	// 		fontFamily: 'Helvetica, Arial',
	// 		fontSize: "12px",
	// 		labels: {
	// 			colors: 'rgb(154, 160, 172)',

	// 		},
	// 		itemMargin: {
	// 			horizontal: 10,
	// 			vertical: 3
	// 		},
	// 		fontWeight: 100,
	// 		offsetY: 0,
	// 	},
	// 	xaxis: {
	// 		categories: DateEventInLong,
	// 		labels: {
	// 			show: true,
	// 			style: {
	// 				colors: 'rgb(154, 160, 172)',
	// 				fontSize: "12px",
	// 				fontWeight: 200,
	// 			},
	// 		},
	// 		title: {
	// 			text: "Date",
	// 			rotate: 0,
	// 			offsetX: 0,
	// 			offsetY: 0,
	// 			style: {
	// 				fontSize: "12px",
	// 				fontWeight: 200,
	// 				color: 'rgb(154, 160, 172)',
	// 			},
	// 		},
	// 	},
	// 	yaxis: {
	// 		tickAmount: 7,
	// 		labels: {
	// 			show: true,
	// 			style: {
	// 				colors: 'rgb(154, 160, 172)',
	// 				fontSize: "12px",
	// 				fontWeight: 200,
	// 			},
	// 			offsetX: 20,
	// 		},
	// 		title: {
	// 			text: "Count",
	// 			rotate: -90,
	// 			offsetX: 0,
	// 			offsetY: 0,
	// 			style: {
	// 				color: 'rgb(154, 160, 172)',
	// 				fontSize: "12px",
	// 				fontWeight: 200,
	// 			},
	// 		},
	// 	},
	// };

	const onChartItemClick = (id, name, color) => {
		setColorText(color)
		setIsModalVisible(true)
		setModelId(`${name}`)
		onMeterDataModalShow(ModemId[id], 'MODEM_TYPE')
	}


	const onMeterTableClick = (id, name, color) => {
		setIsModalVisible(true)
		setModelId(`${name}`)
		setColorText(color)

		onMeterDataModalShow(MeterId[id], 'METER_TYPE')
	}

	const onServiceClick = (id, name, color) => {
		setIsModalVisible(true)
		setModelId(`${name}`)
		setColorText(color)

		onMeterDataModalShow(serviceProvid.category[id].split('(')[0], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LDR')")
	}

	const onFrimwarTableClick = (id, name, color) => {
		setIsModalVisible(true)
		setModelId(`${name}`)
		setColorText(color)
		onMeterDataModalShow(name, "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.VERINT')")
	}
	const onMechanicalMeterTableClick = (id, name, color) => {
		setIsModalVisible(true)
		setModelId(`${name}`)
		setColorText(color)

		onMeterDataModalShow(MechancalMeterId[id], 'MECHANICAL_TYPE')
	}
	const onMeterDataModalShow = async (id, colName,CARD_ID) => {
		console.log(Profile);
		setModalLoad(true)
		let obj={}
			if(Object.keys(CardFilter[CARD_ID]||{}).length){
				obj={ colName: colName, value: id, CATEGORY0: CardFilter[CARD_ID]?.account, CATEGORY1: CardFilter[CARD_ID]?.ga, CATEGORY2: CardFilter[CARD_ID]?.circle, CATEGORY3: CardFilter[CARD_ID]?.division, CATEGORY4: CardFilter[CARD_ID]?.subdivision, CATEGORY5: CardFilter[CARD_ID]?.area, ROLES: userInfo?.ROLE, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }
			}else{
				obj={ colName: colName, value: id, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE,ins_no:Profile.ins_no, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }
			}
		const data = await onGetLoraConsumerDetailsByColumn(obj)
		if (data.success === true) {
			setTableDataInApi(data.data.data)
			setModalLoad(false)

		} else {
			console.log('something want wrong')
			setModalLoad(false)
		}
	}

	const onHandalRssiInConsummer = async (name, color, colName, start, end,CARD_ID) => {
		setModelId(`${name}`)
		setModalLoad(true)
		setColorText(color)
		setIsModalVisible(true)
		let obj={}
			if(Object.keys(CardFilter[CARD_ID]||{}).length){
				obj={ colName: colName, start: start, end: end, CATEGORY0: CardFilter[CARD_ID]?.account, CATEGORY1: CardFilter[CARD_ID]?.ga, CATEGORY2: CardFilter[CARD_ID]?.circle, CATEGORY3: CardFilter[CARD_ID]?.division, CATEGORY4: CardFilter[CARD_ID]?.subdivision, CATEGORY5: CardFilter[CARD_ID]?.area, ROLES: userInfo?.ROLE, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }
			}else{
				obj={ colName: colName, start: start, end: end, CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE,ins_no:Profile.ins_no, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }
			}
		const data = await onGetLoraConsumerDetailsByColumnBetween(obj)
		if (data.success === true) {
			setTableDataInApi(data.data.data)
			setModalLoad(false)
		} else {
			console.log('something want wrong')
			setModalLoad(false)
		}
	}
	var options2 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;

					onChartItemClick(date_index, categoryModem[date_index], chartContext.w.globals.colors[date_index])
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: categoryModem,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return seriesModem[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};

	var options4 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					console.log(seriesFirmwar);
					//var bar_index = config.seriesIndex;
					console.log(UplinkFirm[date_index], date_index, UplinkFirm);
					if (UplinkFirm[date_index] == null) {
						GetConsumerIncolumeName(false, '', UplinkFirm[date_index], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.VERINT') IS NULL`,card_json[7]?.U_ID)

					} else {
						onFrimwarTableClick(date_index, UplinkFirm[date_index], chartContext.w.globals.colors[date_index].split('(')[0],card_json[7]?.U_ID)
					}
					// alert(categoryFirmwar[date_index] + " - " + seriesFirmwar[date_index]);
				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: categoryFirmwar,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return seriesFirmwar[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};

	var options14 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					// 	//var bar_index = config.seriesIndex;
					console.log(chartContext.w.globals.colors, config.seriesIndex, config.dataPointIndex);
					if (config.dataPointIndex == 0) {
						onHandalRssiInConsummer(serisBAT[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER')", 0, 20,card_json[8]?.U_ID)
					} else if (config.dataPointIndex == 1) {
						onHandalRssiInConsummer(serisBAT[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER')", 21, 40,card_json[8]?.U_ID)
					} else if (config.dataPointIndex == 2) {
						onHandalRssiInConsummer(serisBAT[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER')", 41, 60,card_json[8]?.U_ID)
					} else if (config.dataPointIndex == 3) {
						onHandalRssiInConsummer(serisBAT[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER')", 61, 80,card_json[8]?.U_ID)
					} else if (config.dataPointIndex == 4) {
						onHandalRssiInConsummer(serisBAT[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER')", 81, 100,card_json[8]?.U_ID)
					} else if (config.dataPointIndex == 5) {
						GetConsumerIncolumeName(false, '', serisBAT[date_index], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.BAT_PER') IS NULL`,card_json[8]?.U_ID)
					}
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: serisBAT.map((item, id) => (item + `(${categoryBAT[id]})`)),
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return categoryBAT[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};
	var options15 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					// 	//var bar_index = config.seriesIndex;
					console.log(chartContext.w.globals.colors, config.seriesIndex, config.dataPointIndex);
					if (config.dataPointIndex == 0) {
						GetConsumerIncolumeName(false, '', seriesSNR[date_index], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LSNR')<=-12`,card_json[12]?.U_ID)
					} else if (config.dataPointIndex == 1) {
						GetConsumerIncolumeName(false, '', seriesSNR[date_index], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LSNR')<=-7.0 AND JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LSNR')>-12.0`,card_json[12]?.U_ID)
					} else if (config.dataPointIndex == 2) {
						GetConsumerIncolumeName(false, '', seriesSNR[date_index], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LSNR')<=2.0 AND JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LSNR')>-7.0`,card_json[12]?.U_ID)
					} else if (config.dataPointIndex == 3) {
						GetConsumerIncolumeName(false, '', seriesSNR[date_index], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LSNR')<=7.0 AND JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LSNR')>2.0`,card_json[12]?.U_ID)
					} else if (config.dataPointIndex == 4) {
						GetConsumerIncolumeName(false, '', seriesSNR[date_index], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LSNR')>7`,card_json[12]?.U_ID)
					}

				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: seriesSNR.map((item, id) => (item + ` (${categorySNR[id]})`)),
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return categorySNR[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};
	var options17 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					//var bar_index = config.seriesIndex;
					// console.log(chartContext.w.globals.colors,config.seriesIndex,config.dataPointIndex);
					onMechanicalMeterTableClick(date_index, categoryMechanicalMeter[date_index], chartContext.w.globals.colors[date_index])
					// alert(categoryMeter[date_index] + " - " + seriesMeter[date_index]);
				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: categoryMechanicalMeter,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return seriesMechanicalMeter[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};

	var options3 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					//var bar_index = config.seriesIndex;
					// console.log(chartContext.w.globals.colors,config.seriesIndex,config.dataPointIndex);
					if (!categoryMeter[date_index] == null) {
						GetConsumerIncolumeName(false, '', seriesSNR[date_index], `METER_TYPE IS null OR METER_TYPE=''`,card_json[4]?.U_ID)
					} else {
						onMeterTableClick(date_index, categoryMeter[date_index], chartContext.w.globals.colors[date_index],card_json[4]?.U_ID)
					}
					// alert(categoryMeter[date_index] + " - " + seriesMeter[date_index]);
				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: categoryMeter,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return seriesMeter[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};

	var options6 = {
		chart: {
			//    width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					// 	//var bar_index = config.seriesIndex;
					console.log(chartContext.w.globals.colors, config.seriesIndex, config.dataPointIndex);
					if (config.dataPointIndex == 0) {
						onHandalRssiInConsummer(seriesRSSI[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LRSSI')", -150, -111,card_json[6]?.U_ID)
					} else if (config.dataPointIndex == 1) {
						onHandalRssiInConsummer(seriesRSSI[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LRSSI')", -110, -96,card_json[6]?.U_ID)
					} else if (config.dataPointIndex == 2) {
						onHandalRssiInConsummer(seriesRSSI[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LRSSI')", -95, -81,card_json[6]?.U_ID)
					} else if (config.dataPointIndex == 3) {
						onHandalRssiInConsummer(seriesRSSI[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LRSSI')", -80, -52,card_json[6]?.U_ID)
					} else if (config.dataPointIndex == 4) {
						onHandalRssiInConsummer(seriesRSSI[date_index], chartContext.w.globals.colors[date_index], "JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LRSSI')", -51, 0,card_json[6]?.U_ID)
					} else if (config.dataPointIndex == 5) {
						GetConsumerIncolumeName(false, '', seriesRSSI[date_index], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LRSSI') IS NULL`,card_json[9]?.U_ID)
					}

				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: seriesRSSI,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return categoryRSSI[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};
	var options7 = {
		chart: {
			height: 350,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					// 	//var bar_index = config.seriesIndex;
					console.log(chartContext.w.globals.colors, config.seriesIndex, config.dataPointIndex);
					onServiceClick(config.dataPointIndex, serviceProvid.category[config.dataPointIndex].split('(')[0], chartContext.w.globals.colors[date_index])
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150
		},

		labels: serviceProvid.category,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return serviceProvid.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}
			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors

	};

	var options8 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;

					GetConsumerIncolumeName(false, '', tagsCount.category[date_index].split('(')[0], `TAGS LIKE '%${tagsCount.id[date_index]}%'`,card_json[11]?.U_ID)
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: tagsCount.category,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return tagsCount.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};
	var options9 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;

					GetConsumerIncolumeName(false, '', MCOMST.category[date_index].split('(')[0], `MCOMST=${MCOMST.code[date_index]}`)
				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: MCOMST.category,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return MCOMST.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};
	var options10 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					GetConsumerIncolumeName(false, '', DEVICE_STATUS.categories[date_index].split('(')[0], `MMD_STATUS_ONLINE_OFFLINE='${DEVICE_STATUS.categories[date_index].split('(')[0]}'`)
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: DEVICE_STATUS.categories,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return DEVICE_STATUS.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: [DEVICE_STATUS?.categories[0]?.split('(')[0] === 'online' ? '#54ca68' : '#fc544b', DEVICE_STATUS?.categories[1]?.split('(')[0] === 'offline' ? '#fc544b' : '#54ca68']
	};
	var options11 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;

					GetConsumerIncolumeName(false, '', GSM_BAND.categories[date_index].split('(')[0], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LSF')='${GSM_BAND.categories[date_index].split('(')[0]}'`,card_json[13]?.U_ID)
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: GSM_BAND.categories,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return GSM_BAND.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};
	var options13 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;

					GetConsumerIncolumeName(false, '', APM.category[date_index].split('(')[0], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.APN')='${APM.category[date_index].split('(')[0]}'`)
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: APM.category,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return APM.series[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};
	const handleCancel = () => {
		setIsModalVisible(false);
		settabShow(false)
		setTimeout(() => {
			setTableDataInApi([])
		}, 100)

	};
	const onHandaleViewGSM = (id) => {
		window.open(`/view_existing_consumer_lorawan/${id}`, '_blank')
	}

	const [NameObj, setNameObj] = useState({})
	const ongetProfilNameByAccountId = async (id) => {
		const data = await getProfilNameByAccountId({ ID: id })
		if (data.success === true) {
			setNameObj(JSON.parse(data?.data?.data[0]?.PROFILE_NAME || '{}'))
		} else {
			console.log('something want wrong')
		}
	}
	

	const onProfileWiseSearchClick = () => {
		onChangesProfileWiseSerch({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: true,ins_no:Profile.ins_no, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view }, permissionViewCard: permision?.ROLES_OTHER_PERMISSIONS });
	}

	function getSecondsTodayBydate(ts) {
		var now = moment().add(-moment().utcOffset(), "m").format("DD/MM/YYYY HH:mm:ss");
		var then = moment.utc(ts).add(-moment().utcOffset(), "m").format("DD/MM/YYYY HH:mm:ss");
		return moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(then, "DD/MM/YYYY HH:mm:ss"), 'second')
	}

	// const labelsForChartJS = dateInLong
	// colors: ["rgb(0, 200, 81)", "rgb(0, 126, 51)", "rgb(51, 181, 229)", "rgb(0, 153, 204)", "rgb(255, 187, 51)", "rgb(255, 119, 0)"],
	const InstallChartJs = {
		labels: installData && installData.map((item) => (InstallType == 'Days' ? [moment(item?.dates).format('DD-MM-YYYY'), moment(item?.dates).format('ddd')] : InstallType == 'Weeks' ? item?.dates : item?.dates)),
		datasets: [
			{
				label: "Installation",
				data: installData && installData.map((item) => (item.total)),
				backgroundColor: 'rgb(0, 200, 81)',
				maxBarThickness: 30,
				borderColor:'rgb(0, 200, 81)',
				pointRadius: 5,
				pointHoverRadius: 7
			}
		]
	}
	const InstallOptionChartJS = {
		responsive: true,
		maintainAspectRatio: false,
		interaction: {
			mode: chartType[card_json[15].U_ID]=='line'?'index':'nearest',
			intersect: false,
		  },
		scales: {
			x: {
				ticks: {
					font: function (context) {
						var w = context.chart.width;
						return {
							size: w < 512 ? 8 : 10,
						};
					},
				}
			}
		},
		animation: {
			duration: 0
		},

		plugins: {
			legend: {
				position: 'bottom',
				labels: {
					pointStyleWidth: 10,
					usePointStyle: true,
					pointStyle: 'rectRounded'
				}
			},
			zoom: {
				zoom: {
					wheel: {
						enabled: true // SET SCROOL ZOOM TO TRUE
					},
					mode: "x",
				},
				pan: {
					enabled: true,
					mode: "x",
				}
			},
			datalabels: {
				align: 'end',
				anchor: 'end',
				clamp: true,
				color: "black",
				padding: {
					top: 0,
					bottom: 0
				},
				font: function (context) {
					var w = context.chart.width;
					return {
						size: w < 512 ? 10 : 12,

					};
				},
			}
		},
		layout: {
			padding: {
				left: 50,
				right: 50,
				top: 20
			}
		},
		// onClick: (event) => {
		// 	console.log(getElementAtEvent(chartRef.current, event));
		// 	console.log("first")
		// 	// getElementsAtEvent(elements)
		// 	// const chart = chartRef.current;
		// 	// const element = chart.getElementAtEvent(event)[0];
		// 	// const dataset = chart.data.datasets[element._datasetIndex];
		// 	// const xLabel = chart.data.labels[element._index];
		// 	// const value = dataset.data[element._index];
		// 	// console.log(dataset.label + " at " + xLabel + ": " + value);
		// },
	};

	let delayed;
	const optionsForChartJS = {
		responsive: true,
		maintainAspectRatio: false,
		interaction: {
			mode: chartType[card_json[0].U_ID]=='line'?'index':'nearest',
			intersect: false,
		  },
		scales: {
			x: {

				ticks: {
					maxRotation: 90,

				}
			}
		},
		animation: false,
		plugins: {
			legend: {
				position: 'bottom',
				fullSize: false,
				labels: {
					pointStyleWidth: 10,
					usePointStyle: true,
					pointStyle: 'rectRounded',
					padding: 5,
					font: function (context) {
						var w = context.chart.width;
						return {
							size: w < 512 ? 8 : 11,
						};
					},
				}
			},
			zoom: {
				zoom: {
					wheel: {
						enabled: true,
						modifierKey: 'ctrl' // SET SCROOL ZOOM TO TRUE
					},
					mode: "x",
				},
				pan: {
					enabled: true,
					mode: "x",
				}
			},
			datalabels: {
				align: 'end',
				anchor: 'end',
				clamp: true,
				color: "black",
				padding: {
					top: 0,
					bottom: 0
				},
				font: function (context) {
					var w = context.chart.width;
					return {
						size: w < 512 ? 10 : 12,

					};
				},

			}
		},
		layout: {
			padding: {
				left: 50,
				right: 50,
				top: 20
			}
		},
	};
	var options12 = {
		chart: {
			//  width: "80%",
			height: 350,
			// offsetY: -20,
			type: 'pie',
			events: {
				dataPointSelection(event, chartContext, config) {
					var date_index = config.dataPointIndex;
					console.log(IPV.categories[date_index]);
					GetConsumerIncolumeName(false, '', IPV.categories[date_index], `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.IPV4V6')=${IPV.categories[date_index].split('(')[0] == 'IPV4' ? '1' : IPV.categories[date_index].split('(')[0] == 'IPV6' ? '2' : '3'}`)
					//var bar_index = config.seriesIndex;
					// alert(categoryModem[date_index] + " - " + seriesModem[date_index]);

				},
				dataPointMouseEnter: function (event) {
					event.path[0].style.cursor = "pointer";
				}
			}

		},
		legend: {
			position: 'right',
			verticalAlign: 'bottom',
			//   offsetY: -20,
			//   floating: false,
			width: 150

		},

		labels: IPV.categories,
		dataLabels: {
			enabled: true,
			textAnchor: "start",
			formatter: function (val, opt) {
				return IPV.IPV[opt.seriesIndex];
			},
			offsetX: 0,
		},
		responsive: [{
			breakpoint: 1500,
			options: {
				chart: {
					width: "100%",

				},
				legend: {
					position: 'right',
					width: 150
				}

			}
		}, {
			breakpoint: 1300,
			options: {
				chart: {
					// width: "100%",
					height: 530
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 1100,
			options: {
				chart: {
					// width: "100%",
					height: 400
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 700,
			options: {
				chart: {
					// width: "100%",
					height: 700
				},
				legend: {
					position: 'bottom',
					width: "100%",
					height: 100
				}
			}
		}, {
			breakpoint: 500,
			options: {
				chart: {
					width: "100%",
					height: 'auto'
				},
				legend: {
					show: false
				}
			}
		}],
		colors: colors
	};

	const onClick = (event) => {
		// console.log(getElementsAtEvent(chartRef.current, event));
		const { datasetIndex, index } = getElementAtEvent(chartRef.current, event)[0] || {};
		// console.log(datasetIndex, index)
		// console.log((getElementAtEvent(chartRef.current, event)[0]));
		const DATA_point = GSMDATList[datasetIndex]
		if (DATA_point) {
			if (index === 6) {
				if (GSMDATList[datasetIndex] === 'HEARTBEAT_FAIL_LIST' || GSMDATList[datasetIndex] === 'INSTANTANEOUS_FAIL_LIST' || GSMDATList[datasetIndex] === 'DAILY_FAIL_LIST' || GSMDATList[datasetIndex] === 'HOURLY_FAIL_LIST' || GSMDATList[datasetIndex] === 'MONTH_BILL_FAIL_LIST') {
					GetConsumerIncolumeName(false, GSMDATAConsumerCheckList[datasetIndex], DATA_point, `DATE(${GSMDATAConsumerCheckList[datasetIndex]})!='${moment(dateInLong[index], 'DD-MM-YYYY').format('YYYY-MM-DD')}' or ${GSMDATAConsumerCheckList[datasetIndex]} is null`,card_json[0]?.U_ID)
				} else {
					GetConsumerIncolumeName(false, GSMDATAConsumerCheckList[datasetIndex], DATA_point, `DATE(${GSMDATAConsumerCheckList[datasetIndex]})='${moment(dateInLong[index], 'DD-MM-YYYY').format('YYYY-MM-DD')}' `,card_json[0]?.U_ID)
				}
			} else {
				onHandalGsmChart(GSMDATList[datasetIndex], AllGSMChartData.SRNO[index], false,card_json[0]?.U_ID)
			}
		}
	}

	const onClickInstall = (event) => {
		// console.log(getElementsAtEvent(chartRef.current, event));
		const { datasetIndex, index } = getElementAtEvent(InstallChartRef.current, event)[0] || {};
		// console.log((getElementAtEvent(chartRef.current, event)[0]));
		const DATA_point = installData[index].dates ? moment(installData[index].dates).format('YYYY-MM-DD') : ''
		console.log(datasetIndex, index, event, DATA_point)
		if (DATA_point) {
			GetConsumerIncolumeName('NO', `DATE(STR_TO_DATE(INSTALLATION_DETAILS->>'$.Installation_Date_And_Time','%d-%m-%Y'))`, `Installation Date(${moment(DATA_point, 'YYYY-MM-DD').format('DD-MM-YYYY')})`, `DATE(STR_TO_DATE(INSTALLATION_DETAILS->>'$.Installation_Date_And_Time','%d-%m-%Y'))='${DATA_point}'`,card_json[15]?.U_ID)

		}
	}

	const onExClickInstall = (event) => {
		// console.log(getElementsAtEvent(chartRef.current, event));
		const { datasetIndex, index } = getElementAtEvent(expandChartRef.current, event)[0] || {};
		// console.log((getElementAtEvent(chartRef.current, event)[0]));
		const DATA_point = exInstallationChartData?.date[index] ? moment(exInstallationChartData?.date[index], 'DD-MM-YYYY').format('YYYY-MM-DD') : ''
		console.log(datasetIndex, index, event, DATA_point, exInstallationChartData)
		if (DATA_point) {
			GetConsumerIncolumeName('NO', `DATE(STR_TO_DATE(INSTALLATION_DETAILS->>'$.Installation_Date_And_Time','%d-%m-%Y'))`, `Installation Date(${moment(DATA_point, 'YYYY-MM-DD').format('DD-MM-YYYY')})`, `DATE(STR_TO_DATE(INSTALLATION_DETAILS->>'$.Installation_Date_And_Time','%d-%m-%Y'))='${DATA_point}'`,card_json[15]?.U_ID)
		}
	}
	// const myChart = chartRef.current;
	// setTimeout(() => {
	// 	myChart.zoom(2);
	// 	myChart.update()
	// 	// myChart.pan({
	// 	// 	x: Number.MAX_SAFE_INTEGER
	// 	// }, undefined, 'default');
	// })



	const onClickForEvent = (event) => {
		const { datasetIndex, index } = getElementAtEvent(eventChartRef.current, event)[0] || {};
		const DATA_point = GSMEventList[datasetIndex]
		if (DATA_point) {
			if (index === 6) {
				if (DATA_point === 'HEARTBEAT_FAIL_LIST' || DATA_point === 'INSTANTANEOUS_FAIL_LIST' || DATA_point === 'DAILY_LOAD_FAIL_LIST' || DATA_point === 'LOAD_SURVEY_FAIL_LIST' || DATA_point === 'MONTH_BILL_FAIL_LIST') {
					GetConsumerIncolumeName(false, GSMEventConsumerCheckList[datasetIndex], DATA_point, `DATE(${GSMEventConsumerCheckList[datasetIndex]})!='${moment(DateEventInLong[index], 'DD-MM-YYYY').format('YYYY-MM-DD')}'`)
				} else {
					GetConsumerIncolumeName(false, GSMEventConsumerCheckList[datasetIndex], DATA_point, `DATE(${GSMEventConsumerCheckList[datasetIndex]})='${moment(DateEventInLong[index], 'DD-MM-YYYY').format('YYYY-MM-DD')}'`)
				}
			} else {
				onHandalGsmChart(DATA_point, AllGSMEventChartData.SRNO[index], false)
			}
		}
	}

	const [zoomInEnable, setzoomInEnable] = useState(false)
	const [zoomOutEnable, setzoomOutEnable] = useState(false)

	const optionsExpanded = useMemo(() => ({
		// parsing: false,
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			x: {
				// type: 'time',
				ticks: {
					maxRotation: 90,
					minRotation: 90,
					font: {
						size: 10
					},
				}
			},

			y: {
				beginAtZero: true
			},
		},

		// parsing: false,
		plugins: {
			// decimation: {
			// 	enabled: true,
			// 	algorithm: 'lttb',
			// 	samples: 800,
			// 	threshold: 800
			// },
			legend: {
				position: 'bottom',
				labels: {
					pointStyleWidth: 10,
					usePointStyle: true,
					pointStyle: 'rectRounded'
				}
			},
			zoom: {
				zoom: {
					// onZoomComplete: ({
					// 	chart
					// }) => {
					// 	const xMin = chart.scales.x.getLabelForValue(chart.scales.x.min);
					// 	const xMax = chart.scales.x.getLabelForValue(chart.scales.x.max);
					// 	const yMin = chart.scales.y.min;
					// 	const yMax = chart.scales.y.max;
					// 	if (chart.scales.x._valueRange === chart.data.labels.length) {
					// 		setzoomOutEnable(false)
					// 		console.log("disable Zoom Out")
					// 	} else {
					// 		setzoomOutEnable(true)
					// 	}
					// 	if (chart.scales.x.min === chart.scales.x.max) {
					// 		setzoomInEnable(false)
					// 		console.log("disable Zoom in")
					// 	}
					// 	else {
					// 		setzoomInEnable(true)
					// 	}
					// 	// console.log("x values min max == ", chart.scales.x.min, chart.scales.x.max)
					// 	// console.log("Zoom === ", xMin, xMax, yMin, yMax)
					// },
					wheel: {
						enabled: true,
					},
					mode: "x",
				},
				pan: {
					enabled: true,
					mode: "x",
				}
			},
			datalabels: {
				align: 'end',
				anchor: 'end',
				clamp: true,
				color: "black",
				padding: {
					top: 0,
					bottom: 0
				},
				font: function (context) {
					var w = context.chart.width;
					var max = context.chart.scales.x.ticks.length
					return {
						// size: w < 512 ? 8 : 10,
						size: max < 15 ? 10 : 8
					};
				},

			}
		},
		layout: {
			padding: {
				top: 20
			}
		},
	}), [expandedChartData])

	const exInstantData = {
		labels: expandedChartData?.date,
		datasets: [
			{
				label: "Heartbeat Success",
				data: expandedChartData?.total?.heartbeat_success,
				barPercentage: 1.0,
				backgroundColor: 'rgb(0, 126, 51)',
				borderRadius: 5,
			},
			{
				label: "Heartbeat fail",
				data: expandedChartData?.total?.heartbeat_fail,
				barPercentage: 1.0,
				backgroundColor: 'rgb(50,225,79)',
				borderRadius: 5,
			},
			{
				label: "DailyData Success",
				data: expandedChartData?.total?.daily_success,
				barPercentage: 1.0,
				backgroundColor: 'rgb(51,33,113)',
				borderRadius: 5,
			},
			{
				label: "DailyData Fail",
				data: expandedChartData?.total?.daily_fail,
				barPercentage: 1.0,
				backgroundColor: 'rgb(120,111,206)',
				borderRadius: 5,
			}, {
				label: "Alert",
				data: expandedChartData?.total?.alert_total,
				barPercentage: 1.0,
				backgroundColor: 'rgb(255, 119, 0)',
				borderRadius: 5,
			},
			{
				label: "Timesync",
				data: expandedChartData?.total?.timesync_total,
				barPercentage: 1.0,
				backgroundColor: 'rgb(257, 120, 10)',
				borderRadius: 5,
			},
			{
				label: "Reboot",
				data: expandedChartData?.total?.REBOOT_LIST_total,
				barPercentage: 1.0,
				backgroundColor: 'rgb(120,111,206)',
				borderRadius: 5,
			},
			{
				label: "Status Error",
				data: expandedChartData?.total?.STATUS_ERR_total,
				barPercentage: 1.0,
				backgroundColor: 'rgb(51,33,113)',
				borderRadius: 5,
			}
		],
	};

	const exEventChartJsData = {
		labels: exEventChartData?.date,
		datasets: [
			{
				label: "Volt Event",
				barPercentage: 1.0,
				data: exEventChartData?.total?.volt,
				backgroundColor: 'rgb(0, 126, 51)',
				borderRadius: 5,
			},
			{
				label: "Current Event",
				data: exEventChartData?.total?.current,
				barPercentage: 1.0,
				backgroundColor: 'rgb(50,225,79)',
				borderRadius: 5,
			},
			{
				label: "Power Event",
				data: exEventChartData?.total?.power,
				backgroundColor: 'rgb(0,104,138)',
				barPercentage: 1.0,
				borderRadius: 5,
			},
			{
				label: "Other Event",
				data: exEventChartData?.total?.other,
				backgroundColor: 'rgb(85, 200, 245)',
				barPercentage: 1.0,
				borderRadius: 5,
			},
			{
				label: "Transaction Event",
				data: exEventChartData?.total?.transection,
				backgroundColor: 'rgb(255, 119, 0)',
				barPercentage: 1.0,
				borderRadius: 5,
			}, {
				label: "Nonrollover Event",
				data: exEventChartData?.total?.nonrollover,
				backgroundColor: 'rgb(240, 193, 91)',
				barPercentage: 1.0,
				borderRadius: 5,
			}, {
				label: "Control Event",
				data: exEventChartData?.total?.control,
				backgroundColor: 'rgb(51,33,113)',
				borderRadius: 5,
				barPercentage: 1.0,

			}
		]
	}

	const exMonthBillChartJSData = {
		labels: exMonthBillChartData?.date,
		datasets: [
			{
				label: "Monthly Success",
				barPercentage: 1.0,
				data: exMonthBillChartData?.total?.month_success,
				backgroundColor: 'rgb(0, 126, 51)',
				borderRadius: 5,
			},
			{
				label: "Monthly Fail",
				data: exMonthBillChartData?.total?.month_fail,
				barPercentage: 1.0,
				backgroundColor: 'rgb(50,225,79)',
				borderRadius: 5,
			}
		]
	}


	const exInstallChartJs = {
		labels: exInstallationChartData?.date,
		datasets: [
			{
				label: "Installation",
				data: exInstallationChartData?.barData,
				backgroundColor: 'rgb(0, 200, 81)'
			}
		]
	}
	const exInstallOptionChartJS = {
		responsive: true,
		maintainAspectRatio: false,
		animation: {
			duration: 0
		},

		plugins: {
			legend: {
				position: 'bottom',
				labels: {
					pointStyleWidth: 10,
					usePointStyle: true,
					pointStyle: 'rectRounded'
				}
			},
			zoom: {
				zoom: {
					wheel: {
						enabled: true // SET SCROOL ZOOM TO TRUE
					},
					mode: "x",
				},
				pan: {
					enabled: true,
					mode: "x",
				}
			},
			datalabels: {
				align: 'end',
				anchor: 'end',
				clamp: true,
				color: "black",
				padding: {
					top: 0,
					bottom: 0
				},
				font: function (context) {
					var w = context.chart.width;
					return {
						size: w < 512 ? 10 : 12,

					};
				},

			}
		},
		layout: {
			padding: {
				left: 50,
				right: 50,
				top: 20
			}
		},
		// onClick: (event) => {
		// 	console.log(getElementAtEvent(chartRef.current, event));
		// 	console.log("first")
		// 	// getElementsAtEvent(elements)
		// 	// const chart = chartRef.current;
		// 	// const element = chart.getElementAtEvent(event)[0];
		// 	// const dataset = chart.data.datasets[element._datasetIndex];
		// 	// const xLabel = chart.data.labels[element._index];
		// 	// const value = dataset.data[element._index];
		// 	// console.log(dataset.label + " at " + xLabel + ": " + value);
		// },
	};

	const expandChartRef = useRef()
	const myChart = expandChartRef.current;
	let midValue = 0
	if (myChart != undefined || myChart != null) {
		const xMin = myChart.scales.x.min;
		const xMax = myChart.scales.x.max;
		console.log("minMax == ", xMin, xMax)
		midValue = xMax / 2
	}

	const zoomIn = () => {
		if (myChart != undefined || myChart != null) {
			myChart.zoom(1.2);
		}
	}
	const zoomOut = () => {
		if (myChart != undefined || myChart != null) {
			myChart.zoom(0.8);
		}
	}

	const panLeft = () => {
		if (myChart != undefined || myChart != null) {
			myChart.pan({ x: 400 }, undefined, 'default');
		}
	}
	const panRight = () => {
		if (myChart != undefined || myChart != null) {
			myChart.pan({ x: -400 }, undefined, 'default');
		}
	}
	setTimeout(() => {
		if (myChart != undefined || myChart != null) {
			myChart.zoomScale('x', { min: midValue - 3, max: midValue + 3 }, 'default')
			console.log("midaVAlue in setTimeout == ", Math.round(midValue))
			// myChart.zoom(1.2);
			// myChart.pan({
			// 	x: 500
			// }, undefined, 'default');

			// myChart.pan({
			// 	x: - (Number.MAX_SAFE_INTEGER)
			// }, undefined, 'default');

		}
	}, 20)

	// const [activeTab, setActiveTab] = useState("Device Dashboard");
	const [lastSeenType, setLastSeenType] = useState("byHours");
	// const { isLoaded } = useLoadScript({
	// 	// Enter your own Google Maps API key
	// 	googleMapsApiKey: "AIzaSyD07E1VvpsN_0FvsmKAj4nK9GnLq-9jtj8"
	//   });
	const onModelOpenAndCheckDate = async () => {
		const data = await getStartAndEndDateByTable({ tableName: 'lora_consumer_device_index', col: 'HEARTBEAT_TS' })
		if (data.success === true) {
			console.log("Expiry Dates == ", data.data)
			setExpireDate(data.data)
			setIsLastModalVisible(true)
		} else {
			console.log("something want wrong")
		}
	}
	const onLoadCosutomDashboardList = async (info) => {
		const data = await getLoraCustomDashboadList()
		if (data.success == true) {
			const dashtab = data?.data?.data?.filter((item) => (info?.LORA_CUSTOM_DASHBOARD?.dashboard_view?.includes(item?.unique_id) || userInfo?.ROLE == 'ROLE1650614500708'))
			setDashTabs(dashtab)
		} else {
			console.log('something want wrong')
		}
	}
	const customStyles = {
		menu: provided => ({ ...provided, zIndex: 9999 }),
		multiValue: (provided, { data }) => {
			return {
				...provided,
				width: 'min-content',
				backgroundColor: "#6777ef",
			};
		},
		multiValueLabel: (styles, { data }) => ({
			...styles,
			color: "white",
		}),
	}
	const animatedComponents = makeAnimated();

	const Download_Logs = () => {
		exportExcelDownload(TableData.map((item, id) => ({ "SRNO": id + 1, "Consumer Name": item?.address_compony_name, "Modem Serial No": item?.DEVICE_SERIAL_NO, "RSSI": item?.RSSI, "SNR": item?.SNR, "Battery Percent": item?.BAT_PER, "Installation Number": item?.INSTALLATION_NUMBER, "EVC Type": MeterDetails.filter((info) => (info?.METER_TYPE == item?.METER_TYPE))[0]?.METER_PROFILE_NAME || '', "Heartbeat Last Seen": item?.HEARTBEAT_TS ? moment.utc(item.HEARTBEAT_TS).add(-moment().utcOffset(), "m").fromNow('ss:hh:mm') : '',ACCOUNT:AllCategory?.category0.filter((inac) => (inac?.UNIQUE_ID === item?.CAT0_ID))[0]?.CATEGORY0,CATEGORY1:AllCategory?.category1.filter((inac) => (inac?.CATEGORY1_UNIQUE_ID === item?.CAT1_ID))[0]?.CATEGORY1_NAME,CATEGORY2:AllCategory?.category2.filter((inac) => (inac?.CATEGORY2_UNIQUE_ID === item?.CAT2_ID))[0]?.CATEGORY2_NAME,CATEGORY3:AllCategory?.category3.filter((inac) => (inac?.CATEGORY3_UNIQUE_ID === item?.CAT3_ID))[0]?.CATEGORY3_NAME,CATEGORY4:AllCategory?.category4.filter((inac) => (inac?.CATEGORY4_UNIQUE_ID === item?.CAT4_ID))[0]?.CATEGORY4_NAME,CATEGORY5:AllCategory?.category5.filter((inac) => (inac?.UNIQUE_ID === item?.CAT5_ID))[0]?.NAME })), ModelId + (new Date().valueOf()))
	}

	const onHandaleChange = (e, data, id) => {
		if (e.target.checked) {
			var dash_info = DashTabs;
			var obj = JSON.parse(data?.view_json || '{}')
			console.log('step1 true',obj)
			// obj = obj[card_id] || { ...obj }
			console.log('step2 true',obj)
			obj[card_id] = { ...obj[card_id]|{}, display: true,bar_pemission:[...CardBar.map(item=>item?.name)] };
			dash_info[id].view_json = JSON.stringify(obj)
			setDashTabs([...dash_info])
		} else {
			var dash_info = DashTabs
			var obj = JSON.parse(data?.view_json || '{}')
			console.log('step1 false',obj)
			// obj = obj[card_id] || { ...obj }
			console.log('step2 false',obj)
			obj[card_id] = { ...obj[card_id]||{}, display: false }
			dash_info[id].view_json = JSON.stringify(obj)
			setDashTabs([...dash_info])
		}
	}

	const onHandaleBarChange = (e, data, id) => {
		if (e.target.checked) {
			var dash_info = DashTabs;
			var obj = JSON.parse(data?.view_json || '{}')
			console.log('step1 true',obj)
			// obj = obj[card_id] || { ...obj }
			console.log('step2 true',obj)
			obj[card_id] = { ...obj[card_id], bar_pemission: [...obj[card_id]?.bar_pemission||[],e.target.name] };
			dash_info[id].view_json = JSON.stringify(obj)
			setDashTabs([...dash_info])
		} else {
			var dash_info = DashTabs
			var obj = JSON.parse(data?.view_json || '{}')
			console.log('step1 false',obj)
			// obj = obj[card_id] || { ...obj }
			console.log('step2 false',obj)
			obj[card_id] = { ...obj[card_id], bar_pemission: obj[card_id]?.bar_pemission?.filter((item)=>(item!==e.target.name)) }
			dash_info[id].view_json = JSON.stringify(obj)
			setDashTabs([...dash_info])
		}
	}

	const UpdateCustomDasboard = async () => {
		setDashLoader(true)
		const data = await UpdateLoraDashboardAddCustomCard({ DashTabs, user_id: userInfo?.UNIQUE_ID })
		if (data.success == true) {
			toast.success('Added card in Dashboard successfully')
			setisDashModal(false)
			setcard_id('')
			setCardBar([])
			setDashLoader(false)
			onLoadCosutomDashboardList(permision?.ROLES_OTHER_PERMISSIONS)
		} else {
			toast.error('Server Issue')
			setDashLoader(false)
		}
	}

	const UpdateCustomDasboardInCardDelete = async (card_id) => {
		swal.fire({
			title: "Are you sure?",
			text: "card remove in this dashboard",
			icon: "warning",
			showCancelButton: true,
		}).then(async (willDelete) => {
			if (willDelete.isConfirmed) {
				// setCardRemoveLoader(true)
				let data_info = DashTabDetailById
				var viewJson = JSON.parse(data_info?.view_json || '{}');
				if (viewJson[card_id]) {
					viewJson[card_id].display = false
					data_info.view_json = JSON.stringify(viewJson)
				}
				const data = await UpdateLoraDashboardAddCustomCard({ DashTabs: [data_info], user_id: userInfo?.UNIQUE_ID })
				if (data.success == true) {
					toast.success('Remove card in Dashboard successfully')
					// setCardRemoveLoader(false)
					onLoadCosutomDashboardList(permision?.ROLES_OTHER_PERMISSIONS)
				} else {
					toast.error('Server Issue')
					// setCardRemoveLoader(false)
				}
			}
		})
	}
	function findParent(json, targetValue, parentChain = []) {
		for (const node of json) {
		  if (node.value === targetValue) {
			return [...parentChain, node.value];
		  }
	  
		  if (node.children && node.children.length > 0) {
			const result = findParent(node.children, targetValue, [...parentChain, node.value]);
			if (result) {
			  return result;
			}
		  }
		}
	  
		return null; // Node not found
	  }
	const onChangeTreeSelect = (newValue,tree) => {
		const array_parent= findParent(TreeSelection,newValue)||[]
		setProfile({ account: array_parent[0]||'', ga: array_parent[1]||'', circle: array_parent[2]||'', division:array_parent[3]||'', subdivision: array_parent[4]||'', area: array_parent[5]||'' })
	  };

	  const onchangeDefaultLoadData=async(e,UID)=>{
		setFilterDay(FilterDay?.map((item)=>(item.card_id==UID?{...item,day_preference:e.target.value}:{...item})))
		
		swal.fire({
			title: "Do you want to save the changes?",
			// text: "Once deleted, you will not be able to recover this User Details!",
			icon: "warning",
			showDenyButton: true,
			showCancelButton: false,
			confirmButtonText: "Save",
  			denyButtonText: `Don't save`
		 }).then(async (result) => {
			if (result.isConfirmed) {
			const data=await UserDashboardCardFilterStore({user_id:userInfo?.UNIQUE_ID, day_preference:e.target.value,modem_type:'Lorawan',card_id:UID})
			if(data.success==true){
				toast.success('Save Filter Success')
				onGetFilterDaywise()
			}else{
				toast.error('Not Save Filter Server Issue')
			}
			}else if (result.isDenied) {

			}
			onChangesCardWiseFilter('',UID,false,new Number(e.target.value))

			setDefaultShowBar({...DefaultShowBar,[UID]:e.target.value})
		 })
	}

	const onHandalSearchMulti = (newSearchTerms) => {
		setProfile({...Profile,ins_no:newSearchTerms});
	};
	
	const onItemCleared = (clearedIndex) => {
		const newSearchTerms = Profile?.ins_no?.filter((_, index) => index !== clearedIndex);
		onHandalSearchMulti(newSearchTerms);
	};
	const onClearAllItems = () => {
		onHandalSearchMulti([]);
	};

	const onClickDownloadImg=async(element,imageFileName,type)=>{
		const canvas = await html2canvas(element);
		const image = canvas.toDataURL(type=='png'?"image/png":"image/jpg", 1.0);
		downloadImage(image,type=='png'?imageFileName+'.png':imageFileName+'.jpg');
		};
	const downloadImage = (blob, fileName) => {
		const fakeLink = window.document.createElement("a");
		fakeLink.style = "display:none;";
		fakeLink.download = fileName;
		
		fakeLink.href = blob;
		
		document.body.appendChild(fakeLink);
		fakeLink.click();
		document.body.removeChild(fakeLink);
		
		fakeLink.remove();
	}

	const onClickAllImgDownloadPDF=async()=>{
		const RefArray=[IMGCARD0,IMGCARD1,IMGCARD2,IMGCARD3,IMGCARD4,IMGCARD5,IMGCARD6,IMGCARD7,IMGCARD8,IMGCARD9,IMGCARD10,IMGCARD11,IMGCARD12,IMGCARD13,IMGCARD14,IMGCARD15]
		const RefArrayText=[card_json[0].CARD_NAME,card_json[1].CARD_NAME ,card_json[2].CARD_NAME ,card_json[3].CARD_NAME ,card_json[4].CARD_NAME ,card_json[5].CARD_NAME ,card_json[6].CARD_NAME ,card_json[7].CARD_NAME ,card_json[8].CARD_NAME ,card_json[9].CARD_NAME ,card_json[10].CARD_NAME ,card_json[11].CARD_NAME,card_json[12].CARD_NAME ,card_json[13].CARD_NAME ,card_json[14].CARD_NAME ,card_json[15].CARD_NAME  ]
		var doc = new jsPDF('l','mm','a4');

		for (let i = 0; i < RefArray.length; i++) {
			const item = RefArray[i];
			if (item.current) {
				const canvas = await html2canvas(item.current);
				const image = canvas.toDataURL("image/png", 1.0);
				const ratio = canvas.height / canvas.width;
				const contentWidth = doc.internal.pageSize.getWidth(); // make content full-width
				const contentHeight = contentWidth * ratio; // scale height proportionally to width
				doc.text(RefArrayText[i], 60, 22, {
					align: 'center'
				  })
				doc.addImage(image, "png", 0, 28, contentWidth, contentHeight);
	
				if (i < RefArray.length - 1) {
					doc.addPage('l', 'mm', 'a4');
				}
			}
		}
	
		doc.save('lora_modem_dashboard.pdf');
		setisRefDownload(false);

	}

	useEffect(()=>{
		if(isRefDownload&&activeTab=='Device Dashboard'){
		onClickAllImgDownloadPDF()
		}
	},[isRefDownload])
	const onClickUndermaintance = (event) => {
		// console.log(getElementsAtEvent(chartRef.current, event));
		const { datasetIndex, index } = getElementAtEvent(UndermainRef.current, event)[0] || {};
		// console.log((getElementAtEvent(chartRef.current, event)[0]));
		console.log(datasetIndex, index, event)
			if(index===0){
			GetConsumerIncolumeName('NO', `DATEDIFF(CURDATE(), CHANGE_STATUS_TS) BETWEEN 1 AND 15 AND CUSTOMER_STATUS=2`, `Duration  1 - 7 days`, `DATEDIFF(CURDATE(), CHANGE_STATUS_TS) BETWEEN 1 AND 15 AND CUSTOMER_STATUS=2`,card_json[28]?.U_ID)
			}else if(index===1){
				GetConsumerIncolumeName('NO', `DATEDIFF(CURDATE(), CHANGE_STATUS_TS) BETWEEN 16 AND 30 AND CUSTOMER_STATUS=2`, `Duration  16 - 30 days`, `DATEDIFF(CURDATE(), CHANGE_STATUS_TS) BETWEEN 16 AND 30 AND CUSTOMER_STATUS=2`,card_json[28]?.U_ID)
			}else if(index===2){
				GetConsumerIncolumeName('NO', `DATEDIFF(CURDATE(), CHANGE_STATUS_TS) BETWEEN 31 AND 45 AND CUSTOMER_STATUS=2`, `Duration  31 - 45 days`, `DATEDIFF(CURDATE(), CHANGE_STATUS_TS) BETWEEN 31 AND 45 AND CUSTOMER_STATUS=2`,card_json[28]?.U_ID)
			}else if(index===3){
				GetConsumerIncolumeName('NO', `DATEDIFF(CURDATE(), CHANGE_STATUS_TS) > 45 AND CUSTOMER_STATUS=2`, `Duration  More then 45`, `DATEDIFF(CURDATE(), CHANGE_STATUS_TS) > 45 AND CUSTOMER_STATUS=2`,card_json[28]?.U_ID)
			}
	}

	const [DiReportLoader,setDiReportLoader]=useState(false)
	const ongetGenretedAllGSMReport=async()=>{
		setDiReportLoader(true)
		var sql=''
		if (report.start_date !== '' && report.end_date !== '' && report?.value != ''&&report?.type!=='') {
			const x = new Date(moment(report.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD'));
			const y = new Date(moment(report.end_date, 'DD-MM-YYYY').format('YYYY-MM-DD'));
			console.log(x > y, x, y);
			if (x > y) {
				setDiReportLoader(false)

				return toast.warn('"Start Date" Must be Less than or Equal to "End Date"')
			}
		if(report?.value=='Heartbeat'){
			sql=sql+'HEARTBEAT_SUCCESS_LIST as success_data,HEARTBEAT_FAIL_LIST as fail_data'
		}else if(report?.value=='Daily'){
			sql=sql+'DAILY_SUCCESS_LIST as success_data,DAILY_FAIL_LIST as fail_data'
		}else if(report?.value=='Hourly'){
			sql=sql+'HOURLY_SUCCESS_LIST as success_data,HOURLY_FAIL_LIST as fail_data'
		}else if(report?.value=='Alert'){
			sql=sql+'ALERT_LIST as success_data'
		}
		const data=await getLoraGeneretDiagnosticReport({ start: moment(report.start_date, "DD-MM-YYYY").format("YYYY-MM-DD"), end: moment(report.end_date, "DD-MM-YYYY").format("YYYY-MM-DD"),CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area,ins_no:Profile.ins_no, ROLES: userInfo?.ROLE, serach: Profile.account === '' && Profile.ga === '' && Profile.circle === '' && Profile.division === '' && Profile.subdivision === '' && Profile.area === ''&& Profile?.ins_no?.length==0 ? false : true, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view },column_name:sql ,report_type:report?.value })
		if(data.success==true){
			const Reportdata=data?.data?.data
			if (report?.type === 'csv') {
				const headers = data?.data?.header
				exportCSVFile(headers, Reportdata, `Lorawan_${report?.value}_Diagnostic_report_` + '(' + report.start_date + ')' + '_' + '(' + report.end_date + ')')
				setDiReportLoader(false)
			} else {
				exportExcelDownload(Reportdata.map(item=>{
					var obj={}
					data?.data?.header?.map((key)=>{obj[key]=item[key]||'Other'})
					return obj
				}), `Lorawan_${report?.value}_Diagnostic_report_` + '(' + report.start_date + ')' + '_' + '(' + report.end_date + ')')
				setDiReportLoader(false)
			}
		}else{
			toast.warn('Server Issue')
			setDiReportLoader(false)
		}
	}else{
		toast.warn('Please Fill Proper Details')
		setDiReportLoader(false)
	}
	}

	const openReportModal=async(tableName,col)=>{
		const data = await getStartAndEndDateByTable({ tableName: tableName, col: col })
		if (data.success === true) {

			console.log("Expiry Dates == ", data.data)
			setExpireDate(data.data)
			setModel(true)
		}else{

		}
	}
	return (
		<>
			{<Suspense fallback={<><Spin size="large" /></>}>
				<BootstrapModal className="my-modal-class" show={isModalVisible} onHide={handleCancel} size={"xl"} >
					<BootstrapModal.Header closeButton><BootstrapModal.Title style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
						{ModelId}{TableData.length > 0 ? <span className='btn btn-primary text-white ml-2' onClick={Download_Logs}><i className='fas fa-download'></i></span> : ''}
						{TableData.length > 0 ? <Link to={{ pathname: `All-Lorawan`, state: { detail: TableData.map((data) => (data?.UNIQUE_ID)), title: ModelId } }}><span className='btn btn-primary text-white ml-2'><i className='fas fa-up-right-from-square'></i></span></Link> : ''}
					</BootstrapModal.Title></BootstrapModal.Header>
					<BootstrapModal.Body style={{ maxHeight: '90vh', overflow: 'auto', paddingTop: '0px' }}>
						<div className="modal-table">
							{ModalLoad ? (
								<div className="example">
									<Spin size="large" />
								</div>
							) : <table className="table border table-borderless" id="table-1">
								<thead style={{ position: 'sticky', top: '0', background: '#fff' }}>
									<tr>
										<th className="text-center">SR NO.</th>
										<th className="text-center">Consumer Name</th>
										<th className="text-center">Modem Serial No</th>
										<th className="text-center">Category</th>
										<th className="text-center">RSSI</th>
										<th className="text-center">SNR</th>
										<th className="text-center">Installation Number</th>
										{tabShow === true ? '' : <th className="text-center">Meter Type</th>}
										{tabShow == true ? '' : <th className="text-center">Battery Percent</th>}
										{tabShow == true ? '' : <th className="text-center">Heartbeat Last Seen</th>}
										{tabShow === false && ModelId == 'Under Maintanance' ? <th className="text-center">Change Status Time</th> : ''}
									</tr>
								</thead>
								<tbody id="tbody">
									<>
										{TableData.length > 0 ?
											TableData.map((data, id) => (
												<tr style={{ height: "4rem", cursor: 'pointer' }} className="trheigth even:tw-bg-gray-100 hover:tw-bg-[#D8D8D8]" key={id} onMouseEnter={() => {
													var element = document.getElementById(data?.UNIQUE_ID + 'GSM');
													element.classList.add('within');
													element.classList.remove('display-icon');
												}} onMouseLeave={() => {
													var element = document.getElementById(data?.UNIQUE_ID + 'GSM');
													element.classList.add('display-icon');
													element.classList.remove('within');
												}}>
													<td className="GSM_Link">
														<a className="!tw-text-[#1890ff]" onClick={() => onHandaleViewGSM(data?.UNIQUE_ID)}>{id + 1}</a>
														<a id={data?.UNIQUE_ID + 'GSM'} className='display-icon !tw-text-[#1890ff]' onClick={() => onHandaleViewGSM(data?.UNIQUE_ID)}><img src={exports} style={{ height: "10px" }} /></a></td>
													<td className="text-center">{data?.address_compony_name}</td>
													<td className="text-center">{data?.DEVICE_SERIAL_NO}</td>
													<td className='tw-min-w-[150px] text-center' >
														{AllCategory?.category5.filter((inac) => (inac?.UNIQUE_ID === data?.CAT5_ID))[0]?.NAME || AllCategory?.category4.filter((inac) => (inac?.CATEGORY4_UNIQUE_ID === data?.CAT4_ID))[0]?.CATEGORY4_NAME || AllCategory?.category3.filter((inac) => (inac?.CATEGORY3_UNIQUE_ID === data?.CAT3_ID))[0]?.CATEGORY3_NAME || AllCategory?.category2.filter((inac) => (inac?.CATEGORY2_UNIQUE_ID === data?.CAT2_ID))[0]?.CATEGORY2_NAME || AllCategory?.category1.filter((inac) => (inac?.CATEGORY1_UNIQUE_ID === data?.CAT1_ID))[0]?.CATEGORY1_NAME || AllCategory?.category0.filter((inac) => (inac?.UNIQUE_ID === data?.CAT0_ID))[0]?.CATEGORY0}
													</td>
													<td className="text-center">
														{data?.RSSI >= -150 && data?.RSSI <= -111 ? (
															<>
																<img src={signal1} style={{ height: '20px', width: "40px", border: '0', boxShadow: 'none', borderRadius: 'none' }} />
																<span className="text-center">{data?.RSSI} </span>
															</>
														) : data?.RSSI >= -51 && data?.RSSI <= 0 && data?.RSSI != null ? (
															<>
																<img src={signal5} style={{ height: '20px', width: "40px", border: '0', borderRadius: '0', boxShadow: 'none' }} />
																<span className="text-center">{data?.RSSI} </span>
															</>
														) : data?.RSSI >= -80 && data?.RSSI <= -52 ? (
															<>
																<img src={signal4} style={{ height: '20px', width: "40px", border: '0', borderRadius: '0', boxShadow: 'none' }} />
																<span className="text-center">{data?.RSSI} </span>
															</>
														) : data?.RSSI >= -95 && data?.RSSI <= -81 ? (
															<>
																<img src={signal3} style={{ height: '20px', width: "40px", border: '0', borderRadius: '0', boxShadow: 'none' }} />
																<span className="text-center">{data?.RSSI} </span>
															</>
														) : data?.RSSI >= -110 && data?.RSSI <= -95 ? (
															<>
																<img src={signal2} style={{ height: '20px', width: "40px", border: '0', borderRadius: '0', boxShadow: 'none' }} />
																<span className="text-center">{data?.RSSI} </span>
															</>
														) : (
															"-"
														)}
													</td>
													<td className="text-center">{data?.SNR}</td>
													<td className="text-center">{data?.INSTALLATION_NUMBER}</td>
													{tabShow === true ? '' : <td className="text-center">{MeterDetails.filter((info) => (info?.METER_TYPE == data?.METER_TYPE))[0]?.METER_PROFILE_NAME || ''}</td>}
													{tabShow == true ? '' : <td className="text-center">{data?.BAT_PER} %</td>}

													{tabShow == true ? '' : <td>{getSecondsTodayBydate(data.HEARTBEAT_TS) < 86400 ? <div className="badge badge-success badge-shadow text-white">{data?.HEARTBEAT_TS ? moment.utc(data.HEARTBEAT_TS).add(-moment().utcOffset(), "m").fromNow('ss:hh:mm') : ''}</div> : <div className="badge badge-danger badge-shadow text-white">{data?.HEARTBEAT_TS ? moment.utc(data.HEARTBEAT_TS).add(-moment().utcOffset(), "m").fromNow('ss:hh:mm') : ''}</div>}</td>}
													{tabShow === false && ModelId == 'Under Maintanance' ? <td className="text-center"><BootstrapTooltip title={data?.CHANGE_STATUS_TS ? moment.utc(data.CHANGE_STATUS_TS).format('DD-MM-YYYY hh:mm:ss A') : ''}><div className="badge badge-success badge-shadow text-white" >{data?.CHANGE_STATUS_TS ? moment.utc(data.CHANGE_STATUS_TS).add(-moment().utcOffset(), "m").fromNow('ss:hh:mm') : ''}</div></BootstrapTooltip></td> : ''}
												</tr>
											)) : <tr></tr>}
									</>
								</tbody>
							</table>}
							{TableData.length == 0 && !ModalLoad && <h4 className="text-center">No Data Found</h4>}

						</div>
					</BootstrapModal.Body>
				</BootstrapModal>
			</Suspense>}

			<Modal title={"Last Seen"} visible={isLastModalVisible} maskClosable={false} footer='' onCancel={() => {
				setIsLastModalVisible(false)
				setDates({ start: '', end: '' })
			}} width={500} height={300}>
				<div class="form-group text-left">
					<input type="radio"
						name="login_type"
						id="byHours"
						onChange={() => setLastSeenType("byHours")}
						style={{ height: "16px", width: "20px", verticalAlign: "middle" }}
						checked={lastSeenType === "byHours" ? true : false} /><label for="byHours" className="mr-2" style={{ marginLeft: "5px" }}>By Hours</label>
					<input type="radio"
						name="login_type"
						id="byIntervals"
						onChange={() => setLastSeenType("byIntervals")}
						style={{ height: "16px", width: "20px", verticalAlign: "middle" }}

						checked={lastSeenType === "byIntervals" ? true : false} /><label for="byIntervals" style={{ marginLeft: "5px" }}>By Interval</label>
				</div>
				{/* <div class="form-group tw-flex tw-gap-2 tw-p-0 tw-m-0">
					<div className="tw-py-2 tw-w-full tw-flex tw-items-center tw-pl-4 tw-rounded tw-border-solid tw-border tw-border-gray-200 ">
						<input className="tw-w-6 tw-h-6 "
							type="radio"
							name="login_type"
							id="byHours"
							onChange={() => setLastSeenType("byHours")}
							checked={lastSeenType === "byHours" ? true : false}
						/>
						<label className="tw-mb-0 tw-ml-2 tw-w-full tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-300" for="byHours">
							By Hours
						</label>
					</div>
					<div className="tw-py-2 tw-w-full tw-flex tw-items-center tw-pl-4 tw-rounded tw-border-solid  tw-border tw-border-gray-200 ">
						<input className="tw-w-6 tw-h-6 "
							type="radio"
							name="login_type"
							id="byIntervals"
							onChange={() => setLastSeenType("byIntervals")}
							checked={lastSeenType === "byIntervals" ? true : false}
						/>
						<label className="tw-mb-0 tw-ml-2 tw-w-full tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-300" for="byIntervals">
							By Interval
						</label>
					</div>
				</div> */}
				{lastSeenType === 'byHours' ?
					<div className="tw-flex">
						<div class="form-group col-md-9 tw-p-0">
							<input type="text" id="last_seen_hours" name="last_seen_hours" class="form-control" required="" placeholder="Last Seen Hour" value={inputSeen} onChange={(e) => (setinputSeen(e.target.value))} />
						</div>

						<div class="form-group col-md-3">
							<label htmlFor="last_seen_hours">&nbsp;&nbsp;<br /></label>

							<input type="button" class="btn btn-danger" value="Submit" id="last_seen_btn" name="last_seen_btn" onClick={() => (inputSeen ? window.open(`/lorawan-map-view?last_seen=${inputSeen}`, '_blank') : {})} />
						</div>
					</div>
					:
					<div className="pb-3">
						<div className="d-flex tw-justify-between tw-items-center">
							<div className="d-flex tw-justify-center tw-items-end">
								<Space direction="horizontal">
									<div className="d-flex flex-column">Start Date
										<DatePicker format='DD-MM-YYYY' name='start' onChange={onChangeMap} disabledDate={(current) => {
											return (moment(expireDate.start_date).add(-1, 'days') >= current) || (moment(expireDate.end_date).add(0, 'days') <= current);
										}} />
									</div>
									<div className="d-flex flex-column" >End Date
										<DatePicker name='end' format='DD-MM-YYYY' onChange={onChangesMap} disabledDate={(current) => {
											return (moment(expireDate.start_date).add(-1, 'days') >= current) || (moment(expireDate.end_date).add(0, 'days') <= current);
										}} />
									</div>
								</Space>
							</div>
							<div>
								<a className={`btn btn-danger text-white`} onClick={() => (datesInmap.start && datesInmap.end ? window.open(`/lorawan-map-view?date=${JSON.stringify(datesInmap)}`, '_blank') : {})}>Submit</a>
							</div>
						</div>
					</div>}
			</Modal>

			<Modal title={expandedModelHeader} visible={isExpandedModalOpen} maskClosable={false} footer='' onCancel={handleExpandedModal} width={1500}>

				<div className="d-flex tw-justify-between tw-items-center">
					<div className="d-flex tw-justify-center tw-items-end">
						{expandedModelHeader == 'GSM Month Bill Count' ?
							<Space direction="horizontal">
								<div className="d-flex flex-column">Start In
									<DatePicker value={dates?.start !== '' ? moment(dates.start, "MM-YYYY") : null} onChange={onChange} format='MM-YYYY' name='start' picker="month" /></div>
								<div className="d-flex flex-column" >End In
									<DatePicker value={dates?.end !== '' ? moment(dates?.end, "MM-YYYY") : null} onChange={onChanges} name='end' format='MM-YYYY' picker="month" /></div>
							</Space>

							: <Space direction="horizontal">
								<div className="d-flex flex-column">Start In
									<DatePicker value={dates?.start !== '' ? moment(dates?.start, "DD-MM-YYYY") : null} onChange={onChange} format='DD-MM-YYYY' name='start' disabledDate={(current) => {
										return (moment(expireDate.start_date).add(-moment().utcOffset(), "m").add(-1, 'days') >= current) || (moment(expireDate.end_date).add(-moment().utcOffset(), "m").add(0, 'days') <= current);
									}} /></div>
								<div className="d-flex flex-column" >End In
									<DatePicker value={dates?.end !== '' ? moment(dates?.end, "DD-MM-YYYY") : null} onChange={onChanges} name='end' format='DD-MM-YYYY' disabledDate={(current) => {
										return (moment(expireDate.start_date).add(-moment().utcOffset(), "m").add(-1, 'days') >= current) || (moment(expireDate.end_date).add(-moment().utcOffset(), "m").add(0, 'days') <= current);
									}} /></div>
							</Space>}

						<div className='d-flex'>
							<a className={`btn btn-danger text-white ml-3 ${ChartLoader ? 'btn-progress disabled' : ''}`} onClick={() => (onExpandSubmitClick())}>Submit</a>
							{exInstallationChartData?.date.length > 0 && <h5 className='ml-2'>(Total Count : {sum(exInstallationChartData?.barData)})</h5>}
						</div>

					</div>

					{exInstallationChartData?.date.length || expandedChartData.date.length > 0 || exMonthBillChartData.date.length > 0 || exEventChartData.date.length > 0 ?
						<div>
							<div className="tw-mb-1">
								<small className='tw-text-red-300'><sup className="tw-text-sm !tw-top-0">*</sup> You can also do Zoom and Scroll using your mouse</small>
							</div>
							<div className="tw-flex tw-justify-end tw-items-center">
								<button className={`tw-rounded-lg tw-bg-indigo-500 tw-border-transparent text-white tw-mx-1 tw-p-1`} disabled={zoomInEnable} onClick={zoomIn}><BootstrapTooltip title="ZoomIn">
									<div className="tw-flex tw-items-center fa-lg">
										<i class="fas fa-search-plus" aria-hidden="true"></i>
									</div>
								</BootstrapTooltip>
								</button>
								<button className={`tw-rounded-lg tw-bg-indigo-500 tw-border-transparent text-white tw-mx-1 tw-p-1`} disabled={zoomOutEnable} onClick={zoomOut}>
									<BootstrapTooltip title='ZoomOut'>
										<div className="tw-flex tw-items-center fa-lg">
											<i class="fas fa-search-minus" aria-hidden="true"></i>
										</div>
									</BootstrapTooltip>
								</button>

								<button className="tw-rounded-lg tw-bg-indigo-500 tw-border-transparent text-white tw-mx-1 tw-py-1 tw-px-2" onClick={panLeft}>
									<BootstrapTooltip title='Left scroll'>
										<div className="tw-flex tw-items-center fa-lg">
											<i class="fas fa-caret-left" aria-hidden="true"></i>
										</div>
									</BootstrapTooltip>
								</button>
								<button className="tw-rounded-lg tw-bg-indigo-500 tw-border-transparent text-white tw-mx-1 tw-py-1 tw-px-2" onClick={panRight}>
									<BootstrapTooltip title='Right scroll'>
										<div className="tw-flex tw-items-center fa-lg">
											<i class="fas fa-caret-right" aria-hidden="true"></i>
										</div>
									</BootstrapTooltip>
								</button>
							</div>

						</div>
						: ''}
				</div>

				{expandedChartData.date.length > 0 ? <div className=" tw-mt-2 tw-h-[560px] tw-max-h-screen tw-px-5"><Bar ref={expandChartRef} options={optionsExpanded} data={exInstantData} /> </div> : ''}

				{exMonthBillChartData.date.length > 0 ? <div className="tw-mt-2 tw-h-[560px] tw-max-h-screen tw-px-5"><Bar ref={expandChartRef} options={optionsExpanded} data={exMonthBillChartJSData} /> </div> : ''}

				{exEventChartData.date.length > 0 ? <div className="tw-mt-2 tw-h-[560px] tw-max-h-screen tw-px-5"><Bar ref={expandChartRef} options={optionsExpanded} data={exEventChartJsData} /> </div> : ''}

				{exInstallationChartData?.date.length ? <div className="tw-mt-2 tw-h-[560px] tw-max-h-screen tw-px-5"><Bar ref={expandChartRef} options={exInstallOptionChartJS} data={exInstallChartJs} onClick={onExClickInstall} /> </div> : ''}

				{expandedChartData.date.length == 0 && exMonthBillChartData.date.length == 0 && exEventChartData.date.length == 0 && exInstallationChartData?.date.length == 0 ? <h4 className="text-center">Data Not Found</h4> : ''}

			</Modal>
			<Modal title={"Custom Dashboard permission add " + `(${Modal_card_name})`} visible={isDashModal} footer='' onCancel={() => {
				setisDashModal(false)
				setcard_id('')
				setCardBar([])
			}} width={1000} height={300}>
				<div className="modal-table">
					<table className="table border table-borderless text-center" id="table-1">
						<thead style={{ position: 'sticky', top: '0', background: '#fff' }}>
							<tr>
								<th className="text-center">Dashboard Name</th>
								<th className="text-center">Add Card</th>
								<th className="text-center">Card Other Permission</th>
							</tr>
						</thead>
						<tbody id="tbody">
							<>
								{console.log(DashTabs)}
								{DashTabs.length > 0 ?
									DashTabs.map((data, id) => (
										<tr>
											<td>{data?.name}</td>
											<td><input type="checkbox" className="chk_MSSQL1" name="checkAll" onChange={(e) => { onHandaleChange(e, data, id) }} checked={JSON.parse(data?.view_json || '{}')[card_id]?.display || false} /></td>
											<Popover placement="bottom" title={ <span>{data?.name}</span>} content={
                                                                <>
                                                                <table class="table table-borderless border">
                                                                <thead className='border leading-8' style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}>
                                                                    <tr >
                                                                        <th scope="col" class="thalignleft tw-font-normal text-start" style={{ width: "40%" }}>Lable</th>
                                                                        <th scope="col" class="thalign tw-font-normal text-start" style={{ width: "20%" }}>View</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className='leading-8 ' >
                                                                {CardBar?.map((perm)=>(
                                                                    <tr >
                                                                        <th scope='row' className='text-start tw-font-normal' style={{height: "40px"}}>
                                                                        {perm?.name}
                                                                        </th>
                                                                        <th className=' text-start font-normal' style={{height: "40px"}}>
                                                                            <input className='' type={"checkbox"} name={perm?.name} id={perm?.name}
                                                                             onChange={(e)=>(onHandaleBarChange(e,data,id))} checked={JSON.parse(data?.view_json || '{}')[card_id]?.bar_pemission?.includes(perm?.name)}></input>
                                                                        </th>
                                                                    </tr>
                                                                ))}
                                                                </tbody>
                                                            </table>
                                                            </>
                                                            } trigger="click">
                                                            <th className='tw-cursor-pointer tw-text-blue-600'>More permission</th>
                                                            </Popover>
										</tr>
									)) : <tr></tr>}
							</>
						</tbody>
					</table>
					<div className="text-center">
						<a className={`btn btn-danger ${DashLoader === true ? 'btn-progress disabled' : ''} text-white`} onClick={UpdateCustomDasboard}>Submit</a>
					</div>
				</div>
			</Modal>
			<Modal title="Generate Reports" visible={Model} footer='' onCancel={()=>setModel(false)} width={1500}>
				<section className="section">
					<div className="section-body">
						<div className="row">
							<div className="col-12">
								<div className="form-row" style={{ marginLeft: "10px" }}>

									<><div className="form-group col-md-3" id="strdate">
										<label for="inputPassword4">Start Date :<span className='text-danger'>*</span> </label><br></br>
										<DatePicker onChange={(e, dateString) => setReport({ ...report, start_date: dateString })} format='DD-MM-YYYY' name='start' style={{ width: '100%', height: '40px' }}
											disabledDate={(current) => {
												return current.isAfter(moment())
											}} />
									</div>
										<div className="form-group col-md-3" id="enddate" >
											<label for="inputPassword4">End Date :<span className='text-danger'>*</span> </label><br></br>
											<DatePicker onChange={(e, dateString) => setReport({ ...report, end_date: dateString })} format='DD-MM-YYYY' name='start' style={{ width: '100%', height: '40px' }}
												disabledDate={(current) => {
													return current.isAfter(moment())
												}} />
										</div></>
										<div className="form-group col-md-3" id="enddate" >
											<label for="inputPassword4">Table Type :<span className='text-danger'>*</span> </label><br></br>
											<select className="form-control form-select" name="reportextension" onChange={(e) => (setReport({...report,value:e.target.value}))} value={report?.value}>
											<option value="">Select Extension</option>
											<option value="Heartbeat">Heartbeat</option>
											<option value="Daily">Daily</option>
											<option value="Hourly">Hourly</option>
											<option value="Alert">Alert</option>
										</select>
										</div>
									<div className="form-group col-md-3" id="grpeui">
										<label for="inputPassword4">Extension :<span className='text-danger'>*</span> </label>
										<select className="form-control form-select" name="reportextension" onChange={(e) => (setReport({...report,type:e.target.value}))} value={report?.type}>
											<option value="">Select Extension</option>
											<option value="xls">XLS</option>
											<option value="csv">CSV</option>
										</select>
									</div>
								</div>
								<p style={{ marginLeft: "25px" }} className="text-danger">Note : * Indicates Mandatory Fields</p>
								<div className="text-left">
									<input type="submit" name="submit" className={`btn btn-danger mr-2 ${DiReportLoader == true ? 'disabled btn-progress' : ''} `} value="Generate" id="submitvn" onClick={ongetGenretedAllGSMReport} />
									<Link className="btn btn-light text-dark" onClick={()=>setModel(false)}>Cancel</Link>
								</div>
							</div>
						</div>
					</div>
				</section>
			</Modal>
			{loader ? (
				<div className="main-content">
					<div class="loader"></div>
				</div>
			) : (
				""
			)}

			<section class="section">
				<div class="section-body">

					{(activeTab === 'Device Dashboard' || activeTab == 'Custom Dashboard') && (<>
						<div class="row">
						<div class="col-12">
							<div class="card ">
								<div class="card-body tw-flex tw-items-center tw-gap-3" style={{ padding: "2px 12px" }}>
								<Popover trigger="click" overlayStyle={{width:'300px'}}  content={<>
										<TreeSelect
												style={{ width: '100%' }}
												dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
												treeData={TreeSelection}
												placeholder="All Account"
												treeDefaultExpandAll
												allowClear
												onChange={onChangeTreeSelect}
										/>
									</>}>
									<div>
									<button class="btn btn-primary"> <i className="fas fa-filter"></i> </button>
									</div>
									</Popover>
									<div class="tw-flex tw-gap-2"
										style={{

											borderColor: "#e3e6fc !important",
											position: "relative",
											marginTop: "5px",
										}}>
										<div class="tw-w-full tw-min-w-[13rem]">
											<div class="form-group">
												<label htmlFor="inputPassword4">
												Account<span class="text-danger">*</span>
												</label>
												{/* <Select name='Consumertype' isMulti options={AccounData.map((item, id) =>
																	permision?.ROLES_PERMISSIONS_CATEGORY0?.CATEGORY0_view?.filter(
																		(items) => items === item.UNIQUE_ID
																	).length > 0 || userInfo?.ROLE === 'ROLE1650614500708' ? (
																		{value:item.UNIQUE_ID,label:item.CATEGORY0}
																	) :{}
																)} onChange={(e) => { setProfile({ ...Profile, account: e.map((item) => (item.value)) }) }} /> */}
												<select
													class="form-control form-select accountoga ga_calueacc"
													name="accountid"
													required=""
													id="accountid"
													onChange={(e) => setProfile({ ...Profile, account: e.target.value, ga: "", circle: "", division: "", subdivision: "", area: "" })}
													value={Profile?.account}

												>
													<option value="">All Account</option>
													{AccounData &&
														AccounData.map((item, id) =>
															permision?.ROLES_PERMISSIONS_CATEGORY0?.CATEGORY0_view?.filter(
																(items) => items === item.UNIQUE_ID
															).length > 0 || userInfo?.ROLE === 'ROLE1650614500708' ? (
																<option key={id} value={item.UNIQUE_ID}>{item.CATEGORY0}</option>
															) : (
																""
															)
														)}
												</select>
											</div>
										</div>
										{Profile.account !== "" && (
											<div class="tw-w-full tw-min-w-[12rem] gagrp">
												<div class="form-group">
													<label htmlFor="inputPassword4">{NameObj?.CATEGORY1 || 'CATEGORY1'}</label>
													<select
														class="form-control form-select gatocircle ga_calue"
														name="address_location_d"
														id="address_location_d"
														onChange={(e) => setProfile({ ...Profile, ga: e.target.value, circle: "", division: "", subdivision: "", area: "" })}
														value={Profile?.ga}
													>
														<option value="">Select {NameObj?.CATEGORY1 || 'CATEGORY1'}</option>

														

														{GaData &&
															GaData.filter(item=>item.CATEGORY0==Profile.account).map((item, id) =>
																(permision?.ROLES_PERMISSIONS_CATEGORY1?.CATEGORY1_view?.length > 0 
        														? permision?.ROLES_PERMISSIONS_CATEGORY1?.CATEGORY1_view?.filter((items) => (items === item.CATEGORY1_UNIQUE_ID)).length > 0 
        																: (item?.CATEGORY0==Profile?.account))|| userInfo?.ROLE === 'ROLE1650614500708' ? (
																	<option key={id} value={item.CATEGORY1_UNIQUE_ID}>{item.CATEGORY1_NAME}</option>
																) : (
																	""
																)
															)}
													</select>
												</div>
											</div>
										)}
										{Profile.ga !== "" && Profile.account !== "" && (
											<div class="tw-w-full tw-min-w-[12rem] circlegrp">
												<div class="form-group">
													<label htmlFor="inputPassword4">{NameObj?.CATEGORY2 || 'CATEGORY2'}</label>
													<select
														class="form-control circletodivision form-select"
														name="circle_id"
														onChange={(e) => setProfile({ ...Profile, circle: e.target.value, division: "", subdivision: "", area: "" })}
														value={Profile?.circle}
													>
														<option value="">Select {NameObj?.CATEGORY2 || 'CATEGORY2'}</option>
														
														{CircleData &&
															CircleData.filter(item=>item.CATEGORY1==Profile.ga).map((item, id) =>
																(permision?.ROLES_PERMISSIONS_CATEGORY2?.CATEGORY2_view?.length > 0 
																	? permision?.ROLES_PERMISSIONS_CATEGORY2?.CATEGORY2_view?.filter((items) => (items === item.CATEGORY2_UNIQUE_ID)).length > 0 
																			: (item.CATEGORY0==Profile?.account&&item.CATEGORY1==Profile?.ga))|| userInfo?.ROLE === 'ROLE1650614500708' ? (
																	<option key={id} value={item.CATEGORY2_UNIQUE_ID}>{item.CATEGORY2_NAME}</option>
																) : (
																	""
																)
															)}
													</select>
												</div>
											</div>
										)}
										{Profile.circle !== "" && Profile.ga !== "" && Profile.account !== "" && (
											<div class="tw-w-full tw-min-w-[12rem] divisiongrp">
												<div class="form-group">
													<label htmlFor="inputPassword4">{NameObj?.CATEGORY3 || 'CATEGORY3'}</label>
													<select
														class="form-control divisiontosubdivision form-select"
														name="division_id"
														id="address_location_d"
														onChange={(e) => setProfile({ ...Profile, division: e.target.value, subdivision: "", area: "" })}
														value={Profile?.division}
													>
														<option value="">Select {NameObj?.CATEGORY3 || 'CATEGORY3'}</option>
														
														{DivisionData &&
															DivisionData.filter(item=>item.CATEGORY2==Profile.circle).map((item, id) =>
																(permision?.ROLES_PERMISSIONS_CATEGORY3?.CATEGORY3_view?.length > 0 
																	? permision?.ROLES_PERMISSIONS_CATEGORY3?.CATEGORY3_view?.filter((items) => (items === item.CATEGORY3_UNIQUE_ID)).length > 0 
																			: (item.CATEGORY0==Profile?.account&&item.CATEGORY1==Profile?.ga))|| userInfo?.ROLE === 'ROLE1650614500708' ? (
																	<option key={id} value={item.CATEGORY3_UNIQUE_ID}>{item.CATEGORY3_NAME}</option>
																) : (
																	""
																)
															)}
													</select>
												</div>
											</div>
										)}
										{Profile.division !== "" && Profile.circle !== "" && Profile.ga !== "" && Profile.account !== "" && (
											<div class="tw-w-full tw-min-w-[12rem] subdivisiongrp">
												<div class="form-group">
													<label htmlFor="inputPassword4">{NameObj?.CATEGORY4 || 'CATEGORY4'}</label>
													<select
														class="form-control subdivisiontoarea form-select"
														name="sub_division_id"
														id="address_location_d"
														onChange={(e) => setProfile({ ...Profile, subdivision: e.target.value, area: "" })}
														value={Profile?.subdivision}
													>
														<option value="">Select {NameObj?.CATEGORY4 || 'CATEGORY4'}</option>
														
														{SubdevisionData &&
															SubdevisionData.filter(item=>item.CATEGORY3==Profile.division).map((item, id) =>
																(permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY4_view?.length > 0 
																	? permision?.ROLES_PERMISSIONS_CATEGORY4?.CATEGORY4_view?.filter((items) => (items === item.CATEGORY3_UNIQUE_ID)).length > 0 
																			: (item.CATEGORY0==Profile?.account&&item.CATEGORY1==Profile?.ga&&item.CATEGORY2==Profile?.circle&&item.CATEGORY3==Profile?.division))|| userInfo?.ROLE === 'ROLE1650614500708' ? (
																	<option key={id} value={item.CATEGORY4_UNIQUE_ID}>
																		{item.CATEGORY4_NAME}
																	</option>
																) : (
																	""
																)
															)}
													</select>
												</div>
											</div>
										)}
										{Profile.subdivision !== "" &&
											Profile.division !== "" &&
											Profile.circle !== "" &&
											Profile.ga !== "" &&
											Profile.account !== "" && (
												<div class="tw-w-full tw-min-w-[12rem] areagrp">
													<div class="form-group">
														<label htmlFor="inputPassword4">{NameObj?.CATEGORY5 || 'CATEGORY5'}</label>
														<select
															class="form-control form-select lastarea cust_ara"
															name="area_id"
															id="area_id"
															onChange={(e) => setProfile({ ...Profile, area: e.target.value })}
															value={Profile?.area}
														>
															<option value="">Select {NameObj?.CATEGORY5 || 'CATEGORY5'}</option>
															
															{AreaData &&
																AreaData.filter(item=>item.CATEGORY4==Profile.subdivision).map((item, id) =>
																	(permision?.ROLES_PERMISSIONS_CATEGORY5?.CATEGORY5_view?.length > 0 
																		? permision?.ROLES_PERMISSIONS_CATEGORY5?.CATEGORY5_view?.filter((items) => (items === item.CATEGORY3_UNIQUE_ID)).length > 0 
																				: (item.CATEGORY0==Profile?.account&&item.CATEGORY1==Profile?.ga&&item.CATEGORY2==Profile?.circle&&item.CATEGORY3==Profile?.division&&item.CATEGORY4==Profile?.subdivision))|| userInfo?.ROLE === 'ROLE1650614500708' ? (
																		<option key={id} value={item.UNIQUE_ID}>{item.NAME}</option>
																	) : (
																		""
																	)
																)}
														</select>
													</div>
												</div>
											)}
											<div class="tw-w-full ">
													<div class="form-group">
														<label>Installation Number</label>
											<MultiInput
											placeholder="Search & enter Installation Number"
											onChange={onHandalSearchMulti}
											maxItems={null} // Allow any number of items
											onClear={onItemCleared}
											onClearAll={onClearAllItems}
											/>
											</div>
											</div>
									</div>
									<div className="d-flex">
									
										<button class={`btn btn-primary ml-2 ${!isDownloadBtnShow?'disabled btn-progress':''}`} onClick={onProfileWiseSearchClick}> <i className="fa fa-search"></i> </button>
									</div>
								</div>
							</div>

						</div>
					</div>
						<div class="row">
							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[0].U_ID]?.display==true||activeTab!='Custom Dashboard' ? <div class="col-12">
								<div class="card card-danger">
									<div class="row">
										<div class="col-12 ">
											<div class="card-header"  >
												<h4><span className="mr-2">{card_json[0].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_instantaneous_day_wise_graph and Live Data Find gsm_consumer_device_index (INSTANTANEOUS_TS,DAILY_LOAD_TS,LOAD_SURVEY_TS)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip>
													<div className='btn btn-info  ml-2'><Link to={'/LoraAnalytics'} class='!tw-text-white'>Lorawan Gateway analysis</Link></div></h4>
												<div class="card-header-action d-flex">
												<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[0].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
												</Popover>
													{activeTab=='Custom Dashboard' ?<select class='mr-2' onChange={(e)=>{onchangeDefaultLoadData(e,card_json[0].U_ID)}} value={FilterDay?.filter(item=>item?.card_id==card_json[0]?.U_ID)[0]?.day_preference||'7'}><option value='7'>7 Day</option><option value='10'>10 Day</option><option value='15'>15 Day</option></select>:''}
												<select class='mr-2' onChange={(e)=>{setchartType({...chartType,[card_json[0].U_ID]:e.target.value})}}><option value='bar'>Bar Chart</option><option value='line'>Line Chart</option></select>
													<BootstrapTooltip title={AllGSMChartData?.ENTRYTS ? moment.utc(AllGSMChartData?.ENTRYTS).format("DD-MM-YYYY hh:mm:ss A") : ''} placement="top"><span class="text-left mr-3" >{AllGSMChartData?.ENTRYTS ? moment.utc(AllGSMChartData?.ENTRYTS).add(-moment().utcOffset(), "m").fromNow('ss:hh:mm') : ''}</span></BootstrapTooltip>
													<a class="btn btn-primary text-white mr-1" data-toggle="tooltip" data-placement="Top" title="Refresh" ><i class="fas fa-refresh" aria-hidden="true"></i></a>
													<a class="btn btn-info text-white mr-1" data-toggle="tooltip" data-placement="Top" title="Expand" onClick={() => { onExpandButton('lora_instantaneous_day_wise_graph', 'CREATED_AT', 'lorawan Instantaneous Count') }}>Expand</a>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD0.current,card_json[0].CARD_NAME,type)}} newMenu={[{label:"Diagnostic Report",event:()=>openReportModal('gsm_instantaneous_day_wise_graph', 'CREATED_AT')}]}/>
													<div class="dropdown d-inline ml-2">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[0].CARD_NAME)
																setcard_id(card_json[0].U_ID)
																setCardBar([{name:'Heartbeat Success',val:'Heartbeat_Success'},{name:'Heartbeat Fail',val:'Heartbeat_Fail'},{name:'DailyData Success',val:'DailyData_Success'},{name:'DailyData Fail',val:'DailyData_Fail'},{name:'Hourly Success',val:'Hourly_Success'},{name:'Hourly Fail',val:'Hourly_Fail'},{name:'Alert',val:'Alert'},{name:'Timesync',val:'Timesync'},{name:'Reboot',val:'Reboot'},{name:'Status Error',val:'Status_Error'}])
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[0].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													
												</div>
											</div>

											<div class="card-body heartbeatspace " >
											
											<div style={{ position: "relative", height: "395px" }} ref={IMGCARD0}>
												{AllGSMChartData.heartbeat_fail.length > 0 && AllGSMChartData.heartbeat_success.length > 0
													&& AllGSMChartData.daily_fail.length > 0 && AllGSMChartData.daily_success.length > 0 ?chartType[card_json[0].U_ID]=='line'?<Line options={optionsForChartJS} data={dataForChartJs}/>: <Bar ref={chartRef} onClick={onClick} options={optionsForChartJS} data={dataForChartJs} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
											</div>
											</div>
											<p class="text-right" style={{ marginRight: "40px", lineHeight: "10px" }}>{chartType[card_json[0].U_ID]=='line'?'Line Char':'Bar chart'}</p>
										</div>
									</div>
								</div>
							</div> : ''}
						</div>

						<div class="row">
						{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[1].U_ID]?.display==true||activeTab!='Custom Dashboard'?<div class="col-xs-12 col-md-6 ">
								<div class="card card-info mb-4" style={{ height: '469px' }}>
									<div class="card-header">
										<h4>{card_json[1].CARD_NAME}<BootstrapTooltip title='Find Data In gsm_consumer_device_index (HEARTBEAT_LAST_DATA->MMD_ALERT_EXT_DOOR,HEARTBEAT_LAST_DATA->EERPROM_CHECKSUM,HEARTBEAT_LAST_DATA->EEPROMST)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[1].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													
										<div class="dropdown d-inline">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[1].CARD_NAME)
																setcard_id(card_json[1].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[1].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body" style={{ overflow: 'auto' }}>
										{Object.keys(HeatbeatStatus).length > 0 ? <div className="table-responsive">
											<div class="" id="lorawan_total_consumer_count">
												<table class="table table-borderless table-striped ">
													<tbody>
														<tr style={{ position: 'sticky', top: '0', background: '#fff' }}>
															<th className="text-center"></th>
															<th className="text-center "><span className="badge badge-success"><i className='fas fa-check '></i></span></th>
															<th className="text-center "><span className="badge badge-danger"><i className="fas fa-times " /></span></th>
															<th className="text-center ">(Null)</th>
															<th className="text-center ">! (24 Hrs)</th>
															<th className="text-center ">Status Disable</th>

															<th className="text-center">Total</th>
														</tr>
														<tr>
															<td style={{ height: "35px" }}>TAMPER_FLG</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.TAMPER_FLG')`, `Heartbeat TAMPER_FLG Status Success`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.TAMPER_FLG')='0'  OR JSON_VALUE(ALERT_DISABLE,'$.TAMPER_FLG')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.TAMPER_FLG_0}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.TAMPER_FLG')`, `Heartbeat TAMPER_FLG Status Fail`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.TAMPER_FLG')='1'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.TAMPER_FLG_1}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.TAMPER_FLG')`, `Heartbeat TAMPER_FLG Status Not Available`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.TAMPER_FLG') IS NULL`,card_json[1]?.U_ID))}>{HeatbeatStatus?.TAMPER_FLG_null}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.TAMPER_FLG')`, `Heartbeat TAMPER_FLG ! (24 Hrs)`, `HEARTBEAT_TS<'${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.time_out}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.TAMPER_FLG')`, `Heartbeat TAMPER_FLG Status Not Available`, `JSON_VALUE(ALERT_DISABLE,'$.TAMPER_FLG')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.TAMPER_FLG_DISABLE}</td>
															<td style={{ height: "35px" }} className='text-center'>{HeatbeatStatus?.TAMPER_FLG_0 != undefined && HeatbeatStatus?.TAMPER_FLG_1 != undefined && HeatbeatStatus?.TAMPER_FLG_null != undefined ? HeatbeatStatus?.TAMPER_FLG_0 + HeatbeatStatus?.TAMPER_FLG_1 + HeatbeatStatus?.TAMPER_FLG_null : '0'}</td>
														</tr>
														<tr>
															<td style={{ height: "35px" }}>EDGE_DETECTION</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EDGE_DETECTION')`, `Heartbeat EDGE_DETECTION Status Close`, `((JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EDGE_DETECTION')='1' AND MODEM_TYPE IN ('MODUID1687764102670')) OR JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EDGE_DETECTION')='0' OR JSON_VALUE(ALERT_DISABLE,'$.EDGE_DETECTION')=0 AND MODEM_TYPE NOT IN ('MODUID1687764102670')) `,card_json[1]?.U_ID))}>{HeatbeatStatus?.EDGE_DETECTION_1}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EDGE_DETECTION')`, `Heartbeat EDGE_DETECTION Status open`, `((JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EDGE_DETECTION')='0' AND MODEM_TYPE IN ('MODUID1687764102670')) OR JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EDGE_DETECTION')='1' AND MODEM_TYPE NOT IN ('MODUID1687764102670'))`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EDGE_DETECTION_0}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EDGE_DETECTION')`, `Heartbeat EDGE_DETECTION Status Not Available`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EDGE_DETECTION') IS NULL`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EDGE_DETECTION_null}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EDGE_DETECTION')`, `Heartbeat EDGE_DETECTION ! (24 Hrs)`, `HEARTBEAT_TS<'${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.time_out}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EDGE_DETECTION')`, `Heartbeat EDGE_DETECTION Status Not Available`, `JSON_VALUE(ALERT_DISABLE,'$.EDGE_DETECTION')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EDGE_DETECTION_DISABLE}</td>
															<td style={{ height: "35px" }} className='text-center'>{HeatbeatStatus?.EDGE_DETECTION_0 != undefined && HeatbeatStatus?.EDGE_DETECTION_1 != undefined && HeatbeatStatus?.EDGE_DETECTION_null != undefined ? HeatbeatStatus?.EDGE_DETECTION_0 + HeatbeatStatus?.EDGE_DETECTION_1 + HeatbeatStatus?.EDGE_DETECTION_null : '0'}</td>
														</tr>
														<tr>
															<td style={{ height: "35px" }}>PLS_READ_ERR</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.PLS_READ_ERR')`, `Heartbeat PLS_READ_ERR Status Close`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.PLS_READ_ERR')='0' OR JSON_VALUE(ALERT_DISABLE,'$.PLS_READ_ERR')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.PLS_READ_ERR_0}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.PLS_READ_ERR')`, `Heartbeat PLS_READ_ERR Status Open`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.PLS_READ_ERR')='1'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.PLS_READ_ERR_1}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.PLS_READ_ERR')`, `Heartbeat PLS_READ_ERR Status Not Available`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.PLS_READ_ERR') IS NULL`,card_json[1]?.U_ID))}>{HeatbeatStatus?.PLS_READ_ERR_null}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.PLS_READ_ERR')`, `Heartbeat PLS_READ_ERR Status ! (24 Hrs)`, `HEARTBEAT_TS<'${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.time_out}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.PLS_READ_ERR')`, `Heartbeat PLS_READ_ERR Status Not Available`, `JSON_VALUE(ALERT_DISABLE,'$.PLS_READ_ERR')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.PLS_READ_ERR_DISABLE}</td>
															<td style={{ height: "35px" }} className='text-center'>{HeatbeatStatus?.PLS_READ_ERR_0 != undefined && HeatbeatStatus?.PLS_READ_ERR_1 != undefined && HeatbeatStatus?.PLS_READ_ERR_null != undefined ? HeatbeatStatus?.PLS_READ_ERR_0 + HeatbeatStatus?.PLS_READ_ERR_1 + HeatbeatStatus?.PLS_READ_ERR_null : '0'}</td>
														</tr>
														<tr>
															<td style={{ height: "35px" }}>EPRM_ERR</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EPRM_ERR')`, `Heartbeat EPRM_ERR Status Open`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EPRM_ERR')='0' OR JSON_VALUE(ALERT_DISABLE,'$.EPRM_ERR')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EPRM_ERR_0}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EPRM_ERR')`, `Heartbeat EPRM_ERR Status Close`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EPRM_ERR')='1'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EPRM_ERR_1}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EPRM_ERR')`, `Heartbeat EPRM_ERR Status Not Available`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EPRM_ERR') IS NULL`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EPRM_ERR_null}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EPRM_ERR')`, `Heartbeat EPRM_ERR Status ! (24 Hrs)`, `HEARTBEAT_TS<'${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.time_out}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EPRM_ERR')`, `Heartbeat EPRM_ERR Status Not Available`, `JSON_VALUE(ALERT_DISABLE,'$.EPRM_ERR')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EPRM_ERR_DISABLE}</td>
															<td style={{ height: "35px" }} className='text-center'>{HeatbeatStatus?.EPRM_ERR_0 != undefined && HeatbeatStatus?.EPRM_ERR_1 != undefined && HeatbeatStatus?.EPRM_ERR_null != undefined ? HeatbeatStatus?.EPRM_ERR_0 + HeatbeatStatus?.EPRM_ERR_1 + HeatbeatStatus?.EPRM_ERR_null : '0'}</td>
														</tr>
														<tr>
															<td style={{ height: "35px" }}>CKSM_ERR</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.CKSM_ERR')`, `Heartbeat CKSM_ERR Status Open`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.CKSM_ERR')='0' OR JSON_VALUE(ALERT_DISABLE,'$.CKSM_ERR')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.CKSM_ERR_0}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.CKSM_ERR')`, `Heartbeat CKSM_ERR Status Close`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.CKSM_ERR')='1'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.CKSM_ERR_1}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.CKSM_ERR')`, `Heartbeat CKSM_ERR Status Not Available`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.CKSM_ERR') IS NULL`,card_json[1]?.U_ID))}>{HeatbeatStatus?.CKSM_ERR_null}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.CKSM_ERR')`, `Heartbeat CKSM_ERR Status ! (24 Hrs)`, `HEARTBEAT_TS<'${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.time_out}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.CKSM_ERR')`, `Heartbeat CKSM_ERR Status Not Available`, `JSON_VALUE(ALERT_DISABLE,'$.CKSM_ERR')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.CKSM_ERR_DISABLE}</td>
															<td style={{ height: "35px" }} className='text-center'>{HeatbeatStatus?.CKSM_ERR_0 != undefined && HeatbeatStatus?.CKSM_ERR_1 != undefined && HeatbeatStatus?.CKSM_ERR_null != undefined ? HeatbeatStatus?.CKSM_ERR_0 + HeatbeatStatus?.CKSM_ERR_1 + HeatbeatStatus?.CKSM_ERR_null : '0'}</td>
														</tr>
														<tr>
															<td style={{ height: "35px" }}>INT_DOOR_STATUS</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.INT_DOOR_STATUS')`, `Heartbeat INT_DOOR_STATUS Status Open`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.INT_DOOR_STATUS')='0' OR JSON_VALUE(ALERT_DISABLE,'$.INT_DOOR_STATUS')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.INT_DOOR_STATUS_0}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.INT_DOOR_STATUS')`, `Heartbeat INT_DOOR_STATUS Status Close`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.INT_DOOR_STATUS')='1'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.INT_DOOR_STATUS_1}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.INT_DOOR_STATUS')`, `Heartbeat INT_DOOR_STATUS Status Not Available`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.INT_DOOR_STATUS') IS NULL`,card_json[1]?.U_ID))}>{HeatbeatStatus?.INT_DOOR_STATUS_null}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.INT_DOOR_STATUS')`, `Heartbeat INT_DOOR_STATUS Status ! (24 Hrs)`, `HEARTBEAT_TS<'${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.time_out}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.INT_DOOR_STATUS')`, `Heartbeat INT_DOOR_STATUS Status Not Available`, `JSON_VALUE(ALERT_DISABLE,'$.INT_DOOR_STATUS')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.INT_DOOR_STATUS_DISABLE}</td>
															<td style={{ height: "35px" }} className='text-center'>{HeatbeatStatus?.INT_DOOR_STATUS_0 != undefined && HeatbeatStatus?.INT_DOOR_STATUS_1 != undefined && HeatbeatStatus?.INT_DOOR_STATUS_null != undefined ? HeatbeatStatus?.INT_DOOR_STATUS_0 + HeatbeatStatus?.INT_DOOR_STATUS_1 + HeatbeatStatus?.INT_DOOR_STATUS_null : '0'}</td>
														</tr>
														<tr>
															<td style={{ height: "35px" }}>EXT_DOOR_STATUS</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EXT_DOOR_STATUS')`, `Heartbeat EXT_DOOR_STATUS Status Open`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EXT_DOOR_STATUS')='0' OR JSON_VALUE(ALERT_DISABLE,'$.EXT_DOOR_STATUS')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EXT_DOOR_STATUS_0}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EXT_DOOR_STATUS')`, `Heartbeat EXT_DOOR_STATUS Status Close`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EXT_DOOR_STATUS')='1'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EXT_DOOR_STATUS_1}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EXT_DOOR_STATUS')`, `Heartbeat EXT_DOOR_STATUS Status Not Available`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EXT_DOOR_STATUS') IS NULL`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EXT_DOOR_STATUS_null}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EXT_DOOR_STATUS')`, `Heartbeat EXT_DOOR_STATUS Status ! (24 Hrs)`, `HEARTBEAT_TS<'${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.time_out}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.EXT_DOOR_STATUS')`, `Heartbeat EXT_DOOR_STATUS Status Not Available`, `JSON_VALUE(ALERT_DISABLE,'$.EXT_DOOR_STATUS')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.EXT_DOOR_STATUS_DISABLE}</td>
															<td style={{ height: "35px" }} className='text-center'>{HeatbeatStatus?.EXT_DOOR_STATUS_0 != undefined && HeatbeatStatus?.EXT_DOOR_STATUS_1 != undefined && HeatbeatStatus?.EXT_DOOR_STATUS_null != undefined ? HeatbeatStatus?.EXT_DOOR_STATUS_0 + HeatbeatStatus?.EXT_DOOR_STATUS_1 + HeatbeatStatus?.EXT_DOOR_STATUS_null : '0'}</td>
														</tr>
														<tr>
															<td style={{ height: "35px" }}>RTC_ERR</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.RTC_ERR')`, `Heartbeat RTC_ERR Status Open`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.RTC_ERR')='0' OR JSON_VALUE(ALERT_DISABLE,'$.RTC_ERR')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.RTC_ERR_0}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.RTC_ERR')`, `Heartbeat RTC_ERR Status Close`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.RTC_ERR')='1'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.RTC_ERR_1}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.RTC_ERR')`, `Heartbeat RTC_ERR Status Not Available`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.RTC_ERR') IS NULL`,card_json[1]?.U_ID))}>{HeatbeatStatus?.RTC_ERR_null}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.RTC_ERR')`, `Heartbeat RTC_ERR Status ! (24 Hrs)`, `HEARTBEAT_TS<'${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.time_out}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.RTC_ERR')`, `Heartbeat RTC_ERR Status Not Available`, `JSON_VALUE(ALERT_DISABLE,'$.RTC_ERR')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.RTC_ERR_DISABLE}</td>
															<td style={{ height: "35px" }} className='text-center'>{HeatbeatStatus?.RTC_ERR_0 != undefined && HeatbeatStatus?.RTC_ERR_1 != undefined && HeatbeatStatus?.RTC_ERR_null != undefined ? HeatbeatStatus?.RTC_ERR_0 + HeatbeatStatus?.RTC_ERR_1 + HeatbeatStatus?.RTC_ERR_null : '0'}</td>
														</tr>
														<tr>
															<td style={{ height: "35px" }}>LADR</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LADR')`, `Heartbeat LADR Status Open`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LADR')='1' OR JSON_VALUE(ALERT_DISABLE,'$.LADR')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.LADR_1}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LADR')`, `Heartbeat LADR Status Close`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LADR')='0'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.LADR_0}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LADR')`, `Heartbeat LADR Status Not Available`, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LADR') IS NULL`,card_json[1]?.U_ID))}>{HeatbeatStatus?.LADR_null}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LADR')`, `Heartbeat LADR Status ! (24 Hrs)`, `HEARTBEAT_TS<'${moment().add(-24, 'hours').utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss")}'`,card_json[1]?.U_ID))}>{HeatbeatStatus?.time_out}</td>
															<td style={{ height: "35px", cursor: 'pointer' }} className='text-center text-info' onClick={() => (GetConsumerIncolumeName(false, `JSON_VALUE(HEARTBEAT_LAST_DATA,'$.LADR')`, `Heartbeat LADR Status Not Available`, `JSON_VALUE(ALERT_DISABLE,'$.LADR')=0`,card_json[1]?.U_ID))}>{HeatbeatStatus?.LADR_DISABLE}</td>
															<td style={{ height: "35px" }} className='text-center'>{HeatbeatStatus?.LADR_0 != undefined && HeatbeatStatus?.LADR_1 != undefined && HeatbeatStatus?.LADR_null != undefined ? HeatbeatStatus?.LADR_0 + HeatbeatStatus?.LADR_1 + HeatbeatStatus?.LADR_null : '0'}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
									</div>
								</div>
							</div>:''}
							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[2].U_ID]?.display==true||activeTab!='Custom Dashboard'? <div class="col-xs-12 col-md-6  ">
								<div class="card card-danger">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[2].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (INSTANTANEOUS_TS,DAILY_LOAD_TS,LOAD_SURVEY_TS)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[2].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD2.current,card_json[2].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-1">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[2].CARD_NAME)
																setcard_id(card_json[2].U_ID)
																setCardBar([{name:'Heartbeat Success',val:'Heartbeat_Success'},{name:'Heartbeat Fail',val:'Heartbeat_Fail'},{name:'DailyData Success',val:'DailyData_Success'},{name:'DailyData Fail',val:'DailyData_Fail'},{name:'Hourly Success',val:'Hourly_Success'},{name:'Hourly Fail',val:'Hourly_Fail'},{name:'Alert',val:'Alert'},{name:'Timesync',val:'Timesync'},{name:'Reboot',val:'Reboot'},{name:'Status Error',val:'Status_Error'}])
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[2].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body" >
											
											<div ref={IMGCARD2} style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "345px" }}>
										{Object.keys(letest24).length > 0 ? <ReactApexChart options={options1} type="bar" series={series1} width="100%" height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<p class="text-right" style={{ marginRight: "40px", lineHeight: "10px" }}>{chartType[card_json[2].U_ID]=='line'?'Line Char':'Bar chart'}</p>
								</div>
							</div> : ''}

							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[3].U_ID]?.display==true||activeTab!='Custom Dashboard'?<div class="col-xs-12 col-md-6 ">
								<div class="card card-success">
									<div class="card-header d-flex" >
										<h4><span className="mr-2">{card_json[3].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (CUSTOMER_STATUS)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[3].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
										<div className="btn btn-info mr-1" onClick={() => { onExpandButton('lora_instantaneous_day_wise_graph', 'CREATED_AT', 'Lorawan Consumer Status') }}>Expand</div>
										<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD3.current,card_json[3].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-2">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[3].CARD_NAME)
																setcard_id(card_json[3].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[3].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body ">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} ref={IMGCARD3}>
										{tableData.length > 0 && tableData.length > 0 ? <ReactApexChart options={option16} type="pie" series={tableData} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(tableData)} </p>
										<p>{'Pie chart(Dynamic)'} </p>
									</div>
								</div>
							</div>:''}
							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[4].U_ID]?.display==true||activeTab!='Custom Dashboard'? <><div class="col-xs-12 col-md-6 ">
								<div class="card card-success">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[4].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (METER_TYPE)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[4].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD4.current,card_json[4].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-2">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[4].CARD_NAME)
																setcard_id(card_json[4].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[4].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body ">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} >
										{seriesMeter.length > 0 && categoryMeter.length > 0 ? <ReactApexChart options={options3} type="pie" series={seriesMeter} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(seriesMeter)} </p>
										<p>{'Pie chart(Dynamic)'} </p>
									</div>
								</div>
							</div>
							<ChartClone labels={categoryMeter} type="pie" series={seriesMeter} ref={IMGCARD4}/>
							</> : ''}
							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[5].U_ID]?.display==true||activeTab!='Custom Dashboard'?
							<><div class="col-xs-12 col-md-6 ">
								<div class="card card-success">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[5].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (EVC_MC_METER_TYPE)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[5].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD5.current,card_json[5].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-2">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[5].CARD_NAME)
																setcard_id(card_json[5].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[5].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body ">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} >
										{seriesMechanicalMeter.length > 0 && categoryMechanicalMeter.length > 0 ? <ReactApexChart options={options17} type="pie" series={seriesMechanicalMeter} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(seriesMechanicalMeter)} </p>
										<p>{'Pie chart(Dynamic)'} </p>
									</div>
								</div>
							</div>
							<ChartClone labels={categoryMechanicalMeter} type="pie" series={seriesMechanicalMeter} ref={IMGCARD5}/>
							</>:''}
							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[6].U_ID]?.display==true||activeTab!='Custom Dashboard'? 
							<><div class="col-xs-12 col-md-6 ">
								<div class="card card-info">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[6].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (MODEM_TYPE)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[6].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD6.current,card_json[6].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-2">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[6].CARD_NAME)
																setcard_id(card_json[6].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[6].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div
										class="card-body">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }}  >
										{seriesModem.length > 0 && categoryModem.length > 0 ? <ReactApexChart options={options2} type="pie" series={seriesModem} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(seriesModem)} </p>
										<p>{'Pie chart(Dynamic)'} </p>
									</div>
								</div>

							</div>
								<ChartClone labels={seriesModem} type="pie" series={seriesMechanicalMeter} ref={IMGCARD6}/>
							
							</> : ''}

							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[7].U_ID]?.display==true||activeTab!='Custom Dashboard'?
							<> <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
								<div class="card card-info">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[7].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (HEARTBEAT_LAST_DATA->VERSTR)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[7].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD7.current,card_json[7].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-2">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[7].CARD_NAME)
																setcard_id(card_json[7].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[7].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} >
										{seriesFirmwar.length > 0 && categoryFirmwar.length > 0 ? <ReactApexChart options={options4} type="pie" series={seriesFirmwar} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(seriesFirmwar)}  </p>
										<p>{'Pie chart(Dynamic)'} </p>
									</div>
								</div>

							</div>
							<ChartClone labels={categoryFirmwar} type="pie" series={seriesFirmwar} ref={IMGCARD7} />

							</> : ''}
							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[8].U_ID]?.display==true||activeTab!='Custom Dashboard'?
							<><div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
								<div class="card card-info">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[8].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (HEARTBEAT_LAST_DATA->MMD_INFO_GSM_RSSI)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[8].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD8.current,card_json[8].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-1">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[8].CARD_NAME)
																setcard_id(card_json[8].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[8].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} ref={IMGCARD8}>
										{categoryBAT.length > 0 && serisBAT.length > 0 ? <ReactApexChart options={options14} type="pie" series={categoryBAT} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(categoryBAT)}  </p>
										<p>{'Pie chart(Static)'} </p>
									</div>
								</div>
							</div></>:''}
							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[9].U_ID]?.display==true||activeTab!='Custom Dashboard'? <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
								<div class="card card-info">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[9].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (HEARTBEAT_LAST_DATA->MMD_INFO_GSM_RSSI)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[9].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD9.current,card_json[9].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-1">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[9].CARD_NAME)
																setcard_id(card_json[9].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[9].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} ref={IMGCARD9}>
										{categoryRSSI.length > 0 && seriesRSSI.length > 0 ? <ReactApexChart options={options6} type="pie" series={categoryRSSI} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(categoryRSSI)}  </p>
										<p>{'Pie chart(Static)'} </p>
									</div>
								</div>
							</div> : ''}
							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[10].U_ID]?.display==true||activeTab!='Custom Dashboard'? <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
								<div class="card card-info">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[10].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (HEARTBEAT_LAST_DATA->LDR)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[10].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD10.current,card_json[10].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-1">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[10].CARD_NAME)
																setcard_id(card_json[10].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[10].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} ref={IMGCARD10}>
										{serviceProvid.series.length > 0 && serviceProvid.category.length > 0 ? <ReactApexChart options={options7} type="pie" series={serviceProvid.series} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(serviceProvid.series)}  </p>
										<p>{'Pie chart(Dynamic)'} </p>
									</div>
								</div>
							</div> : ''}
							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[11].U_ID]?.display==true||activeTab!='Custom Dashboard'? <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
								<div class="card card-danger">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[11].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (TAGS)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[11].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD11.current,card_json[11].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-1">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[11].CARD_NAME)
																setcard_id(card_json[11].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[11].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} ref={IMGCARD11}>
										<ReactApexChart options={options8} type="pie" series={tagsCount.series} height={"350"} />
										</div>

										{/* : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>} */}
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(tagsCount.series)}  </p>
										<p>{'Pie chart(Dynamic)'} </p>
									</div>
								</div>
							</div> : ''}
							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[12].U_ID]?.display==true||activeTab!='Custom Dashboard'?<div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
								<div class="card card-info">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[12].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (HEARTBEAT_LAST_DATA->MMD_INFO_GSM_RSSI)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[12].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD12.current,card_json[12].CARD_NAME,type)}}/>
										<div class="dropdown d-inline">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[12].CARD_NAME)
																setcard_id(card_json[12].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[12].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} ref={IMGCARD12}>
										{categorySNR.length > 0 && seriesSNR.length > 0 ? <ReactApexChart options={options15} type="pie" series={categorySNR} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(categorySNR)}  </p>
										<p>{'Pie chart(Static)'} </p>
									</div>
								</div>
							</div>:''}

							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[13].U_ID]?.display==true||activeTab!='Custom Dashboard'? <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
								<div class="card card-info">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[13].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (HEARTBEAT_LAST_DATA->MMD_INFO_GSM_BAND)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[13].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD13.current,card_json[13].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-1">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[13].CARD_NAME)
																setcard_id(card_json[13].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[13].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} ref={IMGCARD13}>
										{GSM_BAND.series.length > 0 && GSM_BAND.categories.length > 0 ? <ReactApexChart options={options11} type="pie" series={GSM_BAND.series} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(GSM_BAND.series)}  </p>
										<p>{'Pie chart(Dynamic)'} </p>
									</div>
								</div>
							</div> : ''}
							{/* {permision?.ROLES_OTHER_PERMISSIONS?.GSM_GROUP_DASH?.MODEM?.view?.filter((item)=>(item=='GSM_IPV')).length>0||userInfo?.ROLE=='ROLE1650614500708'?<div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
									<div class="card card-info">
										<div class="card-header ">
											<h4><span className="mr-2">GSM IPV</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (HEARTBEAT_LAST_DATA->IPV4V6)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										</div>
										<div
											class="card-body"
											style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }}>
											{IPV.IPV.length > 0 && IPV.categories.length > 0 ? <ReactApexChart options={options12} type="pie" series={IPV.IPV} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
										<div className="tw-flex tw-justify-between tw-px-3">
											<p>Total Count : {sum(IPV.IPV)}  </p>
											<p>{'Pie chart(Dynamic)'} </p>
										</div>
									</div>
								</div>:''} */}
							{/* <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
									<div class="card card-info">
										<div class="card-header">
											<h4><span className="mr-2">GSM APN</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (HEARTBEAT_LAST_DATA->APN)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										</div>
										<div
											class="card-body"
											style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }}>
											{APM.series.length > 0 && APM.category.length > 0 ? <ReactApexChart options={options13} type="pie" series={APM.series} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
										<div className="tw-flex tw-justify-between tw-px-3">
											<p>Total Count : {sum(APM.series)}  </p>
											<p>{'Pie chart(Dynamic)'} </p>
										</div>
									</div>
								</div> */}

						{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[14].U_ID]?.display==true||activeTab!='Custom Dashboard'?<div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
								<div class="card card-info">
									<div class="card-header">
										<h4><span className="mr-2">{card_json[14].CARD_NAME}</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (UNLOCK_CONFIG->UNLOCK_STATUS)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[14].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
													<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD14.current,card_json[14].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-1">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[14].CARD_NAME)
																setcard_id(card_json[14].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[14].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
													</div>
									</div>
									<div class="card-body">
											
											<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} ref={IMGCARD14}>
										{UnlockBrand.categories.length > 0 ? <ReactApexChart options={options16} type="pie" series={UnlockBrand.series} height={"350"} /> : <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p>Total Count : {sum(UnlockBrand.series)}  </p>
										<p>{'Pie chart(Dynamic)'} </p>
									</div>
								</div>
							</div>:''}

							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[15].U_ID]?.display==true||activeTab!='Custom Dashboard'? <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
								<div class="card card-danger" >
									<div class="card-header">
										<h4><span className="mr-2">{card_json[15].CARD_NAME} (7 Days Count : {installData.length > 0 ? sum(installData.map((item) => (item.total))) : 0})</span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (INSTALLATION_DETAILS->Installation_Date_And_Time)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
										<div class="card-header-action d-flex">
										<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[15].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
										<select class='mr-2' onChange={(e)=>{setchartType({...chartType,[card_json[15].U_ID]:e.target.value})}}><option value='bar'>Bar Chart</option><option value='line'>Line Chart</option></select>
											<select class="mr-2" name="circle_id" onChange={(e) => {
												onGetInstallationDateWiseGraphData({ CATEGORY0: Profile.account, CATEGORY1: Profile.ga, CATEGORY2: Profile.circle, CATEGORY3: Profile.division, CATEGORY4: Profile.subdivision, CATEGORY5: Profile.area, ROLES: userInfo?.ROLE, serach: true,ins_no:Profile.ins_no, Profile: { CATEGORY0: permision.ROLES_PERMISSIONS_CATEGORY0.CATEGORY0_view, CATEGORY1: permision.ROLES_PERMISSIONS_CATEGORY1.CATEGORY1_view, CATEGORY2: permision.ROLES_PERMISSIONS_CATEGORY2.CATEGORY2_view, CATEGORY3: permision.ROLES_PERMISSIONS_CATEGORY3.CATEGORY3_view, CATEGORY4: permision.ROLES_PERMISSIONS_CATEGORY4.CATEGORY4_view, CATEGORY5: permision.ROLES_PERMISSIONS_CATEGORY5.CATEGORY5_view } }, e.target.value)
												setInstallType(e.target.value)

											}} value={InstallType}>
												<option value='Days'>Days</option>
												<option value='Weeks'>Weeks</option>
												<option value='Years'>Years</option>
											</select>
											<a class="btn btn-info text-white" data-toggle="tooltip" data-placement="Top" title="Expand" style={{ lineHeight: '21px', margin: '0' }} onClick={() => { onExpandButton('', '', 'Installation Date Wise Chart') }}>Expand</a>
											<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD15.current,card_json[15].CARD_NAME,type)}}/>
										<div class="dropdown d-inline ml-1">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[15].CARD_NAME)
																setcard_id(card_json[15].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[15].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
												
										</div>
									</div>
									<div class="card-body" >
									
									<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} ref={IMGCARD15}>
										{installLoad ? <div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div> :chartType[card_json[15].U_ID]=='line'?<Line options={InstallOptionChartJS} data={InstallChartJs}/>: <Bar ref={InstallChartRef} onClick={onClickInstall} height={100} options={InstallOptionChartJS} data={InstallChartJs} />}
										</div>
									</div>
									<div className="tw-flex tw-justify-between tw-px-3">
										<p></p>
										<p>{'Bar chart(Dynamic)'} </p>
									</div>
								</div>
							</div> : ''}

							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[28].U_ID]?.display==true||activeTab!='Custom Dashboard' ? <div class="col-xs-12 col-md-6 col-lg-6 col-xl-6 ">
									<div class="card card-danger" >
										<div class="card-header">
											<h4><span className="mr-2">{card_json[28].CARD_NAME} </span><BootstrapTooltip title='Find Data In gsm_consumer_device_index (INSTALLATION_DETAILS->Installation_Date_And_Time)' placement='top'><span><i className='fas fa-info-circle info_circle'></i></span></BootstrapTooltip></h4>
											<div class="card-header-action d-flex">
											<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[28].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
												<a class="btn btn-info text-white" data-toggle="tooltip" data-placement="Top" title="Expand" style={{ lineHeight: '21px', margin: '0' }} onClick={() => { onExpandButton('', '', 'Installation Date Wise Chart') }}>Expand</a>
												<DownloadGraphImageComponet onClickDownloadImg={(type)=>{onClickDownloadImg(IMGCARD28.current,card_json[28].CARD_NAME,type)}}/>
												<div class="dropdown d-inline ml-1">
															<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
																<i className="fas fa-ellipsis-v"/>
															</button>
												<div class="dropdown-menu dropleft" x-placement="left-start" style={{position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform"}}>
															{activeTab=='Custom Dashboard'?'':permision?.ROLES_OTHER_PERMISSIONS?.CUSTOM_DASHBOARD?.card_add_in_dashboard==true||userInfo?.ROLE == 'ROLE1650614500708'?<a class="dropdown-item has-icon" onClick={()=>{setisDashModal(true)
														setModal_card_name(card_json[28].CARD_NAME)
													setcard_id(card_json[28].U_ID)}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a>:""}
																{activeTab=='Custom Dashboard'?<a class="dropdown-item has-icon" onClick={()=>UpdateCustomDasboardInCardDelete(card_json[28].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a>:''}
															</div>
															</div>
											</div>
										</div>
										<div class="card-body" >
										
										<div style={{ position: "relative", paddingLeft: "0px", paddingRight: "0px", height: "395px" }} ref={IMGCARD28}>
										{isUndermaintanceLoader?<div className="d-flex" style={{ justifyContent: 'center' }}><img class="loader_center text-center" src={loaderGif} /></div>:chartType[card_json[28].U_ID]=='line'?<Line options={UndermainOptionChartJS} data={UnderMaintanceChartJs}/>:<Bar ref={UndermainRef} onClick={onClickUndermaintance} height={100} options={UndermainOptionChartJS} data={UnderMaintanceChartJs} />}
										</div>
										</div>
										<div className="tw-flex tw-justify-between tw-px-3">
											<p></p>
											<p>{'Bar chart(Dynamic)'} </p>
										</div>
									</div>
								</div> : ''}

							{JSON.parse(DashTabDetailById?.view_json||'{}')[card_json[16].U_ID]?.display==true||activeTab!='Custom Dashboard'?<div class="col-12">
								<div class="card h-100 card-danger">
									<div class="row">
										<div class="card-header d-flex" style={{ justifyContent: 'space-between' }}>
											<h4>{card_json[16].CARD_NAME}</h4>
											<div className="d-flex">
											<Popover trigger="click" placement="bottom" overlayStyle={{width:'300px'}}  content={<>
														<TreeSelect
																style={{ width: '100%' }}
																dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
																treeData={TreeSelection}
																placeholder="All Account"
																treeDefaultExpandAll
																allowClear
																onChange={(info)=>onChangesCardWiseFilter(info,card_json[16].U_ID)}
														/>
													</>}>
													<span>
													<button class="btn btn-primary mr-2"> <i className="fas fa-filter"></i> </button>
													</span>
													</Popover>
												<a onClick={() => (inputSeen ? window.open(`/lorawan-map-view?last_seen=${inputSeen}`, '_blank') : {})} class="btn btn-info text-white">View More</a>
										<div class="dropdown d-inline">
														<button class="btn btn-primary " type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
															<i className="fas fa-ellipsis-v" />
														</button>
														<div class="dropdown-menu dropleft mr-2" x-placement="left-start" style={{ position: "absolute", transform: 'translate3d(0px, 28px, 0px)', willChange: "transform" }}>
															{activeTab == 'Custom Dashboard' ? '' : permision?.ROLES_OTHER_PERMISSIONS?.LORA_CUSTOM_DASHBOARD?.card_add_in_dashboard == true || userInfo?.ROLE == 'ROLE1650614500708' ? <a class="dropdown-item has-icon" onClick={() => {
																setisDashModal(true)
																setModal_card_name(card_json[16].CARD_NAME)
																setcard_id(card_json[16].U_ID)
															}}><i className="fas fa-plus " style={{ fontSize: "16px", paddingLeft: "5px", paddingRight: "5px" }}></i>Add Card</a> : ""}
															{activeTab == 'Custom Dashboard' ? <a class="dropdown-item has-icon" onClick={() => UpdateCustomDasboardInCardDelete(card_json[16].U_ID)}><i class="fa fa-trash "></i><span className='ml-2'>Remove Card</span></a> : ''}
														</div>
													</div>
											</div>
										</div>
										<div class="card-body" style={{ height: '500px', width: "100%" }}>
											<div class="map-inner" style={{ height: '500px', width: "100%" }}>
												{/*dev- AIzaSyD07E1VvpsN_0FvsmKAj4nK9GnLq-9jtj8 */}
												{/*server- AIzaSyAo0xl_P_6Ga-ee6ggeYe1JAE2jq3PxU5s */}
												<ArticlesMap
													googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAo0xl_P_6Ga-ee6ggeYe1JAE2jq3PxU5s&v=3.exp&libraries=geometry,drawing,places"
													loadingElement={<div style={{ height: '100%', width: '100%' }} />}
													containerElement={<div style={{ height: '100%', width: '100%' }} />}
													mapElement={<div style={{ height: '100%', width: '100%' }} />}
													onClick={(ev) => { console.log(ev) }}
													mapInfo={mapInfo}
													curentpos={{ lat: 21.727293496271507, lng: 75.5823933220894 }}
												/>
												{/* <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d2965.0824050173574!2d-93.63905729999999!3d41.998507000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sWebFilings%2C+University+Boulevard%2C+Ames%2C+IA!5e0!3m2!1sen!2sus!4v1390839289319" width="100%" height="300" frameborder="0"></iframe> */}
											</div>
										</div>
									</div>
								</div>
							</div>:''}

						</div>
					</>)}
					{(activeTab === 'EVC/MC Meter Dashboard' || activeTab == 'Custom Dashboard') && (<>
						<Lora_meter_dashboard AllCategory={AllCategory} activeTab={activeTab} DashTabDetailById={DashTabDetailById} settringerMeter={settringerMeter} tringerMeter={tringerMeter} Profile={Profile} setProfile={(info) => setProfile(info)} {...props}/>
					</>)}
				</div>
			</section>

		</>
	);
}

export const ArticlesMap = withScriptjs(withGoogleMap((props) => {
	const [jobDetail, setJobDetail] = useState({ activeMarker: {}, isOpen: false, Info: {} })
	const onMarkerClicked = (data, marker) => {
		console.log(data, marker);
		setJobDetail({
			activeMarker: { lat: data?.latLng?.lat(), lng: data?.latLng?.lng() },
			isOpen: true,
			Info: marker
		})
	}

	const onToggleOpen = () => {
		setJobDetail({ ...jobDetail, isOpen: false })
	}
	function getSecondsTodayBydate(ts) {
		var now = moment().add(-moment().utcOffset(), "m").format("DD/MM/YYYY HH:mm:ss");
		var then = moment.utc(ts).add(-moment().utcOffset(), "m").format("DD/MM/YYYY HH:mm:ss");
		return moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(then, "DD/MM/YYYY HH:mm:ss"), 'second')
	}
	return (<>
		<GoogleMap
			defaultZoom={5}
			defaultCenter={{ lat: props.curentpos.lat, lng: props.curentpos.lng }}
			onClick={(e) => { console.log("e.latLng.lat()", e.latLng.lat(), "e.latLng.lng()", e.latLng.lng()) }}
		>
			{props?.mapInfo?.map((item, id) => (<><Marker
				defaultZoomOnClick={4}
				icon={{
					url: (getSecondsTodayBydate(item.HEARTBEAT_TS) < 86400) ? mapicon : mapRedicon,
					scaledSize: new window.google.maps.Size(20, 20),

				}}
				defaultOptions={{ optimized: false }}
				onMouseOver={(data) => onMarkerClicked(data, item)}
				key={id}
				position={{ lat: parseFloat(item?.LATITUDE), lng: parseFloat(item?.LONGITUDE) }}
			/></>))}
		</GoogleMap>
		{jobDetail?.activeMarker?.lat && jobDetail.isOpen &&
			<InfoWindow position={{ lat: jobDetail?.activeMarker?.lat, lng: jobDetail?.activeMarker?.lng }} onCloseClick={onToggleOpen} options={{
				pixelOffset: new window.google.maps.Size(
					0, -15
				)
			}}>
				<div className="detailCard">
					<div className="d-flex main-div">
						<div className="d-inline-block">
							<div className="text-black name">{jobDetail?.Info?.address_compony_name}
							</div>
						</div>
					</div>
				</div>
			</InfoWindow>}
	</>
	);
}
))

